var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTinCan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 20v1h-4v-1h1zm-30 83v-1h1v4h-1zm40-82h-1v1h-1v-2h2zm-26 83h1v3h-1zm7-83v-1h2v1h-1zm14 0h-1v-1h2v1zM37 65h-1v-2h1v1zm-2 23v-1h1v2h-1zm1 6v2h-1v-2zm18 1h1v1h-2v-1zm26 1v-1h1v2h-1zM44 19h1v1h-1zm23 2v-1h1v1zm-34 1v-1h1v1zm14-1v1h-1v-1zm33 15h-1v-1h1zm-44 1h-1v-1h1zm0 1v1h-1v-1zm14 23h1v1h-1zm35 4h1v1h-1zm-48 1v1h-1v-1zm10 1v-1h1v1zm-12 1h1v1h-1zm14 0v1h-1v-1zm32 0v1h-1v-1zm-33 1v1h-1v-1zm5 1v-1h1v1zm31 2v-1h1v1zm-48 0v1h-1v-1zm19 0v1h-1v-1zm27 1v1h-1v-1zm3 1v1h-1v-1zm-49 6h-1v-1h1zm18-1h1v1h-1zm-18 2v1h-1v-1zm-1 3v-1h1v1zm51 1v-1h1v1zm-36 2v1h-1v-1zm6 2v-1h1v1zm-20 1v1h-1v-1zm14 2h-1v-1h1zm-15 1v-1h1v1zm14 0h-1v-1h1zm2 2v1h-1v-1zm-1 2h1v1h-1zm31 1v-1h1v1zm-31 11h-1v-1h1zm-15 2v-1h1v1zm15 1h-1v-1h1zm-1 2v-1h1v1zm3 1h1v1h-1z",
    fill: "#d9d8d4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 98h1v6h-1zm-15-2h1v4h-1v-1zm14 13h1v1h1v2h-1v-1h-1zm10-89h3v1h-3zm9 0h2v1h-2zM48 36v-1h1v2h-1zm-2 49h1v1h-2v-1zm5 10h2v1h-2zm6 0v1h-2v-1h1zm-6 14h-1v-2h1v1zm3 7h-1v-1h2v1zM47 11v1h-1v-1zm2 7h1v1h-1zm3 2v-1h1v1zm-14 1h-1v-1h1zm43 0v-1h1v1zm-41 1v-1h1v1zm34 2v-1h1v1zm-25 9v1h-1v-1zm-13 9v1h-1v-1zm0 5h-1v-1h1zm11 16v1h-1v-1zm1 2h1v1h-1zm0 2v1h-1v-1zm3 2h1v1h-1zm3 0h1v1h-1zm28 0v1h-1v-1zm-47 1v1h-1v-1zm11 0h1v1h-1zm40 2v1h-1v-1zm-51 1v1h-1v-1zm0 3v1h-1v-1zm0 3v-1h1v1zm1 3v1h-1v-1zm17 1v-1h1v1zm-2 5v1h-1v-1zm7 1h-1v-1h1zm21 1v-1h1v1zm-30 1v-1h1v1zm-13 1h-1v-1h1zm13-1v1h-1v-1zm2 5v1h-1v-1zm-16 12h1v1h-1zm15 4v1h-1v-1zm-10 2v1h-1v-1z",
    fill: "#d8d7d3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 21v-1h3v1zm14-2h1v1h-2v-1zm10 0v1h-2v-1h1zm6 1v-1h2v1h-1zM34 78v-1h1v2h-1zm14 14h-2v-1h2zm7 23h2v1h-2zm-10 1h2v1h-2zm0-99h1v1h-1zm7 2v-1h1v1zm14-1v1h-1v-1zm-21 2v-1h1v1zm3 0h-1v-1h1zm27 0h-1v-1h1zm2 0h-1v-1h1zm3-1h1v1h-1zm-45 2h-1v-1h1zm44-1v1h-1v-1zm4 0h1v1h-1zm-44 2v-1h1v1zm6 1h-1v-1h1zm5 13v1h-1v-1zm29 0h1v1h-1zm-45 6h1v1h-1zm14 3v-1h1v1zm6 3h1v1h-1zm-18 8v1h-1v-1zm12 5h-1v-1h1zm4 1h-1v-1h1zm-17 4h1v1h-1zm51 2v1h-1v-1zm-51 2h-1v-1h1zm13 1h1v1h-1zm33 5h1v1h-1zm-30 8h1v1h-1zm0 2h-1v-1h1zm-3 0v1h-1v-1zm31 6h1v1h-1zm-20 3h1v1h-1zm23 5h-1v-1h1zm-30 4h-1v-1h1zm-17 3h-1v-1h1zm17 5h-1v-1h1zm-14 2h-1v-1h1zm13 0h-1v-1h1z",
    fill: "#d5d4d0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 27v2h-1v4h-2v2h-2v-1h-1v-1h-1v-1h-1v-5h1v-1h4v1h2zm-3 1v-1h-1v1zm0 30h-1v-1h1zm0 16v1h-1v-1z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61 109h3v2h-3zm17-13h1v4h-1v-1zm-20 10h-1v-2h1v-1h1v2h-1zm0-7v1h-1v1h-1v-2zm17-8h1v1h-2v-1zm-2 4h1v1h-2v-1zm-15 13v-2h1v2zm9 8h-1v-1h2v1zm-9-98v-1h1v1zm12 0v-1h1v1zm-30 1v1h-1v-1zm-6 4v-1h1v1zm44 9h1v1h-1zM50 44h1v1h-1zm8 1h1v1h-1zm31 5v-1h1v1zM58 63h-1v-1h1zm19 9v1h-1v-1zm5 0v1h-1v-1zm-3 7h-1v-1h1zm-2 5v1h-1v-1zm2 0v1h-1v-1zm-5 4h1v1h-1zm-25 1h1v1h-1zm29 2h1v1h-1zm0 3v-1h1v1zm-1 2v-1h1v1zm-8 1h-1v-1h1zm-14 2v-1h1v1zm25 6v1h-1v-1zm-21 4h1v1h-1zm6 4h-1v-1h1zm3 0v1h-1v-1zm-13 4h-1v-1h1z",
    fill: "#c8c7c3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65 116v-3h2v1h1v1h-2v1zm-9-8v-1h1v-1h1v2h-1v2h-1v-1zm23-86v-2h1v2zm-2 73v-1h2v1h-1zm-18 6v2h-1v-2zm-1 8v-1h1v2h-1zm5 3h-1v-1h2v1zm-7-94v-1h1v1zm8-1h1v1h-1zm28 4v-1h1v1zm-11 2h-1v-1h1zm-36 0v1h-1v-1zm34 5v1h-1v-1zm0 3v1h-1v-1zm-45 4h1v1h-1zm17 1v1h-1v-1zm-17 5v1h-1v-1zm49 15h-1v-1h1zm-2 1h-1v-1h1zm-46 4h-1v-1h1zm45-1v1h-1v-1zm-47 8v-1h1v1zm15-1h1v1h-1zm31 8v-1h1v1zm-1 0v1h-1v-1zm1 10h1v1h-1zm-2 7h-1v-1h1zm2 0v-1h1v1zm-8 4v-1h1v1zm-16 4v-1h1v1zm3 1h-1v-1h1zm-1 1h-1v-1h1zm1 1v1h-1v-1zm22 2h-1v-1h1zm-42 7v1h-1v-1zm23 1h-1v-1h1z",
    fill: "#c9c8c4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49 116v-1h1v-1h1v1h1v1h-1zm5-95v-1h3v1zm20 0h-2v-1h2zm8 2v-1h2v1h-1zM36 75h-1v-2h1v1zm-1 1h1v2h-1v-1zm16 19h-2v-1h2zm-2 11h1v2h-1v-1zm18-86v1h-1v-1zm11 1h-1v-1h1zm-36 0h1v1h-1zm23 0h1v1h-1zm16 0h1v1h-1zm4 1v-1h1v1zM49 35h-1v-1h1zm30-1h1v1h-1zm-44 3h1v1h-1zm15 1v1h-1v-1zm-13 6h-1v-1h1zm11 20v1h-1v-1zm33 1h1v1h-1zm3 0v1h-1v-1zm2 1v-1h1v1zm-38 3h-1v-1h1zm-12 0v1h-1v-1zm12 0h1v1h-1zm5 0v1h-1v-1zm-1 6h1v1h-1zm2 7h1v1h-1zm-2 4v-1h1v1zm34-1h1v1h-1zm-51 1h1v1h-1zm12 2v1h-1v-1zm4 0h1v1h-1zm5 1h-1v-1h1zm-20 0v1h-1v-1zm-1 4h1v1h-1zm14 4h1v1h-1zm0 16v1h-1v-1z",
    fill: "#dad9d5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h-2v-1h-1v-1h2v1h1zm-24-2v-1h3v1h-1zm-28 84v3h-1v-3zm21-84h-2v-1h2zm16 0h-1v-1h2v1zm-28 1h-2v-1h2zm39 75h-1v-2h1v1zm-49 5v-1h1v2h-1zm58-87v-1h1v1zm-45 5v-1h1v1zm38-1h1v1h-1zm-1 3v1h-1v-1zm-41 3h-1v-1h1zm32-1v1h-1v-1zm-40 2v1h-1v-1zm13 13v-1h1v1zm-1 5v-1h1v1zm-14 2h1v1h-1zm-1 4v-1h1v1zm19 2h1v1h-1zm-6 9h1v1h-1zm40 2h-1v-1h1zm-50 0h1v1h-1zm45 1v-1h1v1zm3 2h1v1h-1zm-34 4h1v1h-1zm-15 3h-1v-1h1zm51 4h-1v-1h1zm-35 6v-1h1v1zm-4 1h-1v-1h1zm1 3h-1v-1h1zm1 3v-1h1v1zm6 2v1h-1v-1zm2 4h1v1h-1zm23 3v-1h1v1zm-30 12v-1h1v1zm-12 3h1v1h-1z",
    fill: "#d7d6d2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h-1v-7h1v1zm5-83v-1h5v1h-1zM35 63v-1h1v4h-1zm15-44v-1h2v1h-1zM34 74h1v2h-1v-1zm2 28v2h-1v-2zm31-83h1v1h-1zm11 1h-1v-1h1zm10 1h-1v-1h1zm-50 0v1h-1v-1zm6 0h1v1h-1zm45 1h-1v-1h1zm-10 1h-1v-1h1zM52 45v1h-1v-1zm3 13v1h-1v-1zm26 3v1h-1v-1zm-46 7v-1h1v1zm15 2h-1v-1h1zm-15 3h-1v-1h1zm13 12h1v1h-1zm3 1v-1h1v1zm-4 2h1v1h-1zm3 6h-1v-1h1zm1 1v-1h1v1zm7 0h1v1h-1zm25 1h1v1h-1zm-2 2h1v1h-1zm-46 8h-1v-1h1zm0 2v-1h1v1zm4 4v1h-1v-1zm12 0v1h-1v-1zm-13 3v-1h1v1zm13-1h1v1h-1z",
    fill: "#d6d5d1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65 110h-1v-1h-1v-1h1v-1h1v2zm-6-8h1v3h-1zm2 6v3h-1v-3zm21-35v-1h2v1h-1zM56 99v-1h2v1h-1zm21-1h1v2h-1v-1zm-16 6h2v1h-2zm-2 2h1v2h-1v-1zm3 1h1v1h-2v-1zM47 19v-1h1v1zm-12 0v1h-1v-1zm46 7v1h-1v-1zm-31 8v-1h1v1zM36 44h-1v-1h1zm41 7h1v1h-1zm-42 8v1h-1v-1zm45 0h1v1h-1zm0 6h-1v-1h1zm-31 2v-1h1v1zm-1 17v-1h1v1zm31 1v-1h1v1zm-1 1h-1v-1h1zm-2 2h1v1h-1zm2 2v1h-1v-1zm-5 1h1v1h-1zm-3 1h1v1h-1zm8 0h1v1h-1zm-2 3h1v1h-1zm3 6v1h-1v-1zm-13 10h1v1h-1zm2 5v-1h1v1zm-14 0v1h-1v-1z",
    fill: "#c6c5c1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v1h-3v-1zm19 82v-3h1v3zM54 18h2v1h-2zm-1 34h2v1h-2zm0 44h1v1h-2v-1zm-1 3v-1h1v2h-1zm21-80h-1v-1h1zm13 0h1v1h-1zm3 1h-1v-1h1zm3 1h-1v-1h1zm-47 1v-1h1v1zm4-1v1h-1v-1zm18 2h-1v-1h1zm-32 4v-1h1v1zm15 12v-1h1v1zm30 0h-1v-1h1zm-29 2v1h-1v-1zm-2 1h1v1h-1zm-15 3v1h-1v-1zm12 14h1v1h-1zm5 3h1v1h-1zm30 2v1h-1v-1zm-31 4v1h-1v-1zm-17 3v-1h1v1zm15 3h-1v-1h1zm31 7v-1h1v1zm-29 7v-1h1v1zm9 0v1h-1v-1zm-3 3v1h-1v-1zm-6 1v1h-1v-1zm6 0h1v1h-1zm8 4h-1v-1h1zm19 2v-1h1v1zm-49 8h-1v-1h1zm18 5h1v1h-1zm3 4h-1v-1h1z",
    fill: "#d2d1cd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59 18v-1h5v1h-1zm-3 84h1v-1h1v2h-1v1h-1zm6 11v-1h2v1h1v1h-2v-1zm16-24v-1h-1v-1h2v2zm11-70h2v1h-2zM64 96h2v1h-2zm-8 5v1h-1v-2h1zm2 8v1h-1v-2h1zm-5-92h1v1h-1zm5 0v1h-1v-1zm-6 24h-1v-1h1zm28-1v1h-1v-1zM48 60h1v1h-1zm32 8v1h-1v-1zm-30 4h-1v-1h1zm25 4v-1h1v1zm2 5v1h-1v-1zm0 4v-1h1v1zm2 6h-1v-1h1zm-1 1h-1v-1h1zm-24 1h-1v-1h1zm24 3v-1h1v1zm2 7v1h-1v-1zm-15 13v1h-1v-1z",
    fill: "#cac9c5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54 91v1h-3v-1zm33-72v-1h1v2h-1zm-28 3v-1h2v1h-1zm-9 82v1h-1v-2h1zm42-90h1v1h-1zm-53 5v1h-1v-1zm11 1v-1h1v1zm-9 1h1v1h-1zm2 1v-1h1v1zm19 0v-1h1v1zm5-1v1h-1v-1zm14 0v1h-1v-1zM49 40h1v1h-1zm-13 3v-1h1v1zm0 13h1v1h-1zm44 1h1v1h-1zm-27 1h1v1h-1zm32 3v1h-1v-1zm-4 6v-1h1v1zm4 2h-1v-1h1zm-2 0h1v1h-1zm-48 2v-1h1v1zm13 0v1h-1v-1zm-12 1h1v1h-1zm16 1h-1v-1h1zm-16 3v-1h1v1zm1 8v-1h1v1zm11 5v1h-1v-1zm-12 4v-1h1v1zm13 0v1h-1v-1zm-13 3h1v1h-1zm13 12v1h-1v-1zm0 6h1v1h-1z",
    fill: "#dcdbd7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50 98v5h-1v-5zm3-77v-1h1v2h-1zm-6 45v2h-1v-2zm6 6h1v1h-2v-1zm-4 39h-1v-2h1v1zm-5-92v1h-1v-1zm7 1v-1h1v1zm26 1h-1v-1h1zm-15 1h-1v-1h1zm3 0h-1v-1h1zM36 39v1h-1v-1zm14 0v1h-1v-1zm-1 2h1v1h-1zm0 21v-1h1v1zm-1 2h-1v-1h1zm-12 3h1v1h-1zm10 3v-1h1v1zm37 0h-1v-1h1zm-48 1h1v1h-1zm0 10v-1h1v1zm49 3h-1v-1h1zm-34 0h1v1h-1zm36 4v-1h1v1zm-41 0h1v1h-1zm-8 3v1h-1v-1zm14 1h-1v-1h1zm-1 3v1h-1v-1zm31 1h1v1h-1zm-32 10v-1h1v1zm0 6v1h-1v-1z",
    fill: "#dbdad6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90 22h-1v-1h-1v-1h2zm-28 1v-1h3v1zm-28 79h1v3h-1v-1zm46-6v1h-1v-2h1zm-28 16v2h-1v-2zm-5-93v1h-1v-1zm2 1h1v1h-1zM35 35h1v1h-1zm14 0h1v1h-1zm1 6v-1h1v1zm4 4h1v1h-1zm-6 17h1v1h-1zm2 3v1h-1v-1zm31 2v1h-1v-1zm7 3v1h-1v-1zm0 4h-1v-1h1zm-55 2h1v1h-1zm21 4h-1v-1h1zm-6 3h-1v-1h1zm4 0v-1h1v1zm-2 2v1h-1v-1zm29 1h1v1h-1zm1 3v-1h1v1zm1 2v1h-1v-1zm-1 8v-1h1v1zm0 2v-1h1v1zm-28 14v-1h1v1zm-7 1h-1v-1h1zm4 0h-1v-1h1z",
    fill: "#d4d3cf"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65 105v1h-2v1h-1v-2zm4 10h-1v-3h1zM51 93v-1h2v1h-1zm11 11h-1v-1h2v1zm3 7v-1h1v2h-1zM50 18h-1v-1h1zm2 3v1h-1v-1zm-17 6h-1v-1h1zm16 3h-1v-1h1zm-1 5h1v1h-1zm28 27v-1h1v1zm-28 3h-1v-1h1zm-16 1v1h-1v-1zm46 2h-1v-1h1zm-31 3h-1v-1h1zm6 5h-1v-1h1zm24 0h-1v-1h1zm-27 0h1v1h-1zm27 12v-1h1v1zm-3 0v1h-1v-1zm1 1v-1h1v1zm-7 8v-1h1v1zm-13 0v1h-1v-1zm20 3h1v1h-1zm-18 1h1v1h-1zm0 5v-1h1v1zm5 1v1h-1v-1zm3 3v-1h1v1z",
    fill: "#c5c4c0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68 113h-3v-1h2v-1h1zM56 17v1h-2v-1h1zm1 55v2h-1v-2zm22 15h-1v-2h1v1zm-2 10v-1h1v2h-1zm-15 12h-1v-1h2v1zm2 1h1v2h-1v-1zm5-87h-1v-1h1zm10 10v1h-1v-1zM57 48v1h-1v-1zm-8 9h1v1h-1zm31 8v1h-1v-1zm5 6h1v1h-1zm1 4h-1v-1h1zm-37 2v-1h1v1zm26 1h1v1h-1zm10 6h-1v-1h1zm4 0v1h-1v-1zM53 95v-1h1v1zm23 0v-1h1v1zm-21 2h1v1h-1zm4 4h-1v-1h1zm20 0h-1v-1h1zm5 0v1h-1v-1zm-25 4v1h-1v-1zm21 1h1v1h-1zm-21 3v-1h1v1z",
    fill: "#c7c6c2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v2h-1v-2zm7 22v1h-2v-1h1zm-9 7h2v1h-2zm4 13v1h-2v-1h1zm-1-55v-1h1v1zm3 1h-1v-1h1zm-14 1v-1h1v1zm32-1h1v1h-1zM36 33h1v1h-1zm12 4h-1v-1h1zm0 1v-1h1v1zm1 8h-1v-1h1zm-14 3h1v1h-1zm14 9h1v1h-1zm2 1v-1h1v1zm-5 1h-1v-1h1zm3 2h-1v-1h1zm34 0v-1h1v1zm-46 3v-1h1v1zm45 0h1v1h-1zm5 2v1h-1v-1zm-3 3v-1h1v1zm-40 4v-1h1v1zm40 3v1h-1v-1zm-34 8h-1v-1h1zm-12 0v1h-1v-1zm16 0h1v1h-1zm-8 2v-1h1v1zm7 2v-1h1v1zm-16 0v1h-1v-1zm46 1h-1v-1h1zm-35 24h1v1h-1z",
    fill: "#dfdeda"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77 99h-1v-3h1v1zm-7 15h-1v-3h1zm9-32h1v1h-2v-1zm-18 19h1v1h-2v-1zM35 20h1v1h-1zm14 0v1h-1v-1zm36 2h1v1h-1zm-50 3v1h-1v-1zm43 10v-1h1v1zM48 46h1v1h-1zm28 2h1v1h-1zm-2 10h1v1h-1zm2 1v-1h1v1zm4-1h1v1h-1zm-26 3v1h-1v-1zm-20 5h-1v-1h1zm20-1v1h-1v-1zm26 1v1h-1v-1zm-1 3h-1v-1h1zm0 3v1h-1v-1zm1 6v1h-1v-1zm-4 9h1v1h-1zm-5 5h1v1h-1zm7 1h-1v-1h1zm-4 2h1v1h-1zm3 5v1h-1v-1zm0 3h-1v-1h1zm7-1v1h-1v-1zm-5 5h-1v-1h1zm-10 2v1h-1v-1z",
    fill: "#c2c1bd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64 18v1h-4v-1h1zm-11 85v1h-1v-4h1zm3-85h1v1h-1zm14 0h1v1h-1zm-10 4h1v1h-1zM50 33v1h-1v-1zm-14 2h-1v-1h1zm-2 13h1v1h-1zm14 12h-1v-1h1zm-12 0v1h-1v-1zm13 3v-1h1v1zm32 0v1h-1v-1zm-33 1h1v1h-1zm2 2v-1h1v1zm-16 1h1v1h-1zm0 2v1h-1v-1zm21 3h1v1h-1zm-21 2v1h-1v-1zm18 8v1h-1v-1zm-5 2v-1h1v1zm38 0h1v1h-1zm-5 1h1v1h-1zm4 2h-1v-1h1zm0 5v1h-1v-1zm-29 4v1h-1v-1zm25 5h1v1h-1z",
    fill: "#d1d0cc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25v2h-1v-2zm32 72h2v1h-2zm-8-80v-1h1v1zm-28 3v-1h1v1zm66 0h-1v-1h1zm-19 2h-1v-1h1zm14 0h-1v-1h1zm-25 3v-1h1v1zm19-1v1h-1v-1zm-34 8h-1v-1h1zM31 43h1v1h-1zm4 4h-1v-1h1zm42 11v-1h1v1zm2 2v1h-1v-1zm-46 1h1v1h-1zm18 4h-1v-1h1zm28-1v1h-1v-1zm1 12h-1v-1h1zm-26 5v1h-1v-1zm21 4h1v1h-1zM65 98h-1v-1h1zm10 1v-1h1v1zm-1 1v-1h1v1zm-3 0h1v1h-1zm4 1v1h-1v-1zm-2 1v1h-1v-1zm-1 1v1h-1v-1zm6 4v1h-1v-1zm-8 8h1v1h-1z",
    fill: "#bcbbb7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53 17v1h-3v-1zm-3 14v1h-1v-2h1zm4 68v-1h1v2h-1zM38 19v1h-1v-1zm2 0h1v1h-1zm3 1h-1v-1h1zm33 1v1h-1v-1zm-8 1v1h-1v-1zm9 1v-1h1v1zM34 37h1v1h-1zm46 3h-1v-1h1zm-44 6v-1h1v1zm17 6v1h-1v-1zm27 10h-1v-1h1zm-46 3v-1h1v1zm47 2h-1v-1h1zm-48 2v-1h1v1zm16 4v1h-1v-1zm0 3v1h-1v-1zm32 7h-1v-1h1zm-7 6h-1v-1h1zm-19 4h-1v-1h1zm28 5h1v1h-1zm-3 4h-1v-1h1zm-35 13h1v1h-1zm11 1h1v1h-1zm2 0h1v1h-1z",
    fill: "#cdccc8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60 103v-1h3v1zm5 5h1v2h-1v-1zm3 1h-1v-1h2v1zm-15 8h-2v-1h2zm28-97v1h-1v-1zM50 34h1v1h-1zm29 3h-1v-1h1zm-31 6h1v1h-1zm28 6h-1v-1h1zm0 2h1v1h-1zm3 12v-1h1v1zm-29 3h1v1h-1zm2 3h-1v-1h1zm28 0v1h-1v-1zm-3 4v-1h1v1zm2 0v-1h1v1zm-30 1v-1h1v1zm1 2h1v1h-1zm34 9v-1h1v1zm-7 5v-1h1v1zm-19 8h-1v-1h1zm0 2v-1h1v1zm18 0v-1h1v1zm1 2h-1v-1h1zm-16 4h1v1h-1zm8 9h1v1h-1z",
    fill: "#c3c2be"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77 105v2h-1v-1h-1v-1zm7-92v1h-1v-1zm-27 4v-1h1v1zm3 0h-1v-1h1zm6 0h-1v-1h1zm-16 4v1h-1v-1zm-14 2v1h-1v-1zm44 2v1h-1v-1zm-45 8v1h-1v-1zm-4 8v-1h1v1zm5 1h-1v-1h1zm13 1h1v1h-1zm43 2v1h-1v-1zM74 56v-1h1v1zm-38 3h-1v-1h1zm44 0h-1v-1h1zm-30 0h1v1h-1zm-16 5h-1v-1h1zm54 7v1h-1v-1zm-31 2v-1h1v1zm25 2v1h-1v-1zM50 87h-1v-1h1zm27-1h1v1h-1zm-4 6v1h-1v-1zm1 9v-1h1v1zm-3 2v-1h1v1zm0 5v1h-1v-1zm-4 8h1v1h-1z",
    fill: "#bdbcb8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M61 104v1h1v1h-1v2h-1v-5h1zm19-32h1v2h-1v-1zm-9-54v-1h1v1zM51 33h-1v-1h1zm-17 2v-1h1v1zm0 5v-1h1v1zm1 1v1h-1v-1zm-3 3v1h-1v-1zm42 4h1v1h-1zm4 1h-1v-1h1zm-24 2h1v1h-1zm22 7v1h-1v-1zm-2 18v-1h1v1zm-23 0h1v1h-1zm24 6v-1h1v1zm0 13h1v1h-1zm-3 1v1h-1v-1zm5 6v-1h1v1zm1 1v-1h1v1zm-14 4h-1v-1h1zm2 2h1v1h-1zm2 2h1v1h-1zm-3 5h1v1h-1z",
    fill: "#c4c3bf"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65 114v2h-1v-2zm21-96h-1v-1h1zm-43 5v-1h1v1zm-7 2h-1v-1h1zm-1 11v1h-1v-1zm16 6v1h-1v-1zm-2 18h-1v-1h1zm7 2h1v1h-1zm-6 7v-1h1v1zm26 3v1h-1v-1zm0 4v-1h1v1zm9 0h-1v-1h1zm-32 1v-1h1v1zm26 0h1v1h-1zm-26 8h-1v-1h1zm-2 2h1v1h-1zm20 1h1v1h-1zm13 1v1h-1v-1zm-28 3v-1h1v1zm-5 1v1h-1v-1zm20 2v1h-1v-1zm-17 2h1v1h-1zm2 6h-1v-1h1zm23-1h1v1h-1zm-16 11v1h-1v-1zm-17 2h1v1h-1zm1 1h1v1h-1zm8 0h1v1h-1z",
    fill: "#cbcac6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54 103v-3h1v3zM36 28v2h-1v-2zm44 66h1v1h-2v-1zm2-74h-1v-1h1zm2 1v1h-1v-1zm-2 2h-1v-1h1zm2 0v-1h1v1zm-10 1h-1v-1h1zM50 45h-1v-1h1zm7 0v1h-1v-1zm-2 3h1v1h-1zm-21 2v-1h1v1zm54 11h-1v-1h1zm-35 1h1v1h-1zm3 1h-1v-1h1zm-22 2h1v1h-1zm17 0h1v1h-1zm30 5h-1v-1h1zm-27 7v-1h1v1zm34 0h-1v-1h1zm-38 5v1h-1v-1zm29 1h1v1h-1zm7 5h-1v-1h1zm-28 9v-1h1v1zm-10 19h-1v-1h1z",
    fill: "#cecdc9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M54 100h-1v-3h1v1zm1-4h2v1h-2zm31-76h-1v-1h1zm-40 2h1v1h-1zm31 2h-1v-1h1zm-42 3h1v1h-1zm15 6h-1v-1h1zm-16 5h1v1h-1zm2 7v1h-1v-1zm20 0v1h-1v-1zm34 2h-1v-1h1zm-58 1h-1v-1h1zm22 4h-1v-1h1zm1 10v1h-1v-1zm25 1v-1h1v1zm-46 3h1v1h-1zm47 4v1h-1v-1zm-48 1h1v1h-1zm46 1v-1h1v1zm-20 2h-1v-1h1zm-11 0h1v1h-1zm2 9v-1h1v1zm-1 3v1h-1v-1zm16 10h-1v-1h1zm-31 8h-1v-1h1zm13 13v1h-1v-1z",
    fill: "#cfceca"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h-1v-1h2v1zm16 51v-1h1v2h-1zm1-95h1v1h-1zm11 1v-1h1v1zm-24 1v1h-1v-1zm45 1h-1v-1h1zm-43 2v-1h1v1zm19 0v-1h1v1zm4 0v-1h1v1zM49 35v-1h1v1zm31 2v1h-1v-1zm-29 2v1h-1v-1zm30 3h1v1h-1zM50 63v-1h1v1zm-2 4v-1h1v1zm-13 1v1h-1v-1zm52 1h-1v-1h1zm-39 2h-1v-1h1zm-15 3v-1h1v1zm1 2h-1v-1h1zm19 0v-1h1v1zm-5 13v-1h1v1zm10 4h-1v-1h1zm3-1v1h-1v-1zm1 1v-1h1v1zm-28 9v-1h1v1z",
    fill: "#d3d2ce"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M54 103h-1v-3h1zm18-84h-1v-1h1zm13 0v1h-1v-1zm-3 2h1v1h-1zm-2 1v1h-1v-1zm-44 2v-1h1v1zm0 7h-1v-1h1zm-1 1h1v1h-1zm16 6h-1v-1h1zm-14 3h-1v-1h1zm-1 18v1h-1v-1zm17 3v1h-1v-1zm28 3v1h-1v-1zm-47 7v1h-1v-1zm50 0h1v1h-1zM48 90v-1h1v1zm8 3h-1v-1h1zm9 0h-1v-1h1zm-12 1v1h-1v-1zm5 2v1h-1v-1zm-5 1v1h-1v-1zm26 3h1v1h-1zm-45 4v1h-1v-1zm21 7v1h-1v-1zm-15 3h-1v-1h1zm2 0h1v1h-1z",
    fill: "#d0cfcb"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h-2v-1h2zm22 25h-2v-1h2zm-2 1v2h-1v-2zM48 17h-1v-1h1zm-12 3h1v1h-1zm15 1v1h-1v-1zm20 1v1h-1v-1zM34 44v1h-1v-1zm3 3v1h-1v-1zm39 8v1h-1v-1zm2 7h1v1h-1zm0 5h1v1h-1zm1 4v-1h1v1zm5 13v1h-1v-1zm1 2v1h-1v-1zm-5 1h1v1h-1zm-8 4v1h-1v-1zm4 2v-1h1v1zm-7 5h1v1h-1zm4 6v1h-1v-1zm2 1v1h-1v-1zm-4 1h1v1h-1zm1 2v-1h1v1zm5 0h-1v-1h1z",
    fill: "#b9b8b4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M77 104h1v3h-1zm-2 0v-2h1v2zM61 17h-1v-1h1zm1 0v-1h1v1zm-16 1v-1h1v1zm-3 1h-1v-1h1zm-9 9v-1h1v1zm-1 11v-1h1v1zm45 0h1v1h-1zM35 49v-1h1v1zm22 0v-1h1v1zM35 59h-1v-1h1zm14 1v-1h1v1zm-15 4v1h-1v-1zm44 4v1h-1v-1zm1 2h-1v-1h1zm-30 4h1v1h-1zm32 2h-1v-1h1zm-6 2v1h-1v-1zm-3 14v-1h1v1zm4 2v1h-1v-1zm-1 3v-1h1v1zm1 4h-1v-1h1zm-5 9h-1v-1h1z",
    fill: "#bfbeba"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M86 37v2h-3v-2zm-45 69h-1v-3h1zm0-41v-2h1v2zm5 19v1h-2v-1h1zm36-56h-1v-1h1zm1 7h1v1h-1zm-2 26v-1h1v1zm-38 3h1v1h-1zm40 7v-1h1v1zm1 2v1h-1v-1zm-1 3h1v1h-1zm-43 5v-1h1v1zm46 1v1h-1v-1zm-40 7v1h-1v-1zm-7 10h1v1h-1zm2 10v1h-1v-1zm-1 2h1v1h-1z",
    fill: "#f5f4f0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22v-1h3v1zm-22-2h2v1h-2zm4-1v1h-1v-1zm9 2h1v1h-1zm5 0h1v1h-1zm10 0h1v1h-1zm7 11v1h-1v-1zm-43 4h-1v-1h1zm10 32v1h-1v-1zm33 4v-1h1v1zm-29 1h-1v-1h1zm30 1v1h-1v-1zm-30 2v-1h1v1zm-13 4v1h-1v-1zm17 2h1v1h-1zm26 0h1v1h-1zm-43 2v-1h1v1zm8 0v-1h1v1zm-1 1v1h-1v-1zm8 4h-1v-1h1zm2 0h-1v-1h1zm-6 18v1h-1v-1z",
    fill: "#dddcd8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22h-2v-1h2zm33-3h1v1h-1zm-38 1v1h-1v-1zm29 0h1v1h-1zm-35 2v-1h1v1zm8-1v1h-1v-1zm-20 1h1v1h-1zm45 12h-1v-1h1zm3 8h1v1h-1zM53 55v1h-1v-1zm-1 3h1v1h-1zm29 2v-1h1v1zm2 3h-1v-1h1zm-37 1h1v1h-1zm-9 1h1v1h-1zm10 1v-1h1v1zm-11 4v-1h1v1zm9 1v-1h1v1zm-8 0v1h-1v-1zm14 4v1h-1v-1zm-14 2v1h-1v-1zm12 13v1h-1v-1zm0 15h-1v-1h1z",
    fill: "#deddd9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M75 96v1h-2v-1h1zM62 24v1h-1v-1zm3 1v-1h1v1zm-21 0h1v1h-1zm6 4v-1h1v1zm-16 8v1h-1v-1zm45 1v1h-1v-1zm-45 4v1h-1v-1zm42 10h-1v-1h1zm-23 2v1h-1v-1zm-19 3v-1h1v1zm44 2h-1v-1h1zm3-1h1v1h-1zm-33 5h1v1h-1zm4 3h1v1h-1zm26 6v-1h1v1zm-4 13h1v1h-1zm-23 6v-1h1v1zm26 12v1h-1v-1zm-8 6h1v1h-1zm-19 8h-1v-1h1zm16-1h1v1h-1zm-19 2v-1h1v1z",
    fill: "#c0bfbb"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33v-3h1v3zm40 64h2v1h-2zm1 7h-1v-2h1v1zm-4 5v-1h1v2h-1zM57 16v1h-1v-1zm23 11h-1v-1h1zm-29 4h-1v-1h1zm25 23h1v1h-1zm-40 4h1v1h-1zm51 13v1h-1v-1zm-33 2v1h-1v-1zm-1 14v1h-1v-1zm32 0v1h-1v-1zM66 97v1h-1v-1zm3 0v1h-1v-1zm6 10v-1h1v1zm-26 10h-1v-1h1z",
    fill: "#bbbab6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M34 61h1v3h-1zm42 17h2v1h-2zM65 18v-1h1v1zm-24 2v-1h1v1zm51-1h1v1h-1zm-45 1h1v1h-1zm11 26h-1v-1h1zm-5 16h-1v-1h1zm0 4h-1v-1h1zm0 16h-1v-1h1zm25-1v1h-1v-1zm1 7h1v1h-1zm0 1v1h-1v-1zm-29 2v-1h1v1zm0 2v-1h1v1zm30 0v1h-1v-1zm4 8h-1v-1h1zm-29 3v-1h1v1zm8 11v-1h1v1z",
    fill: "#cccbc7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M81 39h-1v-2h1v1zm0 30v-2h1v2zm5 7v-1h2v1h-1zm-48 29v2h-1v-2zm-2-82v-1h1v1zm6-1v1h-1v-1zm38 8v1h-1v-1zm1 23h1v1h-1zm5 11v-1h1v1zm1 3h-1v-1h1zm-3 2h-1v-1h1zm2 3h1v1h-1zm-48 6v1h-1v-1zm0 4h-1v-1h1zm1 0v-1h1v1zm47 1v-1h1v1zm-38 5h-1v-1h1zm-11 14h1v1h-1z",
    fill: "#e4e3df"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M63 16h2v1h-2zm12 89v-1h2v1h-1zM61 17v-1h1v1zm11 6h1v1h-1zm-8 1h1v1h-1zm14 1h1v1h-1zM36 40v1h-1v-1zm0 17h1v1h-1zm41 5v-1h1v1zm-27 9h1v1h-1zm1 2v1h-1v-1zm4 1h-1v-1h1zm28 2v-1h1v1zm-29 3v-1h1v1zm24 4h-1v-1h1zm3 2h-1v-1h1zm-4 0v1h-1v-1zm-2 15v-1h1v1zm0 2v-1h1v1z",
    fill: "#bebdb9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98v1h-2v-1h1v-1h2v1zM54 17v-1h1v1zm43 0v-1h1v1zm-50 1v1h-1v-1zm47 1v1h-1v-1zm-2 29v1h-1v-1zm-39 6h1v1h-1zm1 6v-1h1v1zm24 7v-1h1v1zm9 7v1h-1v-1zm-10 6v-1h1v1zm-28 3h1v1h-1zm28 1v-1h1v1zm0 7h-1v-1h1zm-7 6h1v1h-1zm4 10h1v1h-1zm-2 2v-1h1v1z",
    fill: "#b7b6b2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M71 21h2v1h-2zM48 73v-1h2v1h-1zm-2-61h-1v-1h1zm-8 8h1v1h-1zm12 0h1v1h-1zm29 11h1v1h-1zm-32 5v-1h1v1zm-10 2v1h-1v-1zm11 10h1v1h-1zm39 15h-1v-1h1zm-6 1v-1h1v1zM38 81v-1h1v1zm2 0h1v1h-1zm15 4h1v1h-1zm-6 3h-1v-1h1zm-2 22v-1h1v1zm-10 1h1v1h-1z",
    fill: "#e0dfdb"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25h-2v-1h2zm-5 74h-1v-2h1v1zm11-77v1h-1v-1zm7 2v-1h1v1zm1 42v-1h1v1zm-27 0h1v1h-1zm27 8h1v1h-1zm1 3v1h-1v-1zm0 7h-1v-1h1zm1 6v1h-1v-1zm-2 3v1h-1v-1zm2 1v-1h1v1zm-8 2h1v1h-1zm5 8v-1h1v1zm-12 2v-1h1v1zm5 8v1h-1v-1zm-20 2h1v1h-1z",
    fill: "#c1c0bc"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h1v2h1v1h-1v1h-1v-1zm44-70h1v1h1v1h-2zM44 98h-1v-3h1zm39-69v1h-1v-2h1zm4-1h1v1h-1zm-1 1h1v1h-1zm0 3h-1v-1h1zm-4 13v-1h1v1zm5 10h1v1h-1zM43 67v1h-1v-1z",
    fill: "#faf5f2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M66 37h2v1h-1v1h-1zm-1-3v2h-1v-2zm29-6v-1h1v1zm-22 6h-1v-1h1zm24 1h-1v-1h1zm-26 0v1h-1v-1zm-2 4v-1h1v1zm-4 6h-1v-1h1zm1 8h1v1h-1zm1 14h1v1h-1zm-2 11v-1h1v1zm2 6h1v1h-1zm-7 6h1v1h-1zm33 10h1v1h-1zm4 6h-1v-1h1zm-15 12h-1v-1h1z",
    fill: "#393836"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M95 27h-1v-2h1v1zm-24 5h1v1h-2v-1zM49 13h-1v-1h1zm-8 2v1h-1v-1zm55 18v1h-1v-1zm-29 3h1v1h-1zm-1 8v1h-1v-1zm-3 10h1v1h-1zm-6 4h-1v-1h1zm15 6h1v1h-1zm-4 3v1h-1v-1zm-4 1h1v1h-1zm2 1v-1h1v1zm-6 6v-1h1v1zm35 25v1h-1v-1zm-5 8h1v1h-1z",
    fill: "#363533"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M76 109h-1v-1h2v1zm-4-93h1v1h-1zm5 6v1h-1v-1zm13 23h1v1h-1zm-39 1v1h-1v-1zm-15 2h1v1h-1zm23 1h-1v-1h1zm33 2v1h-1v-1zm-58 8h-1v-1h1zm22 7h-1v-1h1zm21 8h1v1h-1zm-1 8h1v1h-1zm6 3v-1h1v1zm-2 6v-1h1v1zm-7 1h1v1h-1zm-21 1v1h-1v-1zm21 16v-1h1v1z",
    fill: "#b5b4b0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h-1v-1h1zm16 0h-1v-1h1zm-51 2h1v1h-1zm18 8h1v1h-1zm39 14h1v1h-1zm-15 3h-1v-1h1zm1 4v-1h1v1zm-22 3v1h-1v-1zm22 2h1v1h-1zm1 8h-1v-1h1zm-27 1v1h-1v-1zm30 3v1h-1v-1zm-30 2v-1h1v1zm24 20v-1h1v1zm-3 2h1v1h-1zm3 11h1v1h-1zm-2 1h1v1h-1zm-3 7v1h-1v-1z",
    fill: "#b6b5b1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M42 108h1v1h1v2h-2zm-3-8h-1v-2h1v1zm1 3v2h-1v-2zm5 2v1h-1v-2h1zm41-64v-1h1v1zm-2 20v-1h1v1zm-40 3h-1v-1h1zm0 1v-1h1v1zm42 24h-1v-1h1zm-43 18h1v1h-1zm-3 6v-1h1v1z",
    fill: "#f1f0ec"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13v1h-1v-1zm5 2h1v1h-1zm56 10v-1h1v1zm-36 6h-1v-1h1zm34-1h1v1h-1zM63 43h1v1h-1zm2 1v1h-1v-1zm-7 17h-1v-1h1zm10 6h1v1h-1zm-2 2h-1v-1h1zm-8 6v-1h1v1zm8 3h-1v-1h1zm3 2h1v1h-1zm-9 8v-1h1v1zm0 2h1v1h-1zm31 15h1v1h-1zm-1 5v-1h1v1z",
    fill: "#343331"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M84 63v-1h2v1h-1zm-46 37h-1v-2h1v1zm-2-78h-1v-1h1zm6 1h1v1h-1zm38 12h1v1h-1zm2 33h1v1h-1zm5 3h-1v-1h1zm-40 1v1h-1v-1zm40 1v-1h1v1zm-48 9h-1v-1h1zm44 1v1h-1v-1zm-1 3v1h-1v-1zm-37 3h-1v-1h1zm-7 20h-1v-1h1zm9 1h-1v-1h1z",
    fill: "#e6e5e1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M35 29v1h-1v-2h1zm-2 8v-1h1v1zm45 22v-1h1v1zm-26 1h-1v-1h1zm-19 1v-1h1v1zm22 5h-1v-1h1zm28 9v1h-1v-1zm-3 2v-1h1v1zm-1 3v-1h1v1zm-5 3v-1h1v1zm1 2v-1h1v1zm-25 4h1v1h-1zm20 9h-1v-1h1zm2 5h1v1h-1zm3 2h-1v-1h1zm-4 3v-1h1v1z",
    fill: "#bab9b5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14v-1h1v2h-1zm10-2v1h-1v-1zm43 13v1h-1v-1zm-34 5v1h-1v-1zm5 4h1v1h-1zm0 1v1h-1v-1zm-6 16h-1v-1h1zm33 1v1h-1v-1zm-25 1v1h-1v-1zm-5 7v1h-1v-1zm1 14h1v1h-1zm29 29v1h-1v-1zm-2 2h1v1h-1zm3 1h1v1h-1zm-3 3h-1v-1h1z",
    fill: "#2c2b29"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M77 14v-1h3v1zM53 30v1h-1v-1zm1 10v-1h1v1zm1 2v-1h1v1zm36 21h1v1h-1zm3 11h-1v-1h1zm-2 8v1h-1v-1zm1 1v-1h1v1zm2 1h1v1h-1zm-9 8h1v1h-1zm-2 15h1v1h-1zm-8 7h-1v-1h1zm4-1v1h-1v-1zm-19 5h-1v-1h1z",
    fill: "#a19c99"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M38 95h1v3h-1zm49-58v2h-1v-2zm-44 68v-1h1v2h-1zm-7-80h1v1h-1zm47 15h-1v-1h1zM38 83v-1h1v1zm45 2h1v1h-1zm-44 8v1h-1v-1zm3 15h-1v-1h1zm0 1v1h-1v-1zm-2 3h-1v-1h1zm2 1h-1v-1h1z",
    fill: "#f3f2ee"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29h1v3h-1v-1zm-3 16v-1h3v1h-1zm-2 6v-1h2v1h-1zm-1-18h1v1h-1zm1 10v1h-1v-1zm1 5v-1h1v1zm-1 5v1h-1v-1zm4 2v-1h1v1zm0 3h-1v-1h1zm-2 14v-1h1v1zm0 5h1v1h-1z",
    fill: "#fffffe"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M39 105h1v6h-1zm43-66v-2h1v2zm-39 74h-1v-2h1v1zm39-77v-1h1v1zm4 34v1h-1v-1zm-41 1h1v1h-1zm40 15v-1h1v1zm-43 21h1v1h-1zm-1 2v-1h1v1z",
    fill: "#f2f1ed"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M44 37v2h-1v-2zm-1 24h-2v-1h2zm0-21h-1v-1h1zm-5 4v-1h1v1zm4 1h-1v-1h1zm-1 2v1h-1v-1zm-1 4h-1v-1h1zm3-1v1h-1v-1zm-1 5v-1h1v1zm-1 2h1v1h-1zm1 17v1h-1v-1zm-3 2h1v1h-1zm4 5h-1v-1h1zm-1 2h1v1h-1z",
    fill: "#fffefc"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M40 103h-1v-3h1v1zm1 6h-1v-3h1zm1-4h-1v-1h2v1zm41-64h-1v-1h1zM45 61h1v1h-1zm-6 2h1v1h-1zm46 7v1h-1v-1zm-47 9h1v1h-1zm1 14h1v1h-1zm0 2h-1v-1h1zm2 16h-1v-1h1z",
    fill: "#f4f3ef"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M56 53v-1h5v1h-1zM32 78h-1v-3h1zm6-53v-1h1v1zm9 24v1h-1v-1zm14 6v1h-1v-1zM31 70v-1h1v1zm33 7h-1v-1h1zm3 3h-1v-1h1zm-3 5v1h-1v-1z",
    fill: "#d4d3d1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30v1h-1v2h-1v-3zm24 79v-2h1v2zm3-83v-1h1v1zm-33 4v-1h1v1zm2 2v-1h1v1zm4 11h1v1h-1zm-5 5h-1v-1h1zm6 0v-1h1v1zm-5 16v1h-1v-1zm9 13v1h-1v-1zm16 35v1h-1v-1z",
    fill: "#201f1d"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M80 89h2v1h-2zm-33 17h-1v-2h1v1zm32-77h1v1h-1zm7 14v-1h1v1zM45 63v-1h1v1zm39 2v-1h1v1zm1 1v1h-1v-1zm1 11v-1h1v1zm-47 7v-1h1v1zm-1 0v1h-1v-1zm9 4h-1v-1h1zm-9 7v1h-1v-1zm-1 14h1v1h-1z",
    fill: "#e8e7e3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M44 41h-3v-2h1v1h1v-1h2v1h-1zm-4 5v1h-2v-1h1zm0 11h-2v-1h2zm2-14v1h-1v-1zm-4 11v-1h1v1zm3-1h1v1h-1zm-1 8v-1h1v1zm3 20v-1h1v1z",
    fill: "#fefdfb"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M86 31v-1h1v2h-1zM45 97v1h-1v-2h1zm-4 5v-2h1v2zm47-74h-1v-1h1zm-6 3v-1h1v1zm3 1h-1v-1h1zm2 25h-1v-1h1zM39 90h1v1h-1zm6 2h1v1h-1zm-2 7v-1h1v1zm-1 0h1v1h-1z",
    fill: "#f9f4f1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39h-2v2h-1v-2h-1v-2h4v1zm2-6h1v1h-1zm-3 19v-1h1v1zm2 8v1h-1v-1zm0 1h1v1h-1z",
    fill: "#fdfcfa"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M39 106h-1v-4h1v1zm7 1v2h-1v-2zm35-72h1v1h-1zm0 5h1v1h-1zM38 64v-1h1v1zm46 4v-1h1v1zm-2 7v-1h1v1zm-37 8h1v1h-1zm-7 3v-1h1v1zm1 24v1h-1v-1z",
    fill: "#eeede9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13h-1v-1h1zm-17 0h1v1h-1zm30 17v1h-1v-1zm5 1v1h-1v-1zm28 1h-1v-1h1zM66 43v1h-1v-1zm28 7h-1v-1h1zM67 61v-1h1v1zm5 3v1h-1v-1zm-1 16h1v1h-1zm-2 10h1v1h-1zm26 15v1h-1v-1zm-13 12v1h-1v-1z",
    fill: "#252422"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M94 102h-1v-1h2v1zM41 13h1v1h-1zm54 15h1v1h-1zm-26 3h1v1h-1zm-4 5v-1h1v1zm2 0v-1h1v1zm1 1v-1h1v1zm1 8h-1v-1h1zm-9 30h-1v-1h1zm2 15v1h-1v-1zm26 23v-1h1v1zm2 0h1v1h-1z",
    fill: "#32312f"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58v-1h2v1h-1zM44 13h1v1h-1zm2 0h1v1h-1zm17 17h-1v-1h1zm8 1h-1v-1h1zm-4 2v1h-1v-1zm5 25h-1v-1h1zm-4 19h1v1h-1zm-3 14v-1h1v1zm2-1h1v1h-1zm27 16h-1v-1h1zm-1 2h-1v-1h1z",
    fill: "#262523"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M69 104h-1v-2h1v1zm10-88h-1v-1h1zm-12 0h1v1h-1zm11 2v-1h1v1zm-29 5h1v1h-1zm41 6h-1v-1h1zm-7 30v-1h1v1zm0 20v-1h1v1zM61 99h1v1h-1zm5 4h-1v-1h1zm4 3h-1v-1h1zm-2 1v-1h1v1z",
    fill: "#c2bdba"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M75 110h-2v-1h2zm11-94v-1h1v1zm-8 5h1v1h-1zm9 2h-1v-1h1zm-9 0h1v1h-1zm-47 7h-1v-1h1zm45 16v-1h1v1zM52 68h1v1h-1zm36 7h-1v-1h1zm-13 7h1v1h-1zm8 12v-1h1v1zm-6 15h1v1h-1z",
    fill: "#b3b2ae"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M73 106v1h-1v-2h1zM55 16h1v1h-1zm-8 10h-1v-1h1zm-14 9h1v1h-1zm4 10h-1v-1h1zm-3 14v1h-1v-1zm43 12h1v1h-1zm4 14v-1h1v1zm-26 9v1h-1v-1zm20 12v1h-1v-1zm-1 1v1h-1v-1zm1 0h1v1h-1z",
    fill: "#b8b7b3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M98 23v1h-1v-1zM69 35h-1v-1h1zm28 0h-1v-1h1zm-1 4h-1v-1h1zM58 51h-1v-1h1zm8 4h-1v-1h1zm-7 5h1v1h-1zm2 0h1v1h-1zm8 8v-1h1v1zm3 3h1v1h-1zm-5 7v-1h1v1zm3 2h1v1h-1zm18 33v1h-1v-1z",
    fill: "#2d2c2a"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M43 65h1v1h-2v-1zm-7-38v-1h1v1zm44 0h1v1h-1zm7 9h1v1h-1zm-4 31h1v1h-1zm0 3v1h-1v-1zM45 87v1h-1v-1zm37 1h1v1h-1zm-41 6h-1v-1h1zm-3 7v-1h1v1zm7 6v1h-1v-1zm-1 1v1h-1v-1z",
    fill: "#f0efeb"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34v-1h1v2h-1zm26-5h-1v-1h1zm-23 2v-1h1v1zm-12 1h1v1h-1zm36 0v1h-1v-1zm-30 4v1h-1v-1zm3 8h1v1h-1zm-6 10v1h-1v-1zm5 0v1h-1v-1zM58 78h-1v-1h1zm6-1v1h-1v-1zm26 35h-1v-1h1z",
    fill: "#3a3937"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M40 62h3v1h-3zm7-26h-1v-1h1zm-6 6h-1v-1h1zm-3 1h-1v-1h1zm4 6v1h-1v-1zm-4 4v1h-1v-1zm7 10h-1v-1h1zm-7 10v-1h1v1zm5 1h-1v-1h1zm-4 2h-1v-1h1zm3 6h1v1h-1z",
    fill: "#ebeae8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38h-1v-2h1v1zm12 2h-1v-1h1zm0 2h-1v-1h1zm32 18v1h-1v-1zm1 2h-1v-1h1zm-45 1h1v1h-1zm45 1v1h-1v-1zm-35 2h-1v-1h1zm0 5v1h-1v-1zm0 35v-1h1v1zm1 3h-1v-1h1zm-7 4h1v1h-1z",
    fill: "#e1e0dc"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40h1v1h-1zm32 0h1v1h-1zm5 3h-1v-1h1zm-2 19h1v1h-1zm-37 2h-1v-1h1zm39 0h1v1h-1zm-2 2v1h-1v-1zm-36 7v-1h1v1zm-10 9h1v1h-1zm43 2v-1h1v1zm3 3h-1v-1h1zm-2 1h1v1h-1zm-33 16v1h-1v-1z",
    fill: "#e2e1dd"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M39 106v4h-1v-4zm6-18v-2h1v2zm1 18h-1v-2h1v1zm-1 3v1h-1v-2h1zm-6-45h1v1h-1zm47 10v-1h1v1zm-47 28h-1v-1h1z",
    fill: "#efeeea"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13v1h-1v-1zm50 15h1v1h-1zm0 3v-1h1v1zm-30 2v-1h1v1zm1 0h1v1h-1zm0 10h1v1h-1zm27 3v1h-1v-1zM64 65h-1v-1h1zm4 9v1h-1v-1zm4 6h1v1h-1zm20 29v-1h1v1zm0 2h-1v-1h1z",
    fill: "#232220"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M81 13v1h-1v-1zm-8 2h-1v-1h1zm16 26h1v1h-1zm-1 10h1v1h-1zm4 8h-1v-1h1zm-1 6v-1h1v1zm2 5v-1h1v1zm1 7h-1v-1h1zm2 2h-1v-1h1zm-5 7h1v1h-1zm-14 26v1h-1v-1zm-2 2h-1v-1h1z",
    fill: "#a39e9b"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M40 15v1h-1v-1zm54 15v1h-1v-1zM67 40v1h-1v-1zm28 2v-1h1v1zm-34 3h-1v-1h1zm11-1v1h-1v-1zm-12 9h1v1h-1zm0 1v1h-1v-1zm14 3v1h-1v-1zM64 82h-1v-1h1zm31 17h1v1h-1zm-5 6v1h-1v-1z",
    fill: "#4a4947"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M49 17h-1v-1h1zm15 6h1v1h-1zm27 2h-1v-1h1zM35 58h-1v-1h1zm44 2h-1v-1h1zm-29 1v-1h1v1zm-1 6h1v1h-1zm30 3v1h-1v-1zM54 85v-1h1v1zm-4 1h1v1h-1zm-1 31v1h-1v-1zm6 1h-1v-1h1z",
    fill: "#a6a5a1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M97 17h1v1h-1zm-19 5h-1v-1h1zm-45 0h1v1h-1zm1 3h-1v-1h1zm35-1v1h-1v-1zM50 44v-1h1v1zm42 10h1v1h-1zM55 66v1h-1v-1zm20 22v-1h1v1zm-23 2h-1v-1h1zm22 2h1v1h-1zm1 18v-1h1v1z",
    fill: "#b1b0ac"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21v1h-1v-1zm44 8v-1h1v1zM45 64h1v1h-1zm41 4h-1v-1h1zm-41 1v-1h1v1zm-6 9v1h-1v-1zm1 2v1h-1v-1zm-1 4h1v1h-1zm8 5v1h-1v-1zm-10 5h1v1h-1zm0 16h1v1h-1zm3 3h-1v-1h1z",
    fill: "#e9e8e4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M87 30h1v2h-1v-1zM44 99v-1h2v1h-1zm45-72h-1v-1h1zm-7 4h1v1h-1zM43 67h1v1h-1zm2 28v1h-1v-1zm-1 5h-1v-1h1zm-2 0h1v1h-1zm3 1v-1h1v1zm-1 1v1h-1v-1z",
    fill: "#f7f2ef"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31h2v1h-2zm0-1h-1v-1h1zm10 0v1h-1v-1zm24 3h1v1h-1zm-29 2h-1v-1h1zm3 8h1v1h-1zm-8 5v-1h1v1zm-4 10h-1v-1h1zm4 3v-1h1v1zm5 26h1v1h-1zm28 16v1h-1v-1z",
    fill: "#2b2a28"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36h-2v-1h1v-1h1zm-1 4v-1h1v2h-1zm-1 20v1h-2v-1h1zm2-27h1v1h-1zM40 63h1v1h-1zm45 14v-1h1v1zM41 99v1h-1v-1zm-1 4v-1h1v1z",
    fill: "#f6f5f1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v-2h1v2zm1 1v1h-1v-1zm1 2v1h-1v-1zm2 4h1v1h-1zm-3 6v1h-1v-1zm4 1h1v1h-1zm-3 7h1v1h-1zm0 16h1v1h-1zm0 3h1v1h-1zm2 1v1h-1v-1zm-1 4v-1h1v1z",
    fill: "#fcfbf9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97v1h-1v-2h1zm9 10v2h-1v-2zm-3-96h1v1h-1zm36 23h1v1h-1zm4 41h-1v-1h1zm-1 1v1h-1v-1zm-2 7h1v1h-1zm-33 1v1h-1v-1zm-1 6v1h-1v-1z",
    fill: "#e7e6e2"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M48 14v-1h1v1zm-10 2h1v1h-1zm55 13h1v1h-1zM68 40h1v1h-1zm0 2v1h-1v-1zM58 54h-1v-1h1zm6 14h-1v-1h1zm5 1v-1h1v1zm-2 11v1h-1v-1zm-1 1v1h-1v-1zm-4 3v1h-1v-1z",
    fill: "#474644"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M34 15v1h-1v-2h1zm7 0h-1v-1h1zm55 9h-1v-1h1zm-24 4v1h-1v-1zm-4 2v-1h1v1zm-3 0h1v1h-1zm6 24h-1v-1h1zm-11 3h1v1h-1zm9 8v-1h1v1zm-9 7v-1h1v1z",
    fill: "#1d1c1a"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M55 15v1h-1v-1zm41 8h-1v-1h1zm-31 4h1v1h-1zm31 16v1h-1v-1zM65 56v1h-1v-1zm8 3h1v1h-1zm0 2v1h-1v-1zM60 76h-1v-1h1zm11 3h-1v-1h1zm10 37v1h-1v-1zm1 1v-1h1v1z",
    fill: "#888785"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M52 17v-1h1v1zm10 6v1h-1v-1zm9 1h-1v-1h1zm-2 0h1v1h-1zm13 1v1h-1v-1zm-48 5h-1v-1h1zm1 28v-1h1v1zm15 25h1v1h-1zm33 5h-1v-1h1zm-28 2v-1h1v1zm26 0h1v1h-1z",
    fill: "#aaa9a5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M34 101v1h-1v-2h1zm24 13v1h-2v-1h1zm11-96v1h-1v-1zm10 0v1h-1v-1zM48 52h1v1h-1zM34 98v1h-1v-1zm21 7h-1v-1h1zm-1 6v-1h1v1zm5 5v-1h1v1z",
    fill: "#d2cecb"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M42 96h-1v-1h2v3h-1zm41-68h1v2h-1v-1zm3 3h-2v-1h2zm1-5h1v1h-1zm-5 2v-1h1v1zM42 69v-1h1v1z",
    fill: "#fbf6f3"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M95 27h1v1h-1zm-22 3h-1v-1h1zm23 0h-1v-1h1zm-25 2v-1h1v1zm-6 2h1v1h-1zm2 19h1v1h-1zm-9 7h1v1h-1zm14 24v-1h1v1zm-3 3v1h-1v-1zm23 20h-1v-1h1zm-2 4v-1h1v1z",
    fill: "#31302e"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32v2h-1v-1h-1v-1zm-4-1v1h-1v-1zm34 5v-1h1v1zM59 50h1v1h-1zm-2 24h1v1h-1zm10 3v1h-1v-1zm28 25v1h-1v-1zm-2 2v1h-1v-1zm-2 3h1v1h-1z",
    fill: "#2f2e2c"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M38 100v2h-1v-2zm0 5h-1v-2h1v1zm43-69v1h-1v-1zm3 31h-1v-1h1zm-39 3v-1h1v1zm42 0h-1v-1h1zm-3 2h-1v-1h1zm-45 6h1v1h-1zm-1 29v1h-1v-1z",
    fill: "#e5e4e0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M37 40v-1h1v1zm5 3h-1v-1h1zm3 0h-1v-1h1zm-1 4h-1v-1h1zm-7 3v-1h1v1zm1 7h-1v-1h1zm1 17h1v1h-1zm4 2h-1v-1h1zm-3 1v1h-1v-1zm3 1v1h-1v-1zm1 14v-1h1v1z",
    fill: "#eae9e7"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M82 63h2v1h-2zm0-9h1v1h-1zm-36 7h-1v-1h1zm-2 3v-1h1v1zm38 4v-1h1v1zm0 3h1v1h-1zm1 12h-1v-1h1zm-36 2h-1v-1h1zm-8 27h-1v-1h1zm3 2v-1h1v1z",
    fill: "#ecebe7"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M77 12h-1v-1h1zm4 2h1v1h-1zM52 26v1h-1v-1zm37 5v-1h1v1zm0 5v-1h1v1zm-11 3h-1v-1h1zm12 31v-1h1v1zm2 13v-1h1v1zm-4 9h-1v-1h1zm0 1v1h-1v-1z",
    fill: "#b0aba8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M64 91h-1v-1h2v1zM49 12h1v1h-1zm13 18h1v1h-1zm0 20v1h-1v-1zm11 34v-1h1v1zm-9 4v-1h1v1zm29 16h1v1h-1zm-1 3v-1h1v1zm-1 2h1v1h-1z",
    fill: "#292826"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13h-1v-1h2v1zm37 28v-1h1v1zm1 2h-1v-1h1zM56 67v1h-1v-1zm-3 10h1v1h-1zm4 13v1h-1v-1zm7 4h1v1h-1zm26 2h1v1h-1zm-24 22h1v1h-1z",
    fill: "#595854"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v1h-1v-1zm57 14h-1v-1h1zm-27 7h-1v-1h1zm-1 2v1h-1v-1zM57 77v1h-1v-1zm5 1h-1v-1h1zm9 9v1h-1v-1zm-13 4v-1h1v1zm36 6h1v1h-1zm-5 13v-1h1v1z",
    fill: "#3e3d3b"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81h-1v-3h1zm0 16h-1v-3h1zm51-84h1v1h-1zm-18 5h1v1h-1zm17 0v1h-1v-1zm-3 32v1h-1v-1z",
    fill: "#d4d0cd"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M94 24h2v1h-2zm-59-9h-1v-1h1zm29 16h1v1h-1zm32 2v-1h1v1zm-27 1h-1v-1h1zm3 13v1h-1v-1zm1 28v-1h1v1zm-8 13v-1h1v1zm29 19h1v1h-1z",
    fill: "#282725"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M67 32h-1v-3h1zM37 15h-1v-1h1zm-5 0h1v1h-1zm37 14h1v1h-1zm-4 21h1v1h-1zm1 14v1h-1v-1zm-4 8h-1v-1h1zm32 37v-1h1v1z",
    fill: "#1c1b19"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M65 15v1h-3v-1zm10 8h-1v-1h1zm12 2v-1h1v1zM31 38v-1h1v1zm60 14h1v1h-1zM53 64v1h-1v-1zm-3 4v-1h1v1zm22 26h1v1h-1z",
    fill: "#979692"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18h-1v-1h1zm10 51h-1v-1h1zm-1 7v-1h1v1zm-2 2v-1h1v1zm2 8h-1v-1h1zm-4 1h1v1h-1zm-13 24v1h-1v-1zm2 0v1h-1v-1zm-4 3h-1v-1h1zm-15 4v-1h1v1z",
    fill: "#aba6a3"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22h1v1h-1zm1 23h-1v-1h1zm-19 7v1h-1v-1zm30 47h-1v-1h1zm1 0v1h-1v-1zm1 4v-1h1v1zm5 0v1h-1v-1zm-5 1h1v1h-1zm4 1h1v1h-1zm11 2h1v1h-1z",
    fill: "#c0bcb9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v-1h1v1zm-37 1v-1h1v1zm41 21v-1h1v1zm5 13v1h-1v-1zm-1 4v1h-1v-1zM59 73h-1v-1h1zm18 4h1v1h-1zM58 89v1h-1v-1zm19 0v1h-1v-1zm-2 4v-1h1v1z",
    fill: "#b2b1ad"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64h1v1h1v1h-2zm-1-39h-1v-1h1zm44 8v1h-1v-1zm5 28h-1v-1h1zm0 6h-1v-1h1zm-5 4h1v1h-1zm2 2v1h-1v-1zM45 90h1v1h-1z",
    fill: "#eae9e5"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25h1v1h-1zm-47 9h1v1h-1zm58 13h-1v-1h1zm-38 2v1h-1v-1zm-1 10h1v1h-1zm-3 1h1v1h-1zm5 2v-1h1v1zm21 19v1h-1v-1zm-16 8v1h-1v-1zm13 26v1h-1v-1z",
    fill: "#b4b3af"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101v1h-1v1h-2v-1h1v-1h1zm40-70v2h-1v-2zM46 96v2h-1v-2zm42-67v1h-1v-1zM39 67h1v1h-1z",
    fill: "#f8f3f0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30h1v1h-1zm0 3h-1v-1h1zm-4 11h-1v-1h1zm2-1v1h-1v-1zm3 10v1h-1v-1zm-4 8h-1v-1h1zm5 7h-1v-1h1zm-4 7h-1v-1h1zm28 30h-1v-1h1zm-5 6h1v1h-1z",
    fill: "#272624"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34v1h-1v-2h2v1zm-1 13h1v1h-2v-1zm-2-4v1h-1v-1zm3 9v-1h1v1zm-3 2h-1v-1h1zm3 0v1h-1v-1zm-5 20v-1h1v1z",
    fill: "#fffffd"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34h1v1h-1zm-7 2h1v1h-1zm3 11h-1v-1h1zm-1 1h-1v-1h1zm3 0h1v1h-1zm-3 8h1v1h-1zm-1 3h1v1h-1zm6 16h-1v-1h1zm0 2v1h-1v-1zm0 3v1h-1v-1z",
    fill: "#fbfaf8"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h1v1h-2v-1zm7-23v-1h1v1zm-3 4v1h-1v-1zm-4 4h-1v-1h1zm3 0h-1v-1h1zm-1 3h-1v-1h1zm2 7h-1v-1h1zm0 4v-1h1v1zm-4 12h1v1h-1z",
    fill: "#e7e6e4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102h1v3h-1zm-4 0v-1h2v1h-1zm23-60v-1h1v1zm-3 6h1v1h-1zm3 4h-1v-1h1zm-1 42v1h-1v-1zm-27 6v-1h1v1z",
    fill: "#c1bcb9"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v1h-2v-1h1zM47 44h1v1h-1zm-9 4h1v1h-1zm0 7v1h-1v-1zm0 5v1h-1v-1zm7 17h-1v-1h1zm13 2v1h-1v-1zm4 1h-1v-1h1zm-1 2h1v1h-1z",
    fill: "#dedddb"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M40 46h-1v-1h1zm6 2v-1h1v1zm10 7h1v1h-1zm-19 8v-1h1v1zm0 9h1v1h-1zm3 1v-1h1v1zm7 4v1h-1v-1zm13 2v1h-1v-1zm-13 2h-1v-1h1zm-5 9h1v1h-1z",
    fill: "#e0dfdd"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71h-1v-2h1v1zm32-19v1h-1v-1zm-27 3h-1v-1h1zm26 0v1h-1v-1zm-27 3h1v1h-1zm-5 8h-1v-1h1zm36 10v1h-1v-1zm4 6h1v1h-1zm-12 7v-1h1v1z",
    fill: "#cac9c7"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M56 82h2v1h-2zM39 54v1h-1v-1zm16 1h1v1h-1zm-6 3v1h-1v-1zm-11 2h-1v-1h1zm2 16v-1h1v1zm-2 2v-1h1v1zm22 2v-1h1v1zm0 2h1v1h-1z",
    fill: "#dfdedc"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M63 101h-1v-1h2v3h-1zm4 6h2v1h-3v-2h1zm-7-9h-1v-1h1zm5 6v-1h1v1z",
    fill: "#c3bfbc"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13h1v1h-1zm58 10h1v1h-1zm4 5v1h-1v-1zM65 39h1v1h-1zm5 1h-1v-1h1zm0 15h-1v-1h1zm-6 13v-1h1v1zm31 33v-1h1v1zm-14 15h-1v-1h1z",
    fill: "#454442"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13h2v1h-2zm-3 0h1v1h-1zm6 1v-1h1v1zm-17 2h-1v-1h1zm10 15h-1v-1h1zm17 16v1h-1v-1zm1 33v1h-1v-1zM56 94h-1v-1h1z",
    fill: "#676662"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14h1v1h-1zm6 1v-1h1v1zm25 8v1h-1v-1zM57 64h-1v-1h1zm0 23h-1v-1h1zm17 3v-1h1v1zm1 4h-1v-1h1zm-4 1h-1v-1h1zm2 21v1h-1v-1z",
    fill: "#7c7b77"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M68 57h3v1h-3zM32 15v1h-1v-1zm5 1v-1h1v1zm29 13v1h-1v-1zm6 48h1v1h-1zm23 31v-1h1v1zm-2 1h1v1h-1z",
    fill: "#1a1917"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M55 38h-1v-3h1zm36 3h1v1h-2v-1zM81 16h-1v-1h1zM56 40h-1v-1h1zm36 25v-1h1v1zm1 22h1v1h-1z",
    fill: "#989390"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M60 111v2h-1v-2zm36-95h-1v-1h1zm-28 1v1h-1v-1zm-16 5v1h-1v-1zm36 22v1h-1v-1zm-5 5v1h-1v-1zm2 45h1v1h-1zm-4 9h1v1h-1z",
    fill: "#ccc8c5"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M70 100v-1h1v4h-1zm15-83h-1v-1h1zm4 0h-1v-1h1zM49 50v1h-1v-1zm33 29h-1v-1h1zm4 18v1h-1v-1z",
    fill: "#bebab7"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M91 18h-1v-1h1zm-39 6h-1v-1h1zm32 22v-1h1v1zm1 6v-1h1v1zm-36 0h1v1h-1zm36 39v-1h1v1zm-30 18h-1v-1h1zm2 3v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#d1ccc9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M94 17v1h-1v-1zm-4 18h-1v-1h1zM78 54v-1h1v1zm13 17v-1h1v1zm1 5v1h-1v-1zm-3 11v-1h1v1zm7-1v1h-1v-1zm-11 19v1h-1v-1zm-11 7v-1h1v1z",
    fill: "#aea9a6"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v2h-1v-2zm43-68v-1h1v1zm3 6h1v1h-1zm7 12v-1h1v1zM35 81v1h-1v-1zm0 3h-1v-1h1zm-1 3v-1h1v1zm1 7v1h-1v-1z",
    fill: "#d7d5d1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M94 33v-1h1v2h-1zm2-10v-1h1v1zM70 42v1h-1v-1zm-7 3h-1v-1h1zm-3 9h1v1h-1zm5 27v1h-1v-1zm2 1h-1v-1h1zm24 20h-1v-1h1z",
    fill: "#494846"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23v1h-1v-1zm6 13v1h-1v-1zm-9 20v-1h1v1zm1 2h-1v-1h1zm3 1h-1v-1h1zm5 17h-1v-1h1zm-5 1v-1h1v1zm5 1v1h-1v-1zm-5 4v-1h1v1z",
    fill: "#e9e8e6"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26h-1v-1h1zm3 0h1v1h-1zm41 24v-1h1v1zm-61 4h1v1h-1zm42 11h-1v-1h1zm15 14v1h-1v-1zm1 0h1v1h-1zm3 1h-1v-1h1zm-3 5v-1h1v1z",
    fill: "#a29d9a"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M91 62v-1h1v2h-1zM74 27v-1h1v1zm-22 2v-1h1v1zm0 21v1h-1v-1zm38 11h-1v-1h1zm3 6v1h-1v-1zm-2 5v1h-1v-1zm-14 42v-1h1v1z",
    fill: "#9d9895"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M61 37v1h1v1h-2v-2zm-4-8h1v1h-1zm19 31v1h-1v-1zm0 23v1h-1v-1zm15 10h1v1h-1zm-26 26v-1h1v1zm-2 0h1v1h-1z",
    fill: "#5d5c58"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30h1v1h-1zm-29 8v-1h1v1zm2 2h-1v-1h1zm-5 3h1v1h-1zm0 12h-1v-1h1zm6 14v-1h1v1zm3 14v1h-1v-1zm-9 2v-1h1v1zm22 32v-1h1v1z",
    fill: "#403f3d"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30v1h-1v-1zm-5 10v-1h1v1zm-27 2h-1v-1h1zm-1 0v1h-1v-1zm-9 12h-1v-1h1zm5 13v1h-1v-1zm1 15h-1v-1h1zm7 2h-1v-1h1zm21 19h-1v-1h1z",
    fill: "#535250"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h-2v-1h2zm35-36h1v1h-1zM69 47v-1h1v1zm-6 14h1v1h-1zm-5 7h1v1h-1zm16 2v1h-1v-1zm-6 12v-1h1v1zm4 4v1h-1v-1z",
    fill: "#575654"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38h-1v-2h1v1zm6-3v-1h1v1zm-6 33v-1h1v1zm2 17v-1h1v1zm28 18v-1h1v1zm-4 3h-1v-1h1zm-1 8h-1v-1h1zm-14 3h-1v-1h1z",
    fill: "#3f3e3c"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M95 35h-1v-1h1zm-27 7v-1h1v1zm-1 1h-1v-1h1zm-8 10h1v1h-1zm4 14v1h-1v-1zm2 13h1v1h-1zm-2 2h-1v-1h1zm27 19v-1h1v1zm0 4h-1v-1h1z",
    fill: "#4c4b49"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M96 35v1h-1v-1zM59 47h1v1h-1zm3 7v-1h1v1zm7 1h-1v-1h1zm-10 9h1v1h-1zm9 5h-1v-1h1zm-12 5v1h-1v-1zm3 4h-1v-1h1zm37 25v1h-1v-1z",
    fill: "#3d3c3a"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36h1v4h-1v-1zm5 27v1h-2v-1h1zm-5 11h1v1h-1zM38 84h1v1h-1zm45 2h-1v-1h1z",
    fill: "#edece8"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h-1v-1h1zm1 22v-1h1v1zm3 7h1v1h-1zm-4 1h1v1h-1zM37 80v-1h1v1zm11 5v-1h1v1zm33 1v-1h1v1zm-1 0h1v1h-1zm-32 5h-1v-1h1z",
    fill: "#e3e2de"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56v-1h2v1h-1zm-2-15h-1v-1h1zm3 5h-1v-1h1zm1 7h-1v-1h1zm-1 6h-1v-1h1zm-2 12v1h-1v-1zm0 4h-1v-1h1zm9 0v1h-1v-1z",
    fill: "#e1e0de"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42v-1h1v1zm-1 1v-1h1v1zm-6 6h-1v-1h1zm7 0v-1h1v1zm-4 0h1v1h-1zm-4 3v-1h1v1zm-2 23h1v1h-1zm6 5v-1h1v1zm0 4v1h-1v-1z",
    fill: "#e4e3e1"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M46 59h-1v-2h1v1zm-8-17h1v1h-1zm5 1h1v1h-1zm-4 17h-1v-1h1zm2 12h-1v-1h1zm0 2v1h-1v-1zm4 4v1h-1v-1zm-1 4v-1h1v1z",
    fill: "#f7f6f4"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M57 113v-2h1v2zm28-67v-1h1v1zm4 14h-1v-1h1zm-2 32h-1v-1h1zm-27 5v-1h1v1zm3-1v1h-1v-1zm-5 18v-1h1v1zm2 1h-1v-1h1z",
    fill: "#d0cbc8"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M81 112h-2v-1h2zm7-58v1h-1v-1zm1 25v-1h1v1zm-3 1v1h-1v-1zm9 1v-1h1v1zm-13 28v-1h1v1zm-3 2h-1v-1h1zm-6 0v1h-1v-1z",
    fill: "#b5b0ad"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M74 11h1v1h-1zM55 32v1h-1v-1zm20 6v-1h1v1zm17 25v-1h1v1zm2 3v1h-1v-1zm0 6h-1v-1h1zm-1 5v1h-1v-1zm-2 7v1h-1v-1z",
    fill: "#938e8b"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M50 79h-1v-1h2v1zm31-68v1h-1v-1zM50 49v-1h1v1zm32-1h1v1h-1zm-34 6h1v1h-1zM38 67v1h-1v-1zm9 46h1v1h-1z",
    fill: "#e1dcd9"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13v-1h1v1zm18 0v1h-1v-1zm38 10v-1h1v1zM61 41v1h-1v-1zm32 6v1h-1v-1zM71 61v1h-1v-1zm0 9h1v1h-1zM59 83h1v1h-1z",
    fill: "#6f6e6c"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v-1h1v1zm25 40h-1v-1h1zm1 2v1h-1v-1zm1 0h1v1h-1zm-8 7v1h-1v-1zm-29 3v-1h1v1zm28 5v-1h1v1zm14 15v1h-1v-1z",
    fill: "#c7c6c4"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M48 13h-1v-1h1zm-12 3h1v1h-1zm35 19h-1v-1h1zm-6 4v1h-1v-1zm3 45h1v1h-1zm26 11h1v1h-1zm-5 16v1h-1v-1zm-11 5v1h-1v-1z",
    fill: "#464543"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13h-1v-1h1zm-12 1v-1h1v1zm20 10v1h-1v-1zm-20 7v1h-1v-1zm0 12v1h-1v-1zm1 2v-1h1v1zm-2 46h-1v-1h1zm2 2v1h-1v-1z",
    fill: "#6c6b67"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M75 14v-1h1v1zm2 0v1h-1v-1zm0 13v1h-1v-1zm-23 3h1v1h-1zm38 31h1v1h-1zm1 18h-1v-1h1zm-1 1h1v1h-1zm-5 20v-1h1v1z",
    fill: "#918c89"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M76 14v-1h1v1zM53 25v1h-1v-1zm23 16v-1h1v1zm0 0v1h-1v-1zm17 24v1h-1v-1zm-2 20h1v1h-1zm3 0v1h-1v-1zm-6 12v1h-1v-1z",
    fill: "#9a9592"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M91 14v-1h1v1zM40 25h1v1h-1zm0 17h1v1h-1zm-2 1v1h-1v-1zm5 2v1h-1v-1zm-2 14h1v1h-1zm-2 2h-1v-1h1zm0 10h1v1h-1z",
    fill: "#edecea"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h-2v-1h2zM37 15v-1h1v1zm30 14v-1h1v1zm5 21v1h-1v-1zm-9 8h-1v-1h1zm4 0v-1h1v1zm-4 13h1v1h-1z",
    fill: "#151412"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M64 29v-1h2v1h-1zm6 22h-2v-1h2zM39 14v1h-1v-1zm27 34h-1v-1h1zm3 24h-1v-1h1zm22 40v-1h1v1z",
    fill: "#12110f"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67h1v1h-2v-1zM42 14v1h-1v-1zm-8 4v-1h1v1zm62 8h1v1h-1zM69 43v1h-1v-1zm-7 7h1v1h-1zm1 15h-1v-1h1z",
    fill: "#21201e"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15h-1v-1h1zm49 6h1v1h-1zm1 10v1h-1v-1zM67 41v-1h1v1zm2 2h-1v-1h1zm-9 0h1v1h-1zm0 25h1v1h-1zm34 29v-1h1v1z",
    fill: "#434240"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h-1v-1h1zM31 38h1v1h-1zm3 9h-1v-1h1zm0 3h1v1h-1zm19 1h-1v-1h1zm1 13h-1v-1h1zm21 9h1v1h-1zm-3 17v-1h1v1z",
    fill: "#858480"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M32 73v1h-1v-2h1zm59-59h1v1h-1zM38 24h-1v-1h1zm-1 17h1v1h-1zm1 17h-1v-1h1zm31 24v1h-1v-1zm-7 3h1v1h-1z",
    fill: "#d5d4d2"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M39 16h-1v-1h1zm0 1v-1h1v1zm28 21h1v1h-1zm-5 30v1h-1v-1zm-3 10v-1h1v1zm3 0v-1h1v1zm34 26v1h-1v-1zm-19 12v1h-1v-1z",
    fill: "#3c3b39"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16h-1v-1h1zm8-1h1v1h-1zm40 3v1h-1v-1zM59 42h-1v-1h1zm-28 6h1v1h-1zm61 1v1h-1v-1zM71 89h1v1h-1zm0 27h1v1h-1z",
    fill: "#908f8b"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M52 15h1v1h-1zm10 1h-1v-1h1zm4 0v-1h1v1zm8 6v1h-1v-1zm14 1h-1v-1h1zM55 57h-1v-1h1zm22 17v1h-1v-1zm-1 15v1h-1v-1z",
    fill: "#969591"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M60 16v-1h1v1zm5 0v-1h1v1zm-15 0v1h-1v-1zm4 31v-1h1v1zm5 0h-1v-1h1zm-7 14h-1v-1h1zm22 8v-1h1v1zm0 19v-1h1v1z",
    fill: "#94938f"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h-1v-1h2v1zm6-62h1v1h-1zm-2 10h-1v-1h1zM52 58h-1v-1h1zm-1 13v-1h1v1zm2 18v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#a7a6a2"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v1h-1v-2h1zm28-82v-1h1v1zm-1 43h-1v-1h1zm-5 35v-1h1v1zm-16 7h1v1h-1zm2 4h-1v-1h1zm11 0h1v1h-1z",
    fill: "#c0bbb8"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17h-1v-1h1zm64 7h1v1h-1zm-29 5h1v1h-1zm3 0h1v1h-1zm-6 2v-1h1v1zm7 34h-1v-1h1zm22 44v1h-1v-1zm-2 4v-1h1v1z",
    fill: "#1f1e1c"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M77 17h-1v-1h1zM53 27h-1v-1h1zm25 9v1h-1v-1zm13 32v-1h1v1zm2 10h1v1h-1zm-4 2h-1v-1h1zm0 10v-1h1v1zm-9 23h-1v-1h1z",
    fill: "#a8a3a0"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M41 17v1h-1v-1zm23 29v-1h1v1zm-4 3h-1v-1h1zM32 59h1v1h-1zm1 3v1h-1v-1zm37 0v1h-1v-1zm-11 5v-1h1v1zm8 2v1h-1v-1z",
    fill: "#b0afad"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18h-1v-1h1zm32 6h-1v-1h1zm-48 7v-1h1v1zm0 1h1v1h-1zm19 15h-1v-1h1zm-2 16v1h-1v-1zm0 8v-1h1v1zm20 45v1h-1v-1z",
    fill: "#abaaa6"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M81 18h-1v-1h1zm-24 5h-1v-1h1zm-7 26h1v1h-1zm37 5v1h-1v-1zm-4 4v1h-1v-1zm-17 43h-1v-1h1zm3 0h-1v-1h1zm11 9v1h-1v-1z",
    fill: "#beb9b6"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M77 18v1h-3v-1zm-24 93h-1v-1h2v1zm-4-32v1h-1v-1zm38 9v1h-1v-1zm-34 16v1h-1v-1z",
    fill: "#d3cfcc"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20v-1h1v1zm56 1h1v1h-1zm-19 2v-1h1v1zm-3 1h-1v-1h1zM32 41v1h-1v-1zm23 13v1h-1v-1zm23 3v-1h1v1zm-1 19v1h-1v-1z",
    fill: "#a2a19d"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M97 22v-1h1v1zm-35 5h-1v-1h1zm5 1v-1h1v1zm-4 18h1v1h-1zm-1 6h-1v-1h1zm5 0h-1v-1h1zm-35 5v-1h1v1zm32 9v-1h1v1z",
    fill: "#82817f"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24h-1v-1h1zm8 14v1h-1v-1zm-8 18h-1v-1h1zm7 2h-1v-1h1zm0 1v-1h1v1zm-6 17v-1h1v1zm0 2h1v1h-1zm0 4v-1h1v1z",
    fill: "#e3e2e0"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v1h-1v-1zm-28 9v-1h1v1zm46 10v1h-1v-1zm-4 3v1h-1v-1zm-44 1h1v1h-1zm47 28v-1h1v1zM56 89h1v1h-1zm20 4h1v1h-1z",
    fill: "#adaca8"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v1h-1v-1zm10 13v1h-1v-1zm-9 4h1v1h-1zm-2 9h1v1h-1zm5 3v-1h1v1zm-5 24v-1h1v1zm6 10v1h-1v-1zm0 4v-1h1v1z",
    fill: "#e2e1df"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25h-1v-1h1zm8 22h-1v-1h1zm-21 1v-1h1v1zm1 2h1v1h-1zm-1 3v-1h1v1zm18 1h-1v-1h1zM51 64v-1h1v1zm5 30h1v1h-1z",
    fill: "#9a9995"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M76 38v2h-1v-2zM57 25v1h-1v-1zm-4 2v1h-1v-1zm40 43v1h-1v-1zm-1 19v1h-1v-1zm-4 9v1h-1v-1zm-1 6h-1v-1h1z",
    fill: "#948f8c"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M97 25h1v1h-1zM69 38h-1v-1h1zm3 9h1v1h-1zm-15 3v1h-1v-1zm-1 10h1v1h-1zm8 8v1h-1v-1zm2 17h-1v-1h1zm25 20v-1h1v1z",
    fill: "#383735"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36v1h-1v-2h1zm22-8h-1v-1h1zm3-1h1v1h-1zM65 38v1h-1v-1zm-3 15v1h-1v-1zm29 48v-1h1v1zm-2 7h1v1h-1z",
    fill: "#41403e"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54v-1h2v1h-1zm32-25v1h-1v-1zM68 40h-1v-1h1zM55 78v-1h1v1zm14 3h-1v-1h1zm-6 4v-1h1v1zm26 29h-1v-1h1z",
    fill: "#3b3a38"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67h1v1h-2v-1zm34-35v-1h1v1zm1 4v-1h1v1zM57 53v1h-1v-1zm17 4h-1v-1h1zM61 67h1v1h-1zm4 14h-1v-1h1z",
    fill: "#51504e"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34h-1v-1h1zm21 0v1h-1v-1zm-22 2v-1h1v1zm36 42h1v1h-1zm0 4v1h-1v-1zm5 7v1h-1v-1zm-7 3v-1h1v1zm-1 8v1h-1v-1z",
    fill: "#8a8582"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80v1h-2v-1h1zm32-44v1h-1v-1zm-24 7v-1h1v1zm1 13h1v1h-1zm-6 6v-1h1v1zm29 36v-1h1v1zm-16 18v1h-1v-1z",
    fill: "#555452"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38h1v2h-1v-1zm-8 6h1v1h-1zm8 1h1v1h-1zm-4 5v-1h1v1zm5 8v1h-1v-1zM37 87h1v1h-1zm5 4h-1v-1h1z",
    fill: "#e6e5e3"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41v-1h1v1zm2 1v-1h1v1zm5 4v1h-1v-1zm-7 15h1v1h-1zm6 2h1v1h-1zm-7 17h1v1h-1zm-3 5h-1v-1h1zm20 31h-1v-1h1z",
    fill: "#545351"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43v-1h1v1zm-2 4v-1h1v1zm3 10h-1v-1h1zm-1 7h-1v-1h1zm-2 19v1h-1v-1zm22 17h-1v-1h1zm-3 12v-1h1v1zm-5 4v-1h1v1z",
    fill: "#5d5c5a"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46v-1h1v1zm-35 3h1v1h-1zm6 0h1v1h-1zm7 4v-1h1v1zM32 64h1v1h-1zm35 6v-1h1v1zm4 3h-1v-1h1zm0 3h1v1h-1z",
    fill: "#b3b2b0"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M68 46v1h-1v-1zm-7 33v-1h1v1zm-3 3v-1h1v1zm0 1v1h-1v-1zm13 1h1v1h-1zm25 10v1h-1v-1zm-17 23v-1h1v1zm-3 0v1h-1v-1z",
    fill: "#686765"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49v-1h1v1zm-9 1h-1v-1h1zm8 2v1h-1v-1zm3 7h-1v-1h1zM63 69v1h-1v-1zm8 1h-1v-1h1zM60 90v-1h1v1zm5-1v1h-1v-1z",
    fill: "#b9b8b6"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M67 96v-1h3v1zm-3-23v1h-2v-1h1zm-1-20h-1v-1h1zm9 30h-1v-1h1zm-30 34v-1h1v1z",
    fill: "#cdccca"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M65 83v-1h3v1zM32 71v1h-1v-1zm0 3v1h-1v-1zm14 3v-1h1v1zm1 3h-1v-1h1zm18-1h1v1h-1z",
    fill: "#d7d6d4"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M55 104h1v2h-1v-1zm-5-93h-1v-1h1zm31 42v1h-1v-1zM50 80v-1h1v1zm5 28h1v1h-1zm4 6v-1h1v1z",
    fill: "#cecac7"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11h-1v-1h1zm-1 16v-1h1v1zm3 16v-1h1v1zm35 6v-1h1v1zM77 64h1v1h-1zm-2 2v-1h1v1zm14 14h1v1h-1z",
    fill: "#b4b0ad"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M53 11h1v1h-1zm13 1h-1v-1h1zm25 11v-1h1v1zm-19 3h-1v-1h1zm2 49v-1h1v1zm18 22h-1v-1h1zm-23 21v-1h1v1z",
    fill: "#4d4c48"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M75 11h1v1h-1zM51 26h-1v-1h1zm3-1h1v1h-1zm22 1v1h-1v-1zm1 15v1h-1v-1zm10 56v-1h1v1zm-7 17v-1h1v1z",
    fill: "#a09b98"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M51 12h1v1h-1zm20 18v-1h1v1zm0 13h1v1h-1zm0 29v-1h1v1zm-5 18h1v1h-1zm3 0v1h-1v-1zm26 17h-1v-1h1z",
    fill: "#242321"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M66 12v1h-1v-1zm-1 1v1h-1v-1zm-19 2h-1v-1h1zm30 10h-1v-1h1zm15 1v-1h1v1zm0 24v1h-1v-1zm-1 48h-1v-1h1z",
    fill: "#656460"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65h-2v-1h2zm1-53v1h-1v-1zM41 23h1v1h-1zm39 5h-1v-1h1zm2 50h-1v-1h1zm-36 31v1h-1v-1z",
    fill: "#ebeae6"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14h-1v-1h1zm51 10v1h-1v-1zm2 3h-1v-1h1zm-25 4v1h-1v-1zm23 12v1h-1v-1zM65 54v1h-1v-1zm-4 7h-1v-1h1z",
    fill: "#2e2d2b"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13v1h-1v-1zm-7 1v1h-1v-1zm7 17h-1v-1h1zm1 1h-1v-1h1zm2 9v-1h1v1zm6 77v-1h1v1zm-4 1v1h-1v-1z",
    fill: "#6d6c68"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13h1v1h-1zm9 0v1h-1v-1zm2 0v1h-1v-1zM57 30h-1v-1h1zm-2 53v1h-1v-1zm1 11v-1h1v1zm4 1v-1h1v1z",
    fill: "#6a6965"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M31 31v-2h1v2zm29-17v-1h1v1zm-13 2h-1v-1h1zm40 93v-1h1v1zm-13 7v1h-1v-1zm-15 2v1h-1v-1z",
    fill: "#666561"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M62 15h-1v-1h1zm28 9h-1v-1h1zM58 44v1h-1v-1zm-5 17h-1v-1h1zm3 3h-1v-1h1zm-1 22v1h-1v-1zm20 1v-1h1v1z",
    fill: "#777672"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M65 15v-1h1v1zm-33 4v1h-1v-1zm42 6h-1v-1h1zm4 0v-1h1v1zm-13 2h-1v-1h1zM54 86v1h-1v-1zm7 34h-1v-1h1z",
    fill: "#797874"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15h1v1h-1zm24 38v-1h1v1zm1 1v1h-1v-1zm-23 3h-1v-1h1zm-1 26h1v1h-1zm19 6h1v1h-1zm-17 28h1v1h-1z",
    fill: "#9b9a96"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16v-1h1v1zm0 0v1h-1v-1zm-16 8h-1v-1h1zm33 46v-1h1v1zm-1 4v1h-1v-1zm5 10h-1v-1h1zm-23 28v1h-1v-1z",
    fill: "#b3aeab"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16v-1h1v1zm3 0v1h-1v-1zm-48 9h-1v-1h1zm18 29h-1v-1h1zm39 2h1v1h-1zM77 66h-1v-1h1zm5 41v-1h1v1z",
    fill: "#bbb6b3"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M80 16h-1v-1h1zm-3 21h1v1h-1zm14 5h1v1h-1zm-1 22h1v1h-1zm3 10h-1v-1h1zm-2 9h1v1h-1zm-9 27h1v1h-1z",
    fill: "#aca7a4"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M69 61v-1h2v1h-1zM31 16v1h-1v-1zm34 14h-1v-1h1zm7 23h1v1h-1zm0 7h1v1h-1zm0 18h-1v-1h1z",
    fill: "#191816"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M94 39h-1v-2h1v1zM40 17v-1h1v1zm22 26h-1v-1h1zm11 11v1h-1v-1zm-7 25v-1h1v1zm-8 5v1h-1v-1z",
    fill: "#6c6b69"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16v1h-1v-1zm53 17v1h-1v-1zM58 54v1h-1v-1zm0 15h-1v-1h1zm15 2h-1v-1h1zm-9 7h1v1h-1zm-8 6v-1h1v1z",
    fill: "#646361"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M92 18v-1h1v1zm0 57h-1v-1h1zm-1 5h1v1h-1zm2 1h1v1h-1zm3 5h-1v-1h1zm-9 9h1v1h-1zm-2 11v1h-1v-1z",
    fill: "#a6a19e"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M31 19h-1v-1h1zm28 12h1v1h-1zm11 5h1v1h-1zm24 22h1v1h-1zM58 91h-1v-1h1zm36 4v-1h1v1zm-23 23v1h-1v-1z",
    fill: "#4c4b48"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M38 19v-1h1v1zm10 30v1h-1v-1zm7 4v-1h1v1zm5 21h-1v-1h1zm-28 0h1v1h-1zm0 4v-1h1v1zm34 18h-1v-1h1z",
    fill: "#cfcecb"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M35 80v1h-1v-2h1zm45-61v1h-1v-1zM34 84h1v1h-1zm1 10h-1v-1h1zm48 1h-1v-1h1zm-1 2h1v1h-1z",
    fill: "#d8d6d2"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24h-1v-1h1zm-1 23v1h-1v-1zm2 0v1h-1v-1zm20 24h-1v-1h1zm22-1v1h-1v-1zm-26 5h-1v-1h1zm-2 42v1h-1v-1z",
    fill: "#9c9b97"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1zM35 43v1h-1v-1zm42 33h1v1h-1zm-3 4v-1h1v1zM53 90v1h-1v-1zm21 4v1h-1v-1zm-2 22v-1h1v1z",
    fill: "#a9a8a4"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23v1h-1v-1zm14 1v-1h1v1zm-10 0v1h-1v-1zM34 57v1h-1v-1zm42 14h1v1h-1zm1 3v-1h1v1zM53 88v-1h1v1z",
    fill: "#a1a09c"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M79 24v-1h1v1zM33 34v-1h1v1zm22 33v-1h1v1zm-3 4v1h-1v-1zm24 8h1v1h-1zm-5 12v1h-1v-1zm-15 26h1v1h-1z",
    fill: "#afaeaa"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h1v1h-1zm-10 2v-1h1v1zM54 48v-1h1v1zm22 2h-1v-1h1zM60 93h1v1h-1zm0 1v1h-1v-1zm-1 25h1v1h-1z",
    fill: "#757470"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M54 56v1h-2v-1h1zm18-31h-1v-1h1zm22 32v1h-1v-1zm-16 2v1h-1v-1zm9 28v-1h1v1zm-35 6h1v1h-1z",
    fill: "#959490"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M93 25h1v2h-1v-1zM66 39h-1v-1h1zm5 5v1h-1v-1zm-4 37v-1h1v1zm28 20h1v1h-1zm-5 4v-1h1v1z",
    fill: "#42413f"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M68 27h-1v-1h1zM54 54h-1v-1h1zm21 6v-1h1v1zm1 1v-1h1v1zm-23 3h1v1h-1zm-1 19h1v1h-1zm2 11h-1v-1h1z",
    fill: "#81807c"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M45 103h-1v-2h-1v-1h1v-1h1zm39-77h1v1h-1zm2 27h1v1h-1z",
    fill: "#f6f1ee"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M84 28h-1v-1h2v1zm2 2h-2v-1h2zm0-4h1v1h-1zm1 23v1h-1v-1zM41 95v-1h1v1z",
    fill: "#fcf7f4"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28h-1v-1h1zm26 18v-1h1v1zm-22 3h1v1h-1zm-5 7v1h-1v-1zm-2 9v1h-1v-1zm3 0h1v1h-1zm0 22h-1v-1h1z",
    fill: "#858482"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M91 79v1h-2v-1h1zM76 29h1v1h-1zm-21 5v1h-1v-1zm38 30h-1v-1h1zm-3 17h1v1h-1zm4 8h-1v-1h1z",
    fill: "#97928f"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h-1v-1h1zm-28 6v-1h1v1zm3 10v1h-1v-1zm-2 18v-1h1v1zm-12 5v-1h1v1zm-2 12v-1h1v1zm12 2h1v1h-1z",
    fill: "#4b4a48"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33h-1v-1h1zm-3 4h-1v-1h1zm1 7v1h-1v-1zm4 13h1v1h-1zm-3 30h1v1h-1zm-6 3v1h-1v-1zm31 11h-1v-1h1z",
    fill: "#353432"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55h-1v-2h1v1zm-3-21v-1h1v1zm5 1v1h-1v-1zm4 8v1h-1v-1zm-9 31h1v1h-1zm-3 13h1v1h-1z",
    fill: "#302f2d"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35h-1v-1h1zm6 10h1v1h-1zm-5 3h-1v-1h1zm5 5v1h-1v-1zm0 2h1v1h-1zm-5 2h1v1h-1zm3 16v1h-1v-1z",
    fill: "#f5f4f2"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M47 41v1h-1v-2h1zm-4 2v-1h1v1zm4 6h-1v-1h1zm-9 3v1h-1v-1zm4 8v-1h1v1zm-1 27v1h-1v-1z",
    fill: "#e8e7e5"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41v-1h1v1zm-4 9h1v1h-1zm40 10v-1h1v1zm-14 6h-1v-1h1zm3 45h1v1h-1zm3 1v-1h1v1zm-7 0v1h-1v-1z",
    fill: "#ada8a5"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M55 41h-1v-1h1zm22 2v-1h1v1zm15 23v1h-1v-1zm-1 2h1v1h-1zm-3 12v1h-1v-1zm-2 24h-1v-1h1zm-4 9h-1v-1h1z",
    fill: "#a7a29f"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M65 40h1v1h-1zm6 28v1h-1v-1zM58 80h1v1h-1zm13 7h1v1h-1zm24 11h1v1h-1zm-6 6v-1h1v1zm-2 8h1v1h-1z",
    fill: "#4f4e4c"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h1v1h-1zm0 6h-1v-1h1zm1 2h-1v-1h1zm-5 4v-1h1v1zm1 24h-1v-1h1zm1 1v-1h1v1zm2 11v-1h1v1z",
    fill: "#f6f5f3"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M47 43v1h-1v-1zm10 13v-1h1v1zm-10 2v-1h1v1zm-8 0h1v1h-1zm-2 4v-1h1v1zm1 13h-1v-1h1zm20 4h1v1h-1z",
    fill: "#dddcda"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M47 45h-1v-1h1zm-3 2v-1h1v1zm-3 6h-1v-1h1zm6 2h-1v-1h1zm-3 2v-1h1v1zm1 3h-1v-1h1zm-5 15v1h-1v-1z",
    fill: "#e5e4e2"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44v1h-1v-1zm4 4h1v1h-1zm1 9h1v1h-1zm-1 21h1v1h-1zm-32 2h-1v-1h1zm-3 1h-1v-1h1zm10 30v1h-1v-1z",
    fill: "#cec9c6"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h1v1zm30 6v-1h1v1zm-25 8h-1v-1h1zm5 9v1h-1v-1zm0 3v1h-1v-1zm-2 5v-1h1v1zm-9 12h1v1h-1z",
    fill: "#bab9b7"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62v1h-3v-1zm-3-16v-1h1v1zm-4 13h-1v-1h1zm7 30h1v1h-1zm-6 2v1h-1v-1z",
    fill: "#b6b5b3"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1zm36 10h1v1h-1zm-41 2v-1h1v1zm25 16h-1v-1h1zM55 88h-1v-1h1zm3 6v1h-1v-1zm-6 23v1h-1v-1z",
    fill: "#8f8e8a"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v-1h2v1h-1zm8 3h1v1h-1zm-12 7v-1h1v1zm-1 6v1h-1v-1zm-2 11h-1v-1h1zm9 15h1v1h-1z",
    fill: "#9f9e9c"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M93 48v1h-1v-1zM32 65h1v1h-1zm31 4h1v1h-1zm6 0h1v1h-1zm-13 6v1h-1v-1zm17 4v1h-1v-1zm-7 10v1h-1v-1z",
    fill: "#b7b6b4"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v-1h3v1zm-2-14v-1h1v1zm8 3h-1v-1h1zm1 21h-1v-1h1zm17 38v-1h1v1z",
    fill: "#1b1a18"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M90 52v-1h1v1zm1 3h-1v-1h1zm-58 1h1v1h-1zm45 11v1h-1v-1zm-25 3v1h-1v-1zm22 7v-1h1v1zm-2 39v-1h1v1z",
    fill: "#9e9d99"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M60 73h2v1h-2zm2-18v1h-1v-1zM32 68h-1v-1h1zm37 12h-1v-1h1zm-2 5h1v1h-1zm-31 28h-1v-1h1z",
    fill: "#d0cfcd"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M62 71v-1h2v1h-1zm5-13v1h-1v-1zm-3 9v-1h1v1zm-1 5v1h-1v-1zm-7 7v-1h1v1zm9 12v1h-1v-1z",
    fill: "#999896"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h1v1h-2v-1zm5 4v-1h2v1h-1zm-7-1v1h-1v-1zm8 4v-1h1v1zm-21 32v1h-1v-1z",
    fill: "#d9d8d6"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M42 11h1v1h-1zm-4 24v1h-1v-1zm2 10h-1v-1h1zm0 4h1v1h-1zm2 12v1h-1v-1zm1 14h1v1h-1z",
    fill: "#f3f2f0"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M38 13v-1h1v1zm25 45v1h-1v-1zm5 1h-1v-1h1zm4 6h1v1h-1zm-8 2h-1v-1h1zm-2 5v1h-1v-1z",
    fill: "#9d9c9a"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60h-2v-1h2zM39 13v-1h1v1zm28 40v-1h1v1zm-36 5h1v1h-1zm32 31h-1v-1h1z",
    fill: "#c1c0be"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M42 12h1v1h-1zm28 37v-1h1v1zm-14 1v-1h1v1zm9-1v1h-1v-1zm7 10h-1v-1h1zm-5 31v-1h1v1z",
    fill: "#b2b1af"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13h-1v-1h1zm5 23h1v1h-1zm29 14h1v1h-1zM55 60v1h-1v-1zm18 31v-1h1v1zm18 4h1v1h-1z",
    fill: "#504f4b"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M33 92v1h-1v-2h1zm-1 4v-2h1v2zm50-83h-1v-1h1zm-50 88v-1h1v1z",
    fill: "#d7d2cf"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h1v2h-1v-1zm5-18h-1v-1h1zm-5 37h1v1h-1zm2 9v1h-1v-1zm-37 44v1h-1v-1z",
    fill: "#f2eeeb"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M38 14v-1h1v1zm54 39v-1h1v1zm-34 2v-1h1v1zm2 27v-1h1v1zm11 3h-1v-1h1zm-3 9v-1h1v1z",
    fill: "#585755"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M75 13v1h-1v-1zm0 23v-1h1v1zm-19 1h-1v-1h1zm3 4h-1v-1h1zm34 22v-1h1v1zm0 15v-1h1v1z",
    fill: "#8b8683"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M42 15v-1h1v1zm54 13v-1h1v1zm0 1h1v1h-1zM73 53h1v1h-1zm-6 7v1h-1v-1zm26 47v-1h1v1z",
    fill: "#22211f"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M47 15h-1v-1h1zm22 11v1h-1v-1zm22 20h1v1h-1zm-16 2v-1h1v1zM58 86v1h-1v-1zm-1 34v-1h1v1z",
    fill: "#84837f"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15v-1h2v1h-1zm12 26v-1h1v1zm14 6h-1v-1h1zm-22 7v-1h1v1zm1 30v-1h1v1z",
    fill: "#64635f"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M65 14v1h-3v-1zM31 46v-1h1v1zm22 22h-1v-1h1zm2 19v-1h1v1z",
    fill: "#787773"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M75 15h-1v-1h1zm2 1h1v1h-1zm11 42h-1v-1h1zm5 11h-1v-1h1zm-7 23v1h-1v-1zm-12 20h1v1h-1z",
    fill: "#a9a4a1"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M78 14v1h-1v-1zm-3 22h1v1h-1zm2 1v1h-1v-1zm14 1h1v1h-1zm1 22v1h-1v-1zm-1 28h1v1h-1z",
    fill: "#908b88"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27h-2v-1h2zm26-12h-1v-1h1zm9 19h-1v-1h1zm1 35h-1v-1h1zm-11 43h1v1h-1z",
    fill: "#aaa5a2"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M82 14h1v1h-1zm3 3v1h-1v-1zm11 1v1h-1v-1zm-65 3h1v1h-1zm47 19v1h-1v-1zm7 64h-1v-1h1z",
    fill: "#b2aeab"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M46 15v1h-1v-1zm3 0v1h-1v-1zm17 11v1h-1v-1zm-9 37h1v1h-1zm-5 18v-1h1v1zm2 9h1v1h-1z",
    fill: "#7a7975"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M60 15v1h-1v-1zm-26 9h-1v-1h1zm37 2h1v1h-1zm25 17h1v1h-1zM76 78v-1h1v1zm0 3v-1h1v1z",
    fill: "#92918d"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M84 16v-1h1v1zm-7 12v-1h1v1zm0 7h1v1h-1zm-24 8h1v1h-1zm25 20v1h-1v-1zm18 19h-1v-1h1z",
    fill: "#a39f9c"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M42 16h1v1h-1zm57 1v1h-1v-1zM68 50v-1h1v1zm-11 1h1v1h-1zm-25 5h-1v-1h1zm53 59v1h-1v-1z",
    fill: "#9e9d9b"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M50 17v-1h1v1zm49-1v1h-1v-1zM75 53v-1h1v1zM54 71v-1h1v1zm22 13v-1h1v1zm-1 9h1v1h-1z",
    fill: "#999894"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M32 98h1v2h-1v-1zm48-82h1v1h-1zm3 33v-1h1v1zM32 91v-1h1v1zm0 10h1v1h-1z",
    fill: "#d6d1ce"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M36 18v-1h1v1zm57 5h1v1h-1zM32 53h-1v-1h1zm35 3h1v1h-1zm0 20v-1h1v1zm-8 2h1v1h-1z",
    fill: "#787775"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45v1h-2v-1h1zM39 17h1v1h-1zm30 31h1v1h-1zm1 24v1h-1v-1zM60 91h1v1h-1z",
    fill: "#acaba9"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M32 61v1h-1v-2h1zm12-44h1v1h-1zM32 54v1h-1v-1zm40 19v-1h1v1zM58 91v1h-1v-1z",
    fill: "#c4c3c1"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19h-2v-1h2zm-2 6v1h-1v-1zm12 45v-1h1v1zm-8 3v1h-1v-1zm1 1v1h-1v-1z",
    fill: "#d6d5d2"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M93 18v1h-1v-1zM51 48h-1v-1h1zm12 51v1h-1v-1zm-2 2v-1h1v1zm3-1h1v1h-1zm3 5v1h-1v-1z",
    fill: "#c2bebb"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20v-1h1v1zm60 2v1h-1v-1zm-34 8v1h-1v-1zm13 10v-1h1v1zm-17 8v-1h1v1zm13 70v-1h1v1z",
    fill: "#575652"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M52 107v2h-1v-2zm18-88v1h-1v-1zM34 92v-1h1v1zm1 6v1h-1v-1zm0 9v1h-1v-1z",
    fill: "#d6d4d0"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M95 19v1h-1v-1zM34 41v-1h1v1zm2 10h-1v-1h1zm40 7v-1h1v1zm-25 5v1h-1v-1zm4 31h1v1h-1z",
    fill: "#a8a7a3"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M97 20v-1h1v1zm-25 5h1v1h-1zM60 35h1v1h-1zm15 52h-1v-1h1zm-4 6v1h-1v-1zm20 6h-1v-1h1z",
    fill: "#51504c"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M60 76h1v1h-2v-1zM38 24v-1h1v1zm0 35v-1h1v1zm19 21h-1v-1h1zm6 3v-1h1v1z",
    fill: "#dbdad8"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v-1h1v1zm15 37h-1v-1h1zm-4 0h1v1h-1zm1 18h1v1h-1zm0 5v1h-1v-1zm-22 5h1v1h-1z",
    fill: "#a5a4a0"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M62 94h-1v-1h2v1zm23-71h1v1h-1zM74 49h1v1h-1zM52 75v-1h1v1zm3 12h1v1h-1z",
    fill: "#767571"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M86 24v-1h1v1zm3-1v1h-1v-1zm3 2h-1v-1h1zm-27 0v1h-1v-1zm-6 68v1h-1v-1zm5 0v1h-1v-1z",
    fill: "#71706c"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M41 25h-1v-1h1zm-3 23v1h-1v-1zm8 8h1v1h-1zm24 24h-1v-1h1zm0 5h1v1h-1zm-3 8v-1h1v1z",
    fill: "#cbcac8"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M65 26v-1h1v1zm26 21v1h-1v-1zm-16 4v-1h1v1zm-1 19h1v1h-1zm-20 2v-1h1v1zm33 37h1v1h-1z",
    fill: "#605f5b"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M38 26v2h-1v-2zm3 9h2v1h-2zm1-8h1v1h-1zm-4 5h1v1h-1z",
    fill: "#fefefe"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27v-1h1v1zM55 49v1h-1v-1zm22 31h1v1h-1zm9 4h-1v-1h1zm-2 5h1v1h-1zm-8 21v-1h1v1z",
    fill: "#b0afab"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M84 34v-2h2v1h-1v1zm0-4v1h-1v-1zm1 17h1v1h-1zM44 68v1h-1v-1z",
    fill: "#f9f5f2"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M76 32h-1v-1h1zm-19 1v1h-1v-1zm17 6h1v1h-1zm18 46v-1h1v1zm-2 1v-1h1v1zm-3 16h1v1h-1z",
    fill: "#807b78"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35h-1v-2h1v1zm-34 2h-1v-1h1zm34 22v1h-1v-1zm-1 25h1v1h-1zm-2 4h1v1h-1z",
    fill: "#75706d"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M45 38v1h-1v-2h1zm0-3h-1v-1h1zm-1 16v1h-1v-1zm0 7v-1h1v1zm-1 16h1v1h-1z",
    fill: "#fefefc"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v-1h1v1zm1 3h-1v-1h1zm1 0v1h-1v-1zm37 26v1h-1v-1zm0 11h-1v-1h1zm-2 9v-1h1v1z",
    fill: "#8e8986"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M45 35v2h-2v-2zm-3 36v1h-1v-1zm0 16v-1h1v1z",
    fill: "#fdfdfb"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35v1h-1v-1zm-28 6h1v1h-1zm0 21h-1v-1h1zm-2 2v-1h1v1zm0 30h1v1h-1zm15 22h1v1h-1z",
    fill: "#676664"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36v1h-1v-1zm-8 2h1v1h-1zm3 6v1h-1v-1zm-3 6h1v1h-1zm7 8v1h-1v-1zm-1 2h1v1h-1z",
    fill: "#faf9f7"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v1h-1v-1zM80 47h-1v-1h1zm11 20h-1v-1h1zm4 4h1v1h-1zm1 4v-1h1v1zm-13 31h1v1h-1z",
    fill: "#b2aca9"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v-1h1v1zm-6 10h1v1h-1zm20 21h1v1h-1zm2 6v1h-1v-1zm-22 4h-1v-1h1zm7 13h1v1h-1z",
    fill: "#63625e"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39v1h-1v-1zm-13 4h1v1h-1zm33 4h1v1h-1zm1 8h1v1h-1zM57 88v-1h1v1zm35 6v1h-1v-1z",
    fill: "#555450"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M41 100v2h-1v-2zm43-61v1h-1v-1zM43 64v1h-1v-1zm41 25h-1v-1h1zm-44 9v1h-1v-1z",
    fill: "#f7f6f2"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M40 41h-1v-1h1zm4 1h-1v-1h1zm-4 12h1v1h-1zm2 3h-1v-1h1zm-2 4h-1v-1h1zm5 14v1h-1v-1z",
    fill: "#f8f7f5"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M39 98v-2h1v1h1v1zm44-58h2v1h-2zm1 45h1v1h-1z",
    fill: "#f8f7f3"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45v1h-2v-1h1zM57 66h1v1h-2v-1zm15-13h-1v-1h1zm1 9v1h-1v-1z",
    fill: "#adacaa"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M79 45v1h-1v-1zm-30 4h1v1h-1zm-16 5h1v1h-1zm58 16v1h-1v-1zm-8 8v1h-1v-1zm1 26h-1v-1h1z",
    fill: "#bcb7b4"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M67 50h-1v-1h1zm-10 2h-1v-1h1zm12 7v-1h1v1zm3 18v-1h1v1zm-3 13h-1v-1h1zm1 2h-1v-1h1z",
    fill: "#a9a8a6"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49h1v1h-1zm-1 2h1v1h-1zm-13 3v1h-1v-1zm16 5h1v1h-1zm-7 27v1h-1v-1zm10 30h-1v-1h1z",
    fill: "#8e8d8b"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h1v1zm-6 25v1h-1v-1zm-9 6v1h-1v-1zm14 4v-1h1v1zm-4 2v-1h1v1zm20 27v1h-1v-1z",
    fill: "#757472"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v1h-1v-1zm33 27v-1h1v1zm3 2v1h-1v-1zm-3 7h-1v-1h1zm2-1v1h-1v-1zm-1 11v-1h1v1z",
    fill: "#d1d0ce"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M63 56h1v1h-1zm6 9v1h-1v-1zm2 2v-1h1v1zm-4 4h-1v-1h1zm3 5h-1v-1h1zm-5 11v-1h1v1z",
    fill: "#8b8a88"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v-2h1v2zm1 7v-1h2v1h-1zm33-56h1v1h-1zm-34 51h1v1h-1z",
    fill: "#d3cecb"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M66 59v1h-4v-1h1zm-4 11h-1v-1h1zm4 18v1h-1v-1z",
    fill: "#bebdbb"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M70 114v-2h1v2zM50 81h-1v-1h1zm13 19v-1h1v1zm6 7v-1h1v1zm10 0v1h-1v-1z",
    fill: "#c1bdba"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88v-3h1v3zm0-5v-2h1v2zm1 7h-1v-1h1z",
    fill: "#d6d2cf"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M36 93h1v3h-1v-1zm0-8v-2h1v2zm0 2v-1h1v1z",
    fill: "#dcdcd8"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M48 11v-1h1v1zm41 33h-1v-1h1zm-1 9v1h-1v-1zm-1 29h-1v-1h1zm-39 29v1h-1v-1z",
    fill: "#e1ddda"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M62 12v-2h2v1h-1v1zm32 85h-1v-1h1zm-1 1h-1v-1h1z",
    fill: "#42413d"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M64 12v-1h1v1zm-4 22h1v1h-1zm11 6v-1h1v1zM56 72h-1v-1h1zm15 45v1h-1v-1z",
    fill: "#4b4a46"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M74 11v1h-1v-1zm3 22h-1v-1h1zm14 6h1v1h-1zm2 33h-1v-1h1zm1 9h-1v-1h1z",
    fill: "#86817e"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13h-1v-1h1zm8 44v1h-1v-1zm-21 4h-1v-1h1zm37 33h-1v-1h1zm-29 25h1v1h-1z",
    fill: "#696864"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M67 12h1v2h-1v-1zm30 27v1h-1v-1zM75 75v-1h1v1zm-7 43h-1v-1h1z",
    fill: "#6b6a66"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M77 12h1v1h-1zm15 54h1v1h-1zm-2 13v-1h1v1zm-2 10h1v1h-1zm-12 24h1v1h-1z",
    fill: "#9c9794"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M91 13h-1v-1h1zM40 59h1v1h-1zm1 18v-1h1v1zm0 2h1v1h-1zm3 13h-1v-1h1z",
    fill: "#f4f3f1"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M47 14v-1h1v1zm16 18h1v1h-1zm-4 19h-1v-1h1zm4 24v-1h1v1zm30 29h-1v-1h1z",
    fill: "#333230"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M93 13v1h-1v-1zm-54 9h1v1h-1zm2 4v-1h1v1zm-5 5v-1h1v1zm8 52h-1v-1h1z",
    fill: "#e2e1de"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14v1h-1v-1zm9 37h1v1h-1zm3 14v1h-1v-1zM56 84h1v1h-1zm22 34h-1v-1h1z",
    fill: "#7c7b79"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14h1v1h-1zm7 13h-1v-1h1zm4 0v1h-1v-1zm3 24v1h-1v-1zm5 15v1h-1v-1z",
    fill: "#868583"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M57 16h-1v-2h1v1zm25 7h1v1h-1zM55 44h1v1h-1zm3 42h1v1h-1z",
    fill: "#898884"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M59 14v1h-1v-1zm21 10v1h-1v-1zm-3 25v1h-1v-1zm-43 2h-1v-1h1zm41 20h1v1h-1z",
    fill: "#807f7b"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M59 15v-1h1v1zm31 33h-1v-1h1zm-13 3h-1v-1h1zm-1 19h1v1h-1zm11 39h-1v-1h1z",
    fill: "#7e7d79"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M78 112h1v1h-2v-1zm-3-98h1v1h-1zm0 2h-1v-1h1zm0 96h1v1h-1z",
    fill: "#a5a09d"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16v-1h1v1zm20 31h-1v-1h1zm-7 10v-1h1v1zm11 14v-1h1v1zm6 10v1h-1v-1z",
    fill: "#898886"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M61 56h1v1h-2v-1zM45 16h-1v-1h1zm23 51v-1h1v1zm-4 6v-1h1v1z",
    fill: "#949391"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15v1h-1v-1zm-18 3v1h-1v-1zm35 7h-1v-1h1zm-9 0v1h-1v-1zm7 69h1v1h-1z",
    fill: "#888783"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M42 17h-1v-1h1zm22 32v-1h1v1zm-4 23h1v1h-1zm7 1v-1h1v1zm-4 19h-1v-1h1z",
    fill: "#a09f9d"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16h1v1h-1zm50 29h-1v-1h1zM56 55v-1h1v1zm15 7v-1h1v1zm-1 8h1v1h-1z",
    fill: "#797876"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M61 115v2h-1v-2zm18-99h1v1h-1zM33 78v1h-1v-1zm21 29h1v1h-1z",
    fill: "#d2cdca"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M44 17v1h-1v-1zm15 30v-1h1v1zm6 20v-1h1v1zm4-1h1v1h-1zm-7 21h-1v-1h1z",
    fill: "#939290"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18v-1h3v1zm15 27v1h-1v-1zm-11 7v-1h1v1z",
    fill: "#cac5c2"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18v-1h1v1zm-24 5h-1v-1h1zm36 54v1h-1v-1zm-1 7v-1h1v1zm-19 31v-1h1v1z",
    fill: "#b9b4b1"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M69 88h2v1h-2zM40 18v1h-1v-1zm-7 23v1h-1v-1zm37 55v1h-1v-1z",
    fill: "#c6c5c2"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M52 110v1h-1v-2h1zm15-92v1h-1v-1zm9 2h-1v-1h1zm6 78h1v1h-1z",
    fill: "#d5d3d0"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M91 18v1h-1v-1zm-9 37v1h-1v-1zM60 99v1h-1v-1zm3 2v1h-1v-1zm0 2h1v1h-1z",
    fill: "#c4c0bd"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M91 19v-1h1v1zM81 45h-1v-1h1zm-32 4v-1h1v1zm-1 30v-1h1v1zM38 89h1v1h-1z",
    fill: "#e2dedb"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20v-1h1v1zm-5 20v-1h1v1zm22 31v1h-1v-1zm-2 46v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#93928e"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v1h-1v-2h1zm0-20v1h-1v-1zm33 4v-1h1v1zm9 63v-1h1v1z",
    fill: "#a09f9b"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23v-1h1v1zm-12 1h1v1h-1zM37 56h-1v-1h1zm51 20v-1h1v1zm-24 39v1h-1v-1z",
    fill: "#cdcbc7"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h-1v-1h1zm-38 5v1h-1v-1zm17 36h1v1h-1zm31 24h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#aeada9"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M97 24h-1v-1h1zm-29 4h1v1h-1zm0 19h1v1h-1zm-4 24h1v1h-1zm6 1h-1v-1h1z",
    fill: "#141311"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24h1v1h-1zm27 11h1v1h-1zm0 2h1v1h-1zm34 3v1h-1v-1zm-15 4h-1v-1h1z",
    fill: "#716c69"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90h-1v-1h2v1zM45 25h1v1h-1zm12 33h1v1h-1zm1 34v-1h1v1z",
    fill: "#bbbab8"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h1v1h-1zm4 12v1h-1v-1zM58 47v1h-1v-1zm33 51h1v1h-1zm-18 20v-1h1v1z",
    fill: "#474642"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h-1v-1h1zm-11 7h1v1h-1zm2 3v-1h1v1zm31 59v1h-1v-1zm-21 22h1v1h-1z",
    fill: "#484743"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27v1h-1v-1zm13 22v1h-1v-1zm-7 16h1v1h-1zm3 6v-1h1v1zm-1 15v1h-1v-1z",
    fill: "#7f7e7c"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27h1v1h-1zm-1 25v-1h1v1zm-5 13v1h-1v-1zm6 5v1h-1v-1zm4 14h1v1h-1z",
    fill: "#878684"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M70 28v1h-1v-1zm-5 19v1h-1v-1zm1 3h1v1h-1zm-3 21v1h-1v-1zm8 3v1h-1v-1z",
    fill: "#181715"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30v-1h1v1zm4 10v1h-1v-1zm34 20h1v1h-1zm-17 5v-1h1v1zm11 25v-1h1v1z",
    fill: "#8c8784"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M88 32v-1h1v1zm-7 16h-1v-1h1zm-32 4v-1h1v1zm39 26v1h-1v-1zM38 90h-1v-1h1z",
    fill: "#e4dfdc"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32h-1v-1h1zM66 45v-1h1v1zm-4 23h1v1h-1zm-5 7h-1v-1h1zm38 25h-1v-1h1z",
    fill: "#373634"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32v-1h1v1zm-4 2h1v1h-1zm-28 8h-1v-1h1zm6 15v-1h1v1zm0 12v-1h1v1z",
    fill: "#595856"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M46 101v2h-1v-2zm41-68v-1h1v1zm-4 25h-1v-1h1zM39 91h1v1h-1z",
    fill: "#f4f0ed"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M54 33h1v1h-1zm2 5v1h-1v-1zm21 1h-1v-1h1zm-21 1v-1h1v1zm36 35v-1h1v1z",
    fill: "#95908d"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v-1h1v1zm-7 6h-1v-1h1zm1 10h1v1h-1zm-1 3h1v1h-1zm1 9h-1v-1h1z",
    fill: "#eeedeb"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36h-1v-2h1v1zm-8 7v-1h1v1zm-4 42h-1v-1h1zm12 1v1h-1v-1z",
    fill: "#4d4c4a"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M93 37v-1h1v1zM71 86v1h-1v-1zm1 1h1v1h-1zm-5 8v-1h1v1zm19 21v-1h1v1z",
    fill: "#61605e"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v-1h1v1zm0 9v-1h1v1zm5 11h1v1h-1zm3 20v-1h1v1zm-1 3v1h-1v-1z",
    fill: "#f0efed"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M62 37h1v1h-1zm-7 28v-1h1v1zm19 29h-1v-1h1zm16 4v-1h1v1zm-22 20v1h-1v-1z",
    fill: "#565551"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h1v1h-1zm9 2h1v1h-1zm5 13v1h-1v-1zm18 41h-1v-1h1zm-29 25h1v1h-1z",
    fill: "#4f4e4a"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M39 40h-1v-1h1zm1 10h-1v-1h1zm2 3h1v1h-1zm0 9v-1h1v1zm1 28h-1v-1h1z",
    fill: "#f9f8f6"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1zm4 6v-1h1v1zm-1 8v-1h1v1zm19 54h-1v-1h1zm-14 9h-1v-1h1z",
    fill: "#4e4d4b"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M60 42h1v1h-1zm35 2h1v1h-1zM68 56h1v1h-1zm-2 20h-1v-1h1zm-6 8v-1h1v1z",
    fill: "#72716f"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M68 100v1h-2v-1h1zm21-58h1v1h-1zm-11 3v-1h1v1zm2 66v-1h1v1z",
    fill: "#bfbab7"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M87 45h-1v-1h1zm-6 4v-1h1v1zm-32 3h-1v-1h1zm-1 29h1v1h-1zm0 22v1h-1v-1z",
    fill: "#e4e0dd"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M38 45v1h-1v-1zm1 6v1h-1v-1zm19 4h1v1h-1zm4 22h-1v-1h1zm-3 9v-1h1v1z",
    fill: "#dad9d7"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45h1v1h-1zm2 14v1h-1v-1zm6 15h-1v-1h1zm6 8h1v1h-1zm-4 7h-1v-1h1z",
    fill: "#c2c1bf"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M83 45h1v1h-1zm5 1h-1v-1h1zm0 2h-1v-1h1zM32 80h1v1h-1zm1 11h1v1h-1z",
    fill: "#d5d0cd"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46h1v1h-1zm-21 2h-1v-1h1zm40 10v-1h1v1zM52 86h1v1h-1zm2 4v1h-1v-1z",
    fill: "#8d8c88"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46v1h-1v-1zm-9 22v1h-1v-1zm5 8v-1h1v1zm6 2v1h-1v-1zm-5 5h1v1h-1z",
    fill: "#71706e"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47v-1h1v1zm-6 15h-1v-1h1zm2 21h1v1h-1zm24 30v-1h1v1zm0 1h1v1h-1z",
    fill: "#6e6d6b"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49v-1h1v1zm5 0v1h-1v-1zm-35 6v1h-1v-1zm38 19v-1h1v1zm-2 16v-1h1v1z",
    fill: "#a2a19f"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M73 48v1h-1v-1zm-4 4v1h-1v-1zm5 7h-1v-1h1zm-7 30h-1v-1h1zm-33 23v-1h1v1z",
    fill: "#bdbcba"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70v1h-2v-1h1zM34 49v1h-1v-1zm17 37h1v1h-1zm24 4h1v1h-1z",
    fill: "#9d9c98"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M69 49h1v1h-1zm3 10v1h-1v-1zm-6 8v-1h1v1zm-2 5v1h-1v-1zm18 44v1h-1v-1z",
    fill: "#959492"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M94 51h-1v-1h1zM71 65h1v1h-1zm-6 7h1v1h-1zm6 4h-1v-1h1zm-5 15v1h-1v-1z",
    fill: "#989795"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M38 51v1h-1v-1zm29 5v-1h1v1zm-35 7h-1v-1h1zm34 10v1h-1v-1zm3 4h-1v-1h1z",
    fill: "#c5c4c2"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M37 68h2v1h-2zm14-17v1h-1v-1zm-15 2h-1v-1h1zm10 59h1v1h-1z",
    fill: "#e2ddda"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51v1h-1v-1zm-3 24h1v1h-1zm-3 7h-1v-1h1zm19 34h-1v-1h1zm7 0v-1h1v1z",
    fill: "#81807e"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M80 109h1v1h-2v-1zm6-58h1v1h-1zm-50 2v1h-1v-1zm50 43v1h-1v-1z",
    fill: "#c3bebb"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M63 52h1v1h-1zm0 3v1h-1v-1zm6 30h1v1h-1zm-3 7h1v1h-1zm-29 20h-1v-1h1z",
    fill: "#cccbc9"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56v-1h4v1h-1zm-4 0h-1v-1h1z",
    fill: "#c8c7c5"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M71 66v1h-1v-2h1zm-11-9h-1v-1h1zm6 14h-1v-1h1zm-7 4v1h-1v-1z",
    fill: "#91908e"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1zm5 2h1v1h-1zM39 69v-1h1v1zm-1 21v1h-1v-1zm10 6v1h-1v-1z",
    fill: "#e8e3e0"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58v-1h1v1zm27 1v1h-1v-1zm14 20v1h-1v-1zm-7 9v1h-1v-1zm3 0v1h-1v-1z",
    fill: "#bfbebc"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M48 57h1v1h-1zM32 68v1h-1v-1zm0 3h-1v-1h1zm32 5h1v1h-1zm5 7v-1h1v1z",
    fill: "#d3d2d0"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57h1v1h-1zm-1 24h-1v-1h1zM47 93h-1v-1h1zm-1 10h1v1h-1zm-1 9v1h-1v-1z",
    fill: "#ece8e5"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M71 63h-1v-1h2v1zm-1-5h1v1h-1zm-2 2v-1h1v1zm-6 7h-1v-1h1z",
    fill: "#afaeac"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62h2v1h-2zm2-2h-1v-1h1zm-4 9h1v1h-1zm5 4h1v1h-1z",
    fill: "#b4b3b1"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M88 62v-1h1v1zm-4 31h1v1h-1zm-18 6v1h-1v-1zm1 0h1v1h-1zm17 3v-1h1v1z",
    fill: "#bbb8b5"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98v-2h1v2zM37 67v-1h1v1zm13 15h-1v-1h1zm-2 12h-1v-1h1z",
    fill: "#e0ddda"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M90 68h-1v-2h1v1zm-12 40h1v1h-1zm3 1h1v1h-1zm-10 2h1v1h-1z",
    fill: "#beb8b5"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M57 107h-1v-2h1v1zm31-34v-1h1v1zm-39 5h-1v-1h1zm34 25h-1v-1h1z",
    fill: "#c9c7c3"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74h-1v-1h2v1zm-1 3v-1h1v1zm0 5h1v1h-1zm-39 2h-1v-1h1z",
    fill: "#faf9f5"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96v-1h2v1h-1zM47 79h1v1h-1zm-3 35v1h-1v-1zm-4 1h1v1h-1z",
    fill: "#d3d1ce"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M34 95h1v3h-1zm13-14v-1h1v1zm-12 9v1h-1v-1z",
    fill: "#d6d4d1"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85h1v2h-1v-1zm1 12v1h-1v-2h1zm-1-4h1v1h-1z",
    fill: "#d7d3cf"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M91 10v1h-1v-1zm9 14v1h-1v-1zM30 53v1h-1v-1zm69 0v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M64 11v1h-1v-1zm-1 27v-1h1v1zm32-1h1v1h-1zM74 87h-1v-1h1z",
    fill: "#454441"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M88 37v-2h1v2zm-9-25v-1h1v1zm10 14h1v1h-1z",
    fill: "#d9d4d1"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M81 12v-1h1v1zM47 93v1h-1v-1zm-1 20h-1v-1h1zm0 1h1v1h-1z",
    fill: "#e6e2df"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12h1v1h-1zm0 12v1h-1v-1zm-9 42h1v1h-1zm36 11h-1v-1h1z",
    fill: "#cecdcb"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M57 12h1v1h-1zm16 25v1h-1v-1zm2 20h-1v-1h1zm20 36v1h-1v-1z",
    fill: "#53524e"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13h-1v-1h1zm35 35v1h-1v-1zm-6 48h-1v-1h1zm-26 22v1h-1v-1z",
    fill: "#5c5b57"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M63 12h1v1h-1zm-4 20h-1v-1h1zm37 13h1v1h-1zm-6 49h1v1h-1z",
    fill: "#62615d"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M72 13v-1h1v1zm19 23v-1h1v1zm-16 1h-1v-1h1zm14 60v1h-1v-1z",
    fill: "#7a7572"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M80 13v-1h1v1zm0 33h-1v-1h1zm8 32h1v1h-1zm0 2h-1v-1h1z",
    fill: "#c9c4c1"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13h1v1h-1zm25 49v-1h1v1zm3-1h1v1h-1zm25 40v1h-1v-1z",
    fill: "#565553"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M40 13v1h-1v-1zm20 68h-1v-1h1zm7 0h1v1h-1zm8 36h-1v-1h1z",
    fill: "#504f4d"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14h-1v-1h1zm22 40v1h-1v-1zm-5 40v1h-1v-1zm22 6h1v1h-1z",
    fill: "#5a5957"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13h1v1h-2v-1zm9 29h-1v-1h1zm4 22h-1v-1h1z",
    fill: "#737270"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M55 14v-1h1v1zM31 43v-1h1v1zm24 51h-1v-1h1zm10-1v1h-1v-1z",
    fill: "#706f6b"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M72 14v-1h1v1zM57 34h1v1h-1zm36 56v-1h1v1zm-5 15h-1v-1h1z",
    fill: "#7b7673"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M29 14h1v1h-1zm70 41h-1v-1h1zm-2 31h1v1h-1zm-45 34h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M52 15v-1h1v1zm38 7v1h-1v-1zM32 32v1h-1v-1zm43 59h-1v-1h1z",
    fill: "#72716d"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M80 14v1h-1v-1zM53 25h1v1h-1zm0 10v-1h1v1zm34 57h1v1h-1z",
    fill: "#9f9a97"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M86 15h-1v-1h1zm3 3h1v1h-1zm-58 8v1h-1v-1zm47 16h-1v-1h1z",
    fill: "#b5b1ae"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M82 15h1v1h-1zm-5 12h-1v-1h1zm15 39h-1v-1h1zm1 6v1h-1v-1z",
    fill: "#a49f9c"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M96 16v-1h1v1zM51 36h1v1h-1zm27 6v-1h1v1zm2 9h-1v-1h1z",
    fill: "#bcbab6"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M47 17h-1v-1h1zm43 7v1h-1v-1zM34 45v-1h1v1zm49 46v-1h1v1z",
    fill: "#acaba7"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M52 16v1h-1v-1zm-5 1h1v1h-1zm18 6h1v1h-1zm5 0v1h-1v-1z",
    fill: "#a4a39f"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h1v1h-1zm20 54h1v1h-1zm-21 31h1v1h-1zm0 2h-1v-1h1z",
    fill: "#c2bcb9"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16v1h-1v-1zm15 50h-1v-1h1zm2 6h1v1h-1zm-1 8v-1h1v1z",
    fill: "#afaaa7"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M57 110h1v1h-2v-1zm10-92h-1v-1h1zm-4 79v-1h1v1z",
    fill: "#cdcac7"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M88 17h1v1h-1zM53 44h-1v-1h1zm-18 7h1v1h-1zm42 15h1v1h-1z",
    fill: "#aba7a4"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M90 18h-1v-1h1zm-36 7v-1h1v1zm35 40h1v1h-1zm1 4h-1v-1h1z",
    fill: "#bbb5b2"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18v1h-1v-1zm10 60v-1h1v1zm-36 4h1v1h-1zm33 12h1v1h-1z",
    fill: "#d3d1cd"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M97 22h1v1h-1zM64 50v1h-1v-1zm4 10h1v1h-1zm5 7h1v1h-1z",
    fill: "#1e1d1b"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45h1v1h-2v-1zM54 23h1v1h-1zm-20 85h-1v-1h1z",
    fill: "#dad5d2"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h1v1h-1zm-5 31h1v1h-1zM34 98h-1v-1h1zm19 6h1v1h-1z",
    fill: "#d4cfcc"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101v1h-1v-2h1zm8-77h1v1h-1zm-8 82v1h-1v-1z",
    fill: "#d8d8d4"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h1v1h-1zm2 29h1v1h-1zm15 0v1h-1v-1zm5 41h-1v-1h1z",
    fill: "#6f6e6a"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25h-1v-1h1zM35 44h1v1h-1zm40 33h-1v-1h1zm-4 40h-1v-1h1z",
    fill: "#9f9e9a"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M56 26h-1v-1h1zm1 0v1h-1v-1zm20 7v-1h1v1zm13 11v-1h1v1z",
    fill: "#999592"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26h1v1h-1zm7 5h-1v-1h1zM42 94v-1h1v1zm5 7v-1h1v1z",
    fill: "#e6e1de"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28h-1v-1h1zm39 18h1v1h-1zm-2 1v1h-1v-1zM41 89h-1v-1h1z",
    fill: "#fffefb"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M51 28v-1h1v1zm3 14h1v1h-1zm38 15v1h-1v-1zm-6 23h1v1h-1z",
    fill: "#a6a29f"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27v1h-1v-1zm1 10h1v1h-1zm18 4v-1h1v1zm17 46v1h-1v-1z",
    fill: "#85807d"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M64 28h-2v-1h2zm5-1v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#838280"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M75 27v1h-1v-1zm-18 9h-1v-1h1zm1 1v1h-1v-1zm29 67v-1h1v1z",
    fill: "#7c7774"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v-1h1v1zm0 5v-1h1v1zm-16 6v1h-1v-1zm37 52h-1v-1h1z",
    fill: "#837e7b"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27h1v1h-1zm10 42h1v1h-1zm-34 9v1h-1v-1zm9 39v-1h1v1z",
    fill: "#cccac6"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29v-1h1v1zm0 19h-1v-1h1zm-8 10h-1v-1h1zm9 2h1v1h-1z",
    fill: "#171614"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M76 28v1h-1v-1zm15 16v-1h1v1zm-1 0h1v1h-1zm-2 63v1h-1v-1z",
    fill: "#6e6a67"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M84 29v-1h1v1zm3 14h1v1h-1zm-2 3h1v1h-1zM43 93v-1h1v1z",
    fill: "#fcf8f5"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M32 30v-1h1v2h-1zm66 10h-1v-1h1zM59 87v-1h1v1z",
    fill: "#8c8b88"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30v-1h1v1zm-2 17h1v1h-1zm-1 30v1h-1v-1zm36 22v1h-1v-1z",
    fill: "#4e4d49"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29h1v2h-1v-1zm-16 9v1h-1v-1zm31 53h1v1h-1z",
    fill: "#77726f"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M54 31h1v1h-1zm37 30h-1v-1h1zm-4 29v-1h1v1zm-1 15h1v1h-1z",
    fill: "#8f8a87"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M60 31h1v1h-1zm2 44h-1v-1h1zm9 9v-1h1v1zm-7 1v-1h1v1z",
    fill: "#363534"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v-1h1v1zm40 6v-1h1v1zM35 83h-1v-1h1zm0 5h-1v-1h1z",
    fill: "#d9d7d3"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M98 33h-1v-1h1zM63 43v-1h1v1zm6 18v1h-1v-1zm10 55h-1v-1h1z",
    fill: "#605f5d"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v-1h1v1zm39 30h-1v-1h1zm0 8h-1v-1h1zm-14 40h-1v-1h1z",
    fill: "#aaa4a1"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34v-1h1v1zm-17 5h-1v-1h1zm31 57h-1v-1h1zm-1 6h-1v-1h1z",
    fill: "#847f7c"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34v1h-1v-1zm1 43v1h-1v-1zm20 8h1v1h-1zm-22 26v-1h1v1z",
    fill: "#dddcd9"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M56 35v-1h1v1zm20 28h1v1h-1zm17 20h1v1h-1zm-1 4v-1h1v1z",
    fill: "#817c79"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34h1v1h-1zm17 3v1h-1v-1zm-35 2h1v1h-1zm36 32v-1h1v1z",
    fill: "#888380"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v1h-1v-1zm4 6h-1v-1h1zm-2 1h-1v-1h1zm3 35h1v1h-1z",
    fill: "#f1f0ee"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h-1v-1h1zm-3 4h1v1h-1zM51 54v-1h1v1zm43 10h-1v-1h1z",
    fill: "#8d8885"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v1h-3v-1zm-2 46v1h-1v-1z",
    fill: "#f5f5f1"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M96 37h-1v-1h1zm-34 6v1h-1v-1zm-7 14h1v1h-1zm18 6v1h-1v-1z",
    fill: "#444341"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M71 38h1v1h-1zM57 65h-1v-1h1zm15 28v1h-1v-1zm19 4h1v1h-1z",
    fill: "#4a4945"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M47 39h1v1h-1zm1 7h-1v-1h1zm-11 0v1h-1v-1zm7 28h-1v-1h1z",
    fill: "#e4e3e0"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M63 40h-1v-1h1zm28 13h1v1h-1zM54 80h1v1h-1zm9 15v-1h1v1z",
    fill: "#585753"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M77 40v-1h1v1zm2 13v-1h1v1zm12 21v-1h1v1zm-8 36h-1v-1h1z",
    fill: "#b2adaa"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41v1h-1v-1zm-2 6h1v1h-1zm26 32v1h-1v-1zm-1 3h1v1h-1z",
    fill: "#dcdbd9"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h-1v-1h1zm34 9v-1h1v1zm2 35h1v1h-1zm-2 5v-1h1v1z",
    fill: "#b4afac"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41h1v1h-1zm7 15h1v1h-1zm-8 5v1h-1v-1zm5 18h-1v-1h1z",
    fill: "#696866"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42h-1v-1h1zm-4 1h-1v-1h1zM49 97v-1h1v1zm-12 2h-1v-1h1z",
    fill: "#d9d9d5"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42v-1h1v1zM61 96h-1v-1h1zm-26 4v1h-1v-1zm46 0h1v1h-1z",
    fill: "#d4d2ce"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43v-1h1v1zm18 18h1v1h-1zm2 3h1v1h-1zm-11 50h-1v-1h1z",
    fill: "#898380"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45v-1h1v1zm9 1h1v1h-1zm15 6h1v1h-1zm5 34h-1v-1h1z",
    fill: "#d2d1cf"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M33 45v1h-1v-1zm62 11v1h-1v-1zm-36 9v1h-1v-1zm15 12h-1v-1h1z",
    fill: "#a09f9c"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45h1v1h-1zm1 3h1v1h-1zm-7 10v1h-1v-1zm-1 13v-1h1v1z",
    fill: "#a7a6a4"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45h1v1h-1zm0 4h-1v-1h1zm5 3h-1v-1h1zm-5 7v-1h1v1z",
    fill: "#a3a2a0"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46h1v1h-1zM54 64v-1h1v1zm35 31v-1h1v1zm-23 23h-1v-1h1z",
    fill: "#73726e"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h-1v-1h1zm-1 21v1h-1v-1zm10 6h-1v-1h1zm1 3h-1v-1h1z",
    fill: "#a4a3a1"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49v1h-1v-1zm-5 11v-1h1v1zm17 9v1h-1v-1zm-5 4h1v1h-1z",
    fill: "#bcbbb9"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M63 50h-1v-1h1zm6 13h-1v-1h1zm0 7h-1v-1h1zm-33 41v1h-1v-1z",
    fill: "#b5b4b2"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v1h-1v-1zm7 3v-1h1v1zm-42 4h1v1h-1zm42 20h-1v-1h1z",
    fill: "#aeadab"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50h1v1h-1zm14 6h-1v-1h1zm-4 21v-1h1v1zm6 9h-1v-1h1z",
    fill: "#d6d5d3"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M70 51h1v1h-1zm-5 8h-1v-1h1zm3 7v1h-1v-1zm3 13v-1h1v1z",
    fill: "#969593"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52h1v1h-1zm0 5h-1v-1h1zm-3 4v1h-1v-1zm-2 2h-1v-1h1z",
    fill: "#ecebe9"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h-1v-1h1zm-1 2h1v1h-1zm-11 45h1v1h-1zm2 11v-1h1v1z",
    fill: "#bdb9b6"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M51 53v1h-1v-1zm44 14h1v1h-1zm1 5v1h-1v-1zm-10 34h-1v-1h1z",
    fill: "#a29c99"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M42 110v2h-1v-2zm41-57v1h-1v-1zM43 73v-1h1v1z",
    fill: "#f2f2ee"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56h-1v-1h1zm49-1v1h-1v-1zm1 27v-1h1v1zm-30 32h1v1h-1z",
    fill: "#d2cfcc"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86h-2v-1h2zM48 55v1h-1v-1zm-8 24v-1h1v1z",
    fill: "#dfdedb"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55h1v1h-1zm3 1v-1h1v1zm37 25v1h-1v-1zm-40 26v-1h1v1z",
    fill: "#dddad7"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55h1v1h-1zm-8 4h-1v-1h1zm-25 4v1h-1v-1zm30 26h-1v-1h1z",
    fill: "#c6c5c3"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57v1h-1v-1zm4 13v-1h1v1zm-8 37v1h-1v-1zm-1 4h-1v-1h1z",
    fill: "#b7b2af"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M65 58h1v1h-1zm-1 13v-1h1v1zm-1 21v-1h1v1zm22 24v-1h1v1z",
    fill: "#979694"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M62 60h-1v-1h1zm6 14h-1v-1h1zm2 3h-1v-1h1zm-7 11h1v1h-1z",
    fill: "#c0bfbd"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64h-1v-1h1zm-4 11h1v1h-1zm7 4v-1h1v1zm9 36v1h-1v-1z",
    fill: "#777674"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M76 67h-1v-1h1zm13 22h-1v-1h1zm0 5v1h-1v-1zm-2 12v1h-1v-1z",
    fill: "#8b8784"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M88 67h1v1h-1zm-8 14v1h-1v-1zm4 16h1v1h-1zm-20 8h-1v-1h1z",
    fill: "#c5c3bf"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M97 68h-1v-1h1zm-2 2h1v1h-1zm-6 3v-1h1v1zm2 1h-1v-1h1z",
    fill: "#afa9a6"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69v-1h1v1zm42 3v1h-1v-1zm-3 8h-1v-1h1zm2 6v-1h1v1z",
    fill: "#c7c6c3"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72h-1v-1h1zm21 26v1h-1v-1zm-3 2v-1h1v1zm-1 3h1v1h-1z",
    fill: "#3b3a37"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M95 74v-1h1v1zm-4 3h-1v-1h1zm5-1v1h-1v-1zm-10 28v1h-1v-1z",
    fill: "#a59f9c"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93v-1h1v2h-1zm1-5v1h-1v-1zm-1 3v-1h1v1z",
    fill: "#d5d1ce"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v-1h1v1zm1 2v1h-1v-1zm0 4v1h-1v-1zm-2 9h1v1h-1z",
    fill: "#e5e0dd"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M63 116v1h-1v-2h1zm-2-20h1v1h-1zm-6 11v-1h1v1z",
    fill: "#cfcbc8"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99v-1h2v1h-1zm8 0v2h-1v-2z",
    fill: "#babab6"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M55 111h1v2h-1v-1zM34 99v1h-1v-1zm25 15v1h-1v-1z",
    fill: "#d1cdca"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M61 114h2v1h-2zm21-12v-1h1v1zm-1 0h1v1h-1z",
    fill: "#ceccc8"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107h2v1h-2zm4-3h-1v-1h1zm-1 2v1h-1v-1z",
    fill: "#c6c2bf"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M68 104h1v2h-1v-1zm13 5h-2v-1h2z",
    fill: "#c3bdba"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M44 106v1h-2v-1h-1v-1h2v1z",
    fill: "#f4f2ee"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M78 9h-1V8h1zm21 12h1v1h-1zM31 98h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.031
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M79 9h-1V8h1zm21 17h-1v-1h1zM29 55v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M85 9h1v1h-1zM30 92h1v1h-1zm1 11h-1v-1h1z",
    fill: "#efefef",
    fillOpacity: 0.063
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10h1v1h-1zm34 67v1h-1v-1zm-34 33h1v1h-1z",
    fill: "#e0deda"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10v1h-1v-1zm4 27h-1v-1h1zm-5 50h1v1h-1z",
    fill: "#3d3c39"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M65 10h1v1h-2v-1zm-2 25h-1v-1h1z",
    fill: "#43423e"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M44 12h-1v-1h1zm-3 67v1h-1v-1zm-2 3h1v1h-1z",
    fill: "#fcfbf7"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M47 12v-1h1v1zm4 26h1v1h-1zm15 70h-1v-1h1z",
    fill: "#c4c2bf"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M58 12h-1v-1h1zm17 49h-1v-1h1zm-3 30v-1h1v1z",
    fill: "#3c3b37"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M60 12v-1h2v1h-1zm14 68h1v1h-1z",
    fill: "#403f3b"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M78 11v1h-1v-1zm8 38v-1h1v1zm0 50h-1v-1h1z",
    fill: "#bdb8b5"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13v-1h1v1zm15 29h1v1h-1zm-3 27h-1v-1h1z",
    fill: "#83827f"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M71 13v-1h1v1zM58 36h-1v-1h1zm17 0h-1v-1h1z",
    fill: "#736e6b"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M76 13h-1v-1h1zm-6 2h-1v-1h1zm26 40v1h-1v-1z",
    fill: "#898582"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M80 12v1h-1v-1zM52 39v-1h1v1zm38 3h1v1h-1z",
    fill: "#b8b3b0"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M51 14h-1v-1h1zm8 69v1h-1v-1zm18 32h1v1h-1z",
    fill: "#6a6967"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13h1v1h-1zm15 51v-1h1v1zm-4 20h-1v-1h1z",
    fill: "#706f6d"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M55 14h1v1h-1zm37 7h1v1h-1zm-11 4h-1v-1h1z",
    fill: "#8b8a86"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M71 14v1h-1v-1zm18 79h-1v-1h1zm-13 22v-1h1v1z",
    fill: "#94908d"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15v-1h1v1zM57 41v1h-1v-1zm28 65h1v1h-1z",
    fill: "#9c9895"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v-1h1v1zm15 0h1v1h-1zm1 33h-1v-1h1z",
    fill: "#a8a4a1"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M79 14v1h-1v-1zm-3 26v1h-1v-1zm13 51v1h-1v-1z",
    fill: "#96918e"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v1h-2v-1h1zM34 16v-1h1v1z",
    fill: "#0f0e0c"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16h-1v-1h1zm26 25h1v1h-1zm26 55h1v1h-1z",
    fill: "#5b5a58"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M53 16v-1h1v1zm5 40v1h-1v-1zm12 9v1h-1v-1z",
    fill: "#8c8b89"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15v1h-1v-1zm33 9v-1h1v1zM58 43v-1h1v1z",
    fill: "#8a8985"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16h-1v-1h1zm23 49h1v1h-1zm-7 40v-1h1v1z",
    fill: "#928d8a"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16v-1h1v1zm5 51h-1v-1h1zm-13 50h1v1h-1z",
    fill: "#8d8986"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M77 15h1v1h-1zM59 99v-1h1v1zm6 2v1h-1v-1z",
    fill: "#c4bfbc"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M81 16v-1h1v1zm9 11v-1h1v1zm-15 88v-1h1v1z",
    fill: "#989491"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M94 15h1v1h-1zM52 50h-1v-1h1zm39 5v1h-1v-1z",
    fill: "#bbb7b4"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17v-1h1v1zm1 35h1v1h-1zm69 33h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.027
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M72 17h-1v-1h1zm6 28v1h-1v-1zm-4 62h-1v-1h1z",
    fill: "#b8b6b3"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M84 16v1h-1v-1zM53 38h-1v-1h1zm37 45v1h-1v-1z",
    fill: "#b4aeab"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M39 18h-1v-1h1zm55 22v1h-1v-1zM68 63v1h-1v-1z",
    fill: "#6b6a68"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M29 19h-1v-1h1zm71 4h-1v-1h1zm-1 29v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.024
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19v-1h1v1zm29 36v1h-1v-1zM56 74h-1v-1h1z",
    fill: "#c4c3c0"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M83 19h-1v-1h1zm4 31h1v1h-1zM48 95h-1v-1h1z",
    fill: "#ddd8d5"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18v1h-1v-1zM51 37h1v1h-1zm38 35h-1v-1h1z",
    fill: "#c1bfbc"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M69 99h1v1h-2v-1zm25-81h1v1h-1z",
    fill: "#bbb8b4"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20h-1v-1h1zm29 14v-1h1v1zm12 49h1v1h-1z",
    fill: "#3e3d39"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M84 20h-1v-1h1zm5 6v-1h1v1zM37 69h-1v-1h1z",
    fill: "#dedcd8"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M32 61v-1h1v2h-1zm62-41v1h-1v-1z",
    fill: "#b0afac"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M98 20v1h-1v-1zM69 41v-1h1v1zm1 52v1h-1v-1z",
    fill: "#545350"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M31 23v-1h1v1zm43 10h1v1h-1zm17 55v-1h1v1z",
    fill: "#6a6562"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M53 23v-1h1v1zm3-1v1h-1v-1zm-3 21h-1v-1h1z",
    fill: "#bab6b3"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23v-1h1v1zm15 25v1h-1v-1zm-5 38h1v1h-1z",
    fill: "#a3a29e"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h1v1h-1zM33 44v-1h1v1zm32 74h-1v-1h1z",
    fill: "#7d7c78"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M94 23v-1h1v1zM60 52v-1h1v1zm-2 5v-1h1v1z",
    fill: "#8d8c8a"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M31 23v1h-1v-1zm22 19h-1v-1h1zm20 64v-1h1v1z",
    fill: "#b9b5b2"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24v-1h1v1zm39 24h1v1h-1zm-22 55v1h-1v-1z",
    fill: "#c6c1be"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M56 23h1v1h-1zm-6 29h1v1h-1zm34 28h1v1h-1z",
    fill: "#cbc6c3"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v1h-1v-1zM53 71h1v1h-1zm7 23h-1v-1h1z",
    fill: "#74736f"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23v1h-1v-1zm-60 9v1h-1v-1zm22 52h1v1h-1z",
    fill: "#8f8e8b"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24v1h-1v-1zm-7 41v1h-1v-1zm-2 11v-1h1v1z",
    fill: "#d9d8d3"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M54 24v1h-1v-1zm25 85v1h-1v-1zm-8 5v-1h1v1z",
    fill: "#bcb6b3"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25v-1h2v1h-1zm28 81v-1h1v1z",
    fill: "#b9b3b0"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v-1h1v1zM35 52h-1v-1h1zm30 52h1v1h-1z",
    fill: "#c3c0bd"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26v-1h1v1zm61 34v-1h1v1zm0 32h-1v-1h1z",
    fill: "#6b6663"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v1h-1v-1zm1 10v-1h1v1zm6 5v1h-1v-1z",
    fill: "#fefdfc"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h1v1h-1zm29 61v-1h1v1zm-3 3h1v1h-1z",
    fill: "#979591"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25h1v1h-1zm-8 19h-1v-1h1zm18 13h-1v-1h1z",
    fill: "#5b5a56"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h-1v-1h1zm-8 7v1h-1v-1zm13 18h-1v-1h1z",
    fill: "#464541"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25v1h-1v-1zm-6 19h-1v-1h1zM45 67h-1v-1h1z",
    fill: "#eae8e4"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M46 26h1v1h-1zm0 41v1h-1v-1zm0 39h1v1h-1z",
    fill: "#e8e6e2"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M49 27h-1v-1h1zm41 29h-1v-1h1zm-8 48v1h-1v-1z",
    fill: "#cac6c3"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M49 26h1v1h-1zm21 72h1v1h-1zm3 5h1v1h-1z",
    fill: "#bab7b4"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28v-1h1v1zm24 6h-1v-1h1zm15 48v-1h1v1z",
    fill: "#898481"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M72 27v1h-1v-1zm24 13v1h-1v-1zM66 57v-1h1v1z",
    fill: "#7d7c7a"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27v1h-1v-1zm-7 17v1h-1v-1zm4 6h1v1h-1z",
    fill: "#f2edea"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v-1h1v1zm7 59v-1h1v1zm1 2h1v1h-1z",
    fill: "#e9e8e5"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M50 28v1h-1v-1zm-2 19h1v1h-1zm9 70v-1h1v1z",
    fill: "#ccccc8"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29h-1v-1h1zm2 8h-1v-1h1zm34 45v-1h1v1z",
    fill: "#7f7a77"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M63 29v-1h1v1zm4 22v-1h1v1zm4 0h-1v-1h1z",
    fill: "#11100e"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M48 29h1v1h-1zm0 73v-1h1v1zm-15 5h-1v-1h1z",
    fill: "#e0ddd9"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29h1v1h-1zm1 4h1v1h-1zm0 5v-1h1v1z",
    fill: "#a09a98"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29v1h-1v-1zm0 5v-1h1v1zM40 66h1v1h-1z",
    fill: "#f5f1ee"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M88 30v-1h1v1zm-3 19v1h-1v-1zM43 69h1v1h-1z",
    fill: "#ece7e4"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31v-1h1v1zm1 2h-1v-1h1zm-1 11h-1v-1h1z",
    fill: "#827e7b"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30h1v1h-1zm10 9v-1h1v1zm22 60h1v1h-1z",
    fill: "#43423f"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h-1v-1h1zm9 30v1h-1v-1zm-27 52h1v1h-1z",
    fill: "#cbcbc6"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32v-1h1v1zm27 23v1h-1v-1zm4 38h1v1h-1z",
    fill: "#b2b0ac"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M90 31v2h-1v-2zm-37 9v-1h1v1z",
    fill: "#aba5a3"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M82 33v-1h1v1zm1 23v1h-1v-1zm-37 44h-1v-1h1z",
    fill: "#f6f2ef"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h-1v-1h1zm-3 0v1h-1v-1zm2 12h-1v-1h1z",
    fill: "#f7f3f0"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34h-1v-1h1zm-5 14v1h-1v-1zm-2 5h-1v-1h1z",
    fill: "#efeeec"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M52 33v1h-1v-1zm28 16h1v1h-1zm4 33h-1v-1h1z",
    fill: "#b5b3af"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M77 36h-1v-1h1zm20 24h-1v-1h1zm-8 22h1v1h-1z",
    fill: "#8c8683"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36v-1h1v1zm-41 70v1h-1v-1zm-2 8h-1v-1h1z",
    fill: "#f0eeea"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M53 37h-1v-1h1zm43 37v1h-1v-1zm-6 1v1h-1v-1z",
    fill: "#b3adaa"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1zm41 32h1v1h-1zm-11 40v1h-1v-1z",
    fill: "#a39d9a"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M90 36v1h-1v-1zm4 45h1v1h-1zm-9 24h-1v-1h1z",
    fill: "#b0aaa7"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v-1h1v1zm-12 7h-1v-1h1zm19 19v1h-1v-1z",
    fill: "#97918e"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37h1v1h-1zm0 3h1v1h-1zm24 39h-1v-1h1z",
    fill: "#a9a8a5"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M70 37v1h-1v-1zM59 48h-1v-1h1zm-3 2v1h-1v-1z",
    fill: "#41403d"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38h1v1h-1zm1 2h1v1h-1zm30 68v1h-1v-1z",
    fill: "#9b9693"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39h-1v-1h1zm3 7h1v1h-1zm-10 74v-1h1v1z",
    fill: "#54534f"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M53 39v1h-1v-1zm37 20v-1h1v1zm6 11v-1h1v1z",
    fill: "#bab4b1"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39h1v1h-1zm-7 3h-1v-1h1zm4 12v1h-1v-1z",
    fill: "#dcdad6"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M96 40h-1v-1h1zm-37 4v-1h1v1zm33 2h1v1h-1z",
    fill: "#484744"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h-1v-1h1zm35 31v1h-1v-1zm1 3v1h-1v-1z",
    fill: "#999491"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M82 42h-1v-1h1zM39 88v1h-1v-1zm-1 5v-1h1v1z",
    fill: "#e9e6e3"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M82 41h2v1h-2zM44 66v1h-1v-1z",
    fill: "#eeece8"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M63 42v1h-1v-1zm0 36h1v1h-1zm32 18v-1h1v1z",
    fill: "#62615f"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M72 43v-1h1v1zm-4 19h-1v-1h1zm0 32h-1v-1h1z",
    fill: "#5f5e5c"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v1h-1v-1zm0 34v1h-1v-1zm11 15h1v1h-1z",
    fill: "#d5d4d1"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M52 43v1h-1v-1zm36 38v-1h1v1zm-10 30h-1v-1h1z",
    fill: "#b0aca9"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45v-1h1v1zm23 13h1v1h-1zM33 76v1h-1v-1z",
    fill: "#cecdca"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45v-1h1v1zm26 10v1h-1v-1zm7 42h1v1h-1z",
    fill: "#b3afac"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-1v-1h1zm-4 12h1v1h-1zm5 62h1v1h-1z",
    fill: "#7f7e7a"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h2v1h-2zm5 9h-1v-1h1z",
    fill: "#fdf8f5"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-1v-1zm3 3h1v1h-1zm-16 60h-1v-1h1z",
    fill: "#d9d9d4"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45h1v1h-1zm35 42h1v1h-1zm-36 17h1v1h-1z",
    fill: "#d7d4d1"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M70 46v-1h1v1zm2 6h1v1h-1zm-3 20v1h-1v-1z",
    fill: "#a6a5a3"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h1v1h-1zm-6 7h-1v-1h1zm-28 3h-1v-1h1z",
    fill: "#cdc9c6"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M47 46h1v1h-1zm10 24h-1v-1h1zm-21 44v-1h1v1z",
    fill: "#d2d1ce"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46h1v1h-1zm1 5v1h-1v-1zm-1 13h-1v-1h1z",
    fill: "#7b7a78"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v1h-1v-1zM38 91v-1h1v1zm7 4h1v1h-1z",
    fill: "#f4efec"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47v2h-1v-2zm-3 42h-1v-1h1z",
    fill: "#fdfcfb"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48v-1h1v1zm25 8v1h-1v-1zM55 69h-1v-1h1z",
    fill: "#91908c"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48v-1h1v1zm0 3v-1h1v1zm1 3v-1h1v1z",
    fill: "#fffbf8"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50v-1h1v1zm4 12v1h-1v-1zm-3 5v-1h1v1z",
    fill: "#b8b7b5"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49h1v1h-1zm-6 21v-1h1v1zm-5 37v-1h1v1z",
    fill: "#bebbb8"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M89 49v1h-1v-1zm-4 42h1v1h-1zm-44 3v-1h1v1z",
    fill: "#ebe6e3"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v-1h1v1zM43 77h1v1h-1zm0 10v-1h1v1z",
    fill: "#fffffc"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52v-1h1v1zm13 0v-1h1v1zm-7 6v1h-1v-1z",
    fill: "#9b9a98"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M60 51v1h-1v-1zm13 23h-1v-1h1zm-6 18h-1v-1h1z",
    fill: "#9a9997"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51h1v1h-1zm8 18v-1h1v1zm3 49v-1h1v1z",
    fill: "#7e7d7b"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52v-1h1v1zM52 79h-1v-1h1zm-3 23v1h-1v-1z",
    fill: "#dfdbd8"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51h1v1h-1zm-4 4v-1h1v1zm7 36h-1v-1h1z",
    fill: "#dcd7d4"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52h-1v-1h1zM73 74v-1h1v1zM63 86v1h-1v-1z",
    fill: "#92918f"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M66 52h1v1h-1zm-35 1h1v1h-1zm29 9h1v1h-1z",
    fill: "#c3c2c0"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M83 52h1v1h-1zM51 81v1h-1v-1zm30 14h1v1h-1z",
    fill: "#dbd9d5"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M84 53v-1h1v1zM39 92h-1v-1h1zm7 21v1h-1v-1z",
    fill: "#e7e3e0"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M89 52v1h-1v-1zm-1 4v-1h1v1zM38 92h-1v-1h1z",
    fill: "#e0dcd9"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52v1h-1v-1zM66 98v1h-1v-1zm2 1v-1h1v1z",
    fill: "#b9b9b4"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h-1v-1h1zm22 6h-1v-1h1zM59 95h-1v-1h1z",
    fill: "#82817d"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M58 53h1v1h-1zm30 57h1v1h-1zm-7 6v-1h1v1z",
    fill: "#484745"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M57 64h2v1h-2zm17-11h1v1h-1z",
    fill: "#393834"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h-1v-1h1zm-6 16h1v1h-1zm3 4v1h-1v-1z",
    fill: "#e2e2e0"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M33 57v1h-1v-1zm37 3v-1h1v1zm-8 6h1v1h-1z",
    fill: "#a1a09e"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h2v1h-1zm-2-14v-1h1v1z",
    fill: "#131210"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58v-1h1v1zm2 21h-1v-1h1zm-3 2v-1h1v1z",
    fill: "#dfdad7"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59v-1h1v1zm7 10v1h-1v-1zm8 10h-1v-1h1z",
    fill: "#b1b0ae"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58h1v1h-1zm3 32h1v1h-1zm-28 23h-1v-1h1z",
    fill: "#cfcac7"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60h-1v-1h1zm-11 6v1h-1v-1zm11 7h1v1h-1z",
    fill: "#aaa9a7"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60v-1h1v1zm-45 7v-1h1v1zm1 45h1v1h-1z",
    fill: "#f0edea"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M90 63v1h-1v-2h1zm6 14v1h-1v-1z",
    fill: "#b5afac"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M88 64v-1h1v1zm-29 37v-1h1v1zm6 6v-1h1v1z",
    fill: "#c4c2be"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v-1h1v1zm0 2h1v1h-1zm2 51v1h-1v-1z",
    fill: "#61605c"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66v1h-1v-2h1zm0 5h-1v-1h1z",
    fill: "#c6c4c0"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69v1h-1v-1zm-25 4v1h-1v-1zm40 15v1h-1v-1z",
    fill: "#cccbc8"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70h-1v-1h1zm5 9v-1h1v1zm5 19v1h-1v-1z",
    fill: "#c0bdba"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h1v1h-1zm37 21h1v1h-1zm-2 4h1v1h-1z",
    fill: "#c9c8c5"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M36 73h1v1h-1zm0 4v-1h1v1zm9 5v1h-1v-1z",
    fill: "#dbdad7"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1zm6 12v-1h1v1zm-2 6v1h-1v-1z",
    fill: "#c9c8c6"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74v1h-1v-1zm17 19h1v1h-1zm21 2v-1h1v1z",
    fill: "#494844"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74h1v1h-1zm-3 29h-1v-1h1zm-11 1v1h-1v-1z",
    fill: "#b8b6b2"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M89 75v-1h1v1zm-3 18h1v1h-1zm-15 20v-1h1v1z",
    fill: "#bdb7b4"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v-1h1v1zm-10 2h1v1h-1zm12 1h-1v-1h1z",
    fill: "#807f7d"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M56 76v1h-1v-1zm2 16h1v1h-1zm4 1h-1v-1h1z",
    fill: "#d4d3d0"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M34 77v1h-1v-1zm48 25h-1v-1h1zm-28 1v1h-1v-1z",
    fill: "#d1cfcb"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78h-1v-1h1zm30 24h1v1h-1zm0 4v1h-1v-1z",
    fill: "#3c3b3a"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M74 78v-1h1v1zm19 19h1v1h-1zm0 2h-1v-1h1z",
    fill: "#3f3e3a"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M87 79h-1v-1h1zm-4 2h-1v-1h1zM45 94h-1v-1h1z",
    fill: "#eae5e2"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79v1h-1v-1zm7 17v1h-1v-1zm-6 8v-1h1v1z",
    fill: "#d0ceca"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M37 81h-1v-1h1zm-1 17v-1h1v1zm1 10v1h-1v-1z",
    fill: "#dbdbd6"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82h1v1h-1zm-10 4h-1v-1h1zm0 6v1h-1v-1z",
    fill: "#d7d5d2"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M35 85h1v1h-1zm48 12h-1v-1h1zm-48 11v1h-1v-1z",
    fill: "#dad8d4"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M39 94h1v2h-1v-1zm46-6v1h-1v-1z",
    fill: "#f9f8f4"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h1v3h-1z",
    fill: "#e1deda"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98v1h-1v-1zm20 3h-1v-1h1zm-14 14h-1v-1h1z",
    fill: "#bfbcb9"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M62 116v1h-1v-2h1zm-2 0v1h-1v-1z",
    fill: "#d0ccc9"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M52 10h1v1h-1zm6 17h-1v-1h1z",
    fill: "#95918e"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M53 11v-1h1v1zm22 0v-1h1v1z",
    fill: "#7e7975"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M68 11v-1h1v1zm-13 1h-1v-1h1z",
    fill: "#494843"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12v-1h1v1zm37 85v-1h1v1z",
    fill: "#454440"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M60 12h-2v-1h2z",
    fill: "#3d3c38"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M82 11h1v1h-1zM40 66v-1h1v1z",
    fill: "#ebeae5"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M84 12v-1h1v1zm-40 91v1h-1v-1z",
    fill: "#f5f2ef"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13h-1v-1h1zm30 49h-1v-1h1z",
    fill: "#9a9996"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13v-1h1v1zm9 20h-1v-1h1z",
    fill: "#373734"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M65 13h-1v-1h1zm32 24v-1h1v1z",
    fill: "#62615e"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12h1v1h-1zm19 87v1h-1v-1z",
    fill: "#726e6b"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M73 13v-1h1v1zm17 72v1h-1v-1z",
    fill: "#817b78"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M77 12v1h-1v-1zm0 102h1v1h-1z",
    fill: "#8f8b88"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M79 13h-1v-1h1zm11 3h-1v-1h1z",
    fill: "#a9a5a2"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M82 13v-1h1v1zm5 57v-1h1v1z",
    fill: "#deded9"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M71 13h1v1h-1zm21 18v1h-1v-1z",
    fill: "#787370"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15v-1h1v1zm32 72v1h-1v-1z",
    fill: "#252423"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M40 14v1h-1v-1zm22 14h1v1h-1z",
    fill: "#161513"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M48 15h-1v-1h1zM32 31h1v1h-1z",
    fill: "#8d8c89"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M69 14v1h-1v-1zm23 23h-1v-1h1z",
    fill: "#827d7a"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M84 15h-1v-1h1zm9 4v-1h1v1z",
    fill: "#b6b3af"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M97 15h-1v-1h1zM60 89v1h-1v-1z",
    fill: "#b6b5b2"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15h1v1h-1zm-3 2v-1h1v1z",
    fill: "#070604"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M84 15v1h-1v-1zM54 39h-1v-1h1z",
    fill: "#a6a09d"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M98 15v1h-1v-1zM58 70h1v1h-1z",
    fill: "#a4a39e"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17v-1h1v1zm32 41h-1v-1h1z",
    fill: "#0e0d0b"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16v1h-1v-1zm32 66h-1v-1h1z",
    fill: "#636260"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17h-1v-1h1zM31 32h-1v-1h1z",
    fill: "#b4b3b0"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M82 16v1h-1v-1zM52 41v-1h1v1z",
    fill: "#bab5b2"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M86 17v-1h1v1zM54 71h-1v-1h1z",
    fill: "#989793"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M91 17v-1h1v1zm-9 97h-1v-1h1z",
    fill: "#9f9996"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M92 16h1v1h-1zm-9 92v-1h1v1z",
    fill: "#aea8a5"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17v1h-1v-1zm41 33h1v1h-1z",
    fill: "#292825"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M42 17v1h-1v-1zm16 62h-1v-1h1z",
    fill: "#8a8987"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h-1v-1h1zm12 29v-1h1v1z",
    fill: "#cdc7c4"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M70 17v1h-1v-1zM51 52h1v1h-1z",
    fill: "#ccc7c4"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M72 18v-1h1v1zm-4 92v1h-1v-1z",
    fill: "#c5c5c0"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M78 17v1h-1v-1zm7 79v-1h1v1z",
    fill: "#c8c3c0"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M82 18h-1v-1h1zM49 55v-1h1v1z",
    fill: "#dcd6d3"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18h-1v-1h1zm-5 35v-1h1v1z",
    fill: "#cbcbc7"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18v-1h1v1zm-9 29v1h-1v-1z",
    fill: "#aeaca9"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18h-1v-1h1zM56 32h-1v-1h1z",
    fill: "#7d7976"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M100 17h1v1h-1zm-11 99v1h-1v-1z",
    fillOpacity: 0.008
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M31 18h1v1h-1zm40 73v-1h1v1z",
    fill: "#2c2b27"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18v1h-1v-1zm27 53v1h-1v-1z",
    fill: "#201f1c"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19h-1v-1h1zm35 8h-1v-1h1z",
    fill: "#898885"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19v-1h1v1zm57 31v1h-1v-1z",
    fill: "#686764"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19v-1h1v1zm34 46v1h-1v-1z",
    fill: "#9e9d9a"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M41 19v-1h1v1zm-9 88h-1v-1h1z",
    fill: "#acaba8"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M79 19v-1h1v1zm3 81v-1h1v1z",
    fill: "#d4d1ce"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M81 19v-1h1v1zm7-1h1v1h-1z",
    fill: "#c4c1be"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M85 18v1h-1v-1zm-11 84v1h-1v-1z",
    fill: "#bab8b4"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20v-1h1v1zm-20 3v-1h1v1z",
    fill: "#d5d2cf"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20v-1h1v1zm1 75v1h-1v-1z",
    fill: "#dbd8d5"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M31 20v1h-1v-1zm30 95h-1v-1h1z",
    fill: "#cdcbc8"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21v-1h1v1zm17 2h-1v-1h1z",
    fill: "#cac8c4"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M95 20h1v1h-1zm-9 92v-1h1v1z",
    fill: "#747371"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M96 20h1v1h-1zM63 36v-1h1v1z",
    fill: "#3c3b38"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M99 21v-1h1v1zm-68 87v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.047
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M33 21v1h-1v-1zm53 4h1v1h-1z",
    fill: "#c7c5c2"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21h1v1h-1zm-7 72h-1v-1h1z",
    fill: "#e0dedb"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M96 22h-1v-1h1zm-16 96h-1v-1h1z",
    fill: "#52514f"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22h1v1h-1zm1 3v1h-1v-1z",
    fill: "#b9b4b2"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22v1h-1v-1zm45 31v1h-1v-1z",
    fill: "#9c9996"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M38 23h-1v-1h1zm-1 6v1h-1v-1z",
    fill: "#e7e6e3"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23h-1v-1h1zm-5 16h1v1h-1z",
    fill: "#e0dfdc"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M50 23h-1v-1h1zm2 25v1h-1v-1z",
    fill: "#dedad7"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v-1h1v1zm27 31h1v1h-1z",
    fill: "#cbc7c4"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23h-1v-1h1zm-22 96h-1v-1h1z",
    fill: "#585752"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v1h-1v-1zm9 81v1h-1v-1z",
    fill: "#cac8c5"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v1h-1v-1zm10 80v1h-1v-1z",
    fill: "#c3bdbb"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M84 24v-1h1v1zm-8 32h1v1h-1z",
    fill: "#6e6d69"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25v-1h1v1zm-12 81v-1h1v1z",
    fill: "#dcdbd6"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h-1v-1h1zm-55 5v1h-1v-1z",
    fill: "#b2b2ae"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26h-1v-1h1zm1 11h-1v-1h1z",
    fill: "#fcfbfa"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M39 25h1v1h-1zm7 13v1h-1v-1z",
    fill: "#f7f6f5"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h1v1h-1zm45 47v-1h1v1z",
    fill: "#aba6a4"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M67 25h1v1h-1zm25 70v-1h1v1z",
    fill: "#4c4b47"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h1v1h-1zM53 74h1v1h-1z",
    fill: "#5e5d59"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v1h-1v-1zm-47 4h-1v-1h1z",
    fill: "#b3b1ae"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25v1h-1v-1zm4 58h1v1h-1z",
    fill: "#a5a39f"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M85 25h1v1h-1zm3 49v-1h1v1z",
    fill: "#b6b4b1"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M93 25v1h-1v-1zm0 25h-1v-1h1z",
    fill: "#504f4c"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27h-1v-1h1zm43 5v1h-1v-1z",
    fill: "#67625f"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h-1v-1h1zm56 56h-1v-1h1z",
    fill: "#9c9a97"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M59 27h-1v-1h1zm20 87v1h-1v-1z",
    fill: "#8f8c89"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M64 26v1h-1v-1zm-6 35h1v1h-1z",
    fill: "#787774"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M66 27v-1h1v1zm7 62h1v1h-1z",
    fill: "#7b7a76"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h-1v-1h1zM56 62v-1h1v1z",
    fill: "#91908d"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27v-1h1v1zM41 69h-1v-1h1z",
    fill: "#f0ebe8"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M49 28v-1h1v1zm12 83v1h-1v-1z",
    fill: "#c8c8c3"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M57 28h-1v-1h1zm33 65v1h-1v-1z",
    fill: "#7b7b77"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27v1h-1v-1zm29 82v1h-1v-1z",
    fill: "#7a7a76"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h1v1h-1zm-16 6h-1v-1h1z",
    fill: "#72706d"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M33 28v1h-1v-1zm57 23v1h-1v-1z",
    fill: "#8d8d89"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M53 29v-1h1v1zm38 1h-1v-1h1z",
    fill: "#8e8885"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M55 28h1v1h-1zm18 10h1v1h-1z",
    fill: "#676561"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28h1v1h-1zm6 8v1h-1v-1z",
    fill: "#53534f"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M59 28h1v1h-1zm17 90h1v1h-1z",
    fill: "#262524"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v1h-1v-1zm28 82h-1v-1h1z",
    fill: "#100f0d"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v1h-1v-1zm19 64h1v1h-1z",
    fill: "#5d5855"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M77 29h-1v-1h1zm15 42v1h-1v-1z",
    fill: "#918d8a"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v1h-1v-1zM45 68h-1v-1h1z",
    fill: "#eeeae7"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28h1v1h-1zm6 24h-1v-1h1z",
    fill: "#696461"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29v-1h1v1zm2 18h-1v-1h1z",
    fill: "#434241"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30h-1v-1h1zm5 7h-1v-1h1z",
    fill: "#fdfdfc"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30h-1v-1h1zm-7 56h-1v-1h1z",
    fill: "#fbf9f5"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v-1h1v1zm38 27v1h-1v-1z",
    fill: "#97908e"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M55 30v-1h1v1zm0 13h1v1h-1z",
    fill: "#797672"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v-1h1v1zm5 5h-1v-1h1z",
    fill: "#3a3936"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29v1h-1v-1zm-5 72v-1h1v1z",
    fill: "#b6b1ae"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30h-1v-1h1zM75 65h-1v-1h1z",
    fill: "#6e6966"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31v-1h1v1zm-6 67h1v1h-1z",
    fill: "#f8f6f2"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h1v1h-1zm0 65v-1h1v1z",
    fill: "#dddad6"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M52 30v1h-1v-1zm-1 3v-1h1v1z",
    fill: "#b1afac"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M77 30v1h-1v-1zm19 35v1h-1v-1z",
    fill: "#8f8986"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M78 31h-1v-1h1zM56 42v1h-1v-1z",
    fill: "#9e9a97"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h-1v-1h1zm7 12h-1v-1h1z",
    fill: "#eeebe8"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31v-1h1v1zm-33 4v-1h1v1z",
    fill: "#726d6a"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31v1h-1v-1zm23 27h-1v-1h1z",
    fill: "#686763"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32v-1h1v1zm0 2v-1h1v1z",
    fill: "#d1d0cb"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32h-1v-1h1zm10 76v-1h1v1z",
    fill: "#e0e0dc"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h-1v-1h1zm0 1v1h-1v-1z",
    fill: "#9b9794"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h1v1h-1zm37 2v1h-1v-1z",
    fill: "#f3f1ed"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h-1v-1h1zm-35 78h-1v-1h1z",
    fill: "#eceae6"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33h-1v-1h1zm-41 80h-1v-1h1z",
    fill: "#e0dbd8"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h1v1h-1zm3 29v-1h1v1z",
    fill: "#8a8481"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33h1v1h-1zm4 21v1h-1v-1z",
    fill: "#fcfcfa"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M58 34h-1v-1h1zm35 53v1h-1v-1z",
    fill: "#76716e"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M59 34h-1v-1h1zm17 30h-1v-1h1z",
    fill: "#6d6865"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M73 34h-1v-1h1zm-4 51v-1h1v1z",
    fill: "#4d4c4b"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h-1v-1h1zm-1 7v-1h1v1z",
    fill: "#696664"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34v1h-1v-1zm42 5v-1h1v1z",
    fill: "#7e7976"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35v-1h1v1zm-6 23v-1h1v1z",
    fill: "#f1efeb"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M88 34h1v1h-1zM36 53h1v1h-1z",
    fill: "#d9d5d2"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35h-1v-1h1zM66 84v-1h1v1z",
    fill: "#666563"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35h1v1h-1zm43 40v1h-1v-1z",
    fill: "#a19b98"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35h1v1h-1zm11 27v1h-1v-1z",
    fill: "#c3c1bd"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36h-1v-1h1zM59 85h-1v-1h1z",
    fill: "#5e5d5b"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36h1v1h-1zm6 3v1h-1v-1z",
    fill: "#f1f1ed"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M46 37v1h-1v-1zm0 15h-1v-1h1z",
    fill: "#f8f6f5"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M74 37h1v1h-1zm17 52h-1v-1h1z",
    fill: "#7d7875"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38v-1h1v2h-1z",
    fill: "#eff0eb"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M96 38v-1h1v1zM58 71h1v1h-1z",
    fill: "#24231e"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38v1h-1v-1zm6 50v1h-1v-1z",
    fill: "#eeedea"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M97 39v-1h1v1zM77 59v1h-1v-1z",
    fill: "#868581"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v1h-1v-1zm-1 5v-1h1v1z",
    fill: "#7c7b78"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h-1v-1h1zm0 36h-1v-1h1z",
    fill: "#f5f3f3"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39h1v1h-1zm30 4v1h-1v-1z",
    fill: "#c8c6c2"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40v-1h1v1zm35 20h-1v-1h1z",
    fill: "#736f6c"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40v1h-1v-1zm-4 46h-1v-1h1z",
    fill: "#e6e5e2"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41v-1h1v1zm0 78h-1v-1h1z",
    fill: "#5a5955"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40h1v1h-1zm8 38h-1v-1h1z",
    fill: "#bdbbb8"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41v-1h1v1zM50 51v-1h1v1z",
    fill: "#a7a19e"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M97 40h1v1h-1zm-64 6v1h-1v-1z",
    fill: "#656461"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M79 41h1v1h-1zm0 65h1v1h-1z",
    fill: "#c7c5c1"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42h1v1h-1zm25 19h1v1h-1z",
    fill: "#858481"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v-1h1v1zm28 66h1v1h-1z",
    fill: "#8c8a86"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M80 42h1v1h-1zm-19 69h1v1h-1z",
    fill: "#c8c8c4"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42h1v1h-1zM51 55v1h-1v-1z",
    fill: "#dcd8d5"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43v1h-1v-1zm0 13v-1h1v1z",
    fill: "#f0efee"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44v-1h1v1zm-41 8h-1v-1h1z",
    fill: "#a6a3a0"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M84 43v1h-1v-1zm-43 63h1v1h-1z",
    fill: "#f3f1ee"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44h-1v-1h1zM39 88h1v1h-1z",
    fill: "#f9f6f3"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M89 43h1v1h-1zm-2 53v1h-1v-1z",
    fill: "#b8b4b1"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45v-1h1v1zm38 37h-1v-1h1z",
    fill: "#c7c4c1"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M77 45v-1h1v1zm1 18h-1v-1h1z",
    fill: "#b5b2ae"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44h1v1h-1zm0 44v1h-1v-1z",
    fill: "#aca8a5"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45v1h-1v-1zm-2 12v-1h1v1z",
    fill: "#f2f1ef"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M69 46v-1h1v1zm-8 46v-1h1v1z",
    fill: "#a5a4a2"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M96 46h-1v-1h1zm-1 2h1v1h-1z",
    fill: "#12110e"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47v-1h1v1zm1 39h-1v-1h1z",
    fill: "#efefed"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v1h-1v-1zm23 54h-1v-1h1z",
    fill: "#b8b8b4"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46v1h-1v-1zm-4 18v-1h1v1z",
    fill: "#8e8d89"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47v-1h1v1zm16 62v1h-1v-1z",
    fill: "#4a4946"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v-1h1v1zm3 33v-1h1v1z",
    fill: "#e9e4e1"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46v1h-1v-1zm-3 11v-1h1v1z",
    fill: "#fffdfa"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47v-1h1v1zm-63 2v1h-1v-1z",
    fill: "#8f8e8c"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M47 47h1v1h-1zm-16 58v-1h1v1z",
    fill: "#d7d6d3"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48h-1v-1h1zm18 58v1h-1v-1z",
    fill: "#c5c1be"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47v1h-1v-1zm29 34h1v1h-1z",
    fill: "#b5b2af"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M61 48v-1h1v1zm1 40v-1h1v1z",
    fill: "#292827"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47h1v1h-1zm19 26v1h-1v-1z",
    fill: "#bfb9b6"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47v1h-1v-1zm-28 59h1v1h-1z",
    fill: "#d4cecb"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v1h-1v-1zm4 3v-1h1v1z",
    fill: "#fef9f6"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M86 48v-1h1v1zM40 90v-1h1v1z",
    fill: "#e9e5e2"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48v-1h1v1zM31 87h-1v-1h1z",
    fill: "#e1e1e1",
    fillOpacity: 0.137
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49h-1v-1h1zm29 44v-1h1v1z",
    fill: "#dddbd7"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1zM33 67v1h-1v-1z",
    fill: "#c0bfbc"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M80 48v1h-1v-1zm0 55v-1h1v1z",
    fill: "#d1cecb"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M37 49v1h-1v-1zm4 35v1h-1v-1z",
    fill: "#e3e2df"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M46 49v1h-1v-1zm-1 30h1v1h-1z",
    fill: "#dbd9d8"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M58 49h1v1h-1zm-2 3h-1v-1h1z",
    fill: "#b7b6b3"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M84 50h-1v-1h1zm-48 2h1v1h-1z",
    fill: "#dbd7d4"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51h-1v-1h1zm25 15h-1v-1h1z",
    fill: "#a7a6a3"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v1h-1v-1zm23 20v-1h1v1z",
    fill: "#c3c2bf"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51v-1h1v1zm1 1v1h-1v-1z",
    fill: "#e8e6e5"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M82 51v-1h1v1zM45 92v1h-1v-1z",
    fill: "#fdf9f6"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v-1h1v1zm2 47h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.039
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M52 52h-1v-1h1zm34 7h-1v-1h1z",
    fill: "#ded9d6"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M82 52h-1v-1h1zm-37 62h-1v-1h1z",
    fill: "#ede9e6"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v1h-1v-1zM45 71h-1v-1h1z",
    fill: "#e7e4e1"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51h1v1h-1zm-63 64v-1h1v1z",
    fill: "#d4d4d4",
    fillOpacity: 0.047
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53h-1v-1h1zm50 2v1h-1v-1z",
    fill: "#ddd9d6"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52h1v1h-1zm11 21h1v1h-1z",
    fill: "#afa9a7"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53h-1v-1h1zm-21 47v1h-1v-1z",
    fill: "#c2bfbc"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52h1v1h-1zm-41 60v-1h1v1z",
    fill: "#f0ece9"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53v-1h1v1zm-2 31v-1h1v1z",
    fill: "#999390"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h-1v-1h1zm61 29h-1v-1h1z",
    fill: "#a4a09d"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h-1v-1h1zm40 15v-1h1v1z",
    fill: "#c6c4c1"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M85 53v1h-1v-1zM44 71v1h-1v-1z",
    fill: "#fffffb"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M93 53v1h-1v-1zM70 86v1h-1v-1z",
    fill: "#6b6a67"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h1v1h-1zm-5 39h1v1h-1z",
    fill: "#726f6c"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55v-1h1v1zm0 5h-1v-1h1z",
    fill: "#c4c2c0"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v1h-1v-1zm-9 54h1v1h-1z",
    fill: "#c1bfbb"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54v1h-1v-1zm-6 24v-1h1v1z",
    fill: "#aeaca8"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56v-1h1v1zm-2 46v1h-1v-1z",
    fill: "#d5d2ce"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56v-1h1v1zm-7 54h1v1h-1z",
    fill: "#b6b3b0"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55h1v1h-1zM44 95h-1v-1h1z",
    fill: "#f5f0ed"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h1v1h-1zm-2 39h-1v-1h1z",
    fill: "#93908c"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55h1v1h-1zm-63 54v1h-1v-1z",
    fill: "#a6a19d"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57v-1h1v1zm1 21v-1h1v1z",
    fill: "#adaba7"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h-1v-1h1zm0 2v1h-1v-1z",
    fill: "#fffcf9"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v1h-1v-1zM48 98h-1v-1h1z",
    fill: "#e7e2df"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M90 58h-1v-2h1v1z",
    fill: "#908a88"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M89 57v1h-1v-1zm3 32v-1h1v1z",
    fill: "#9e9996"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58v1h-1v-1zM38 68v-1h1v1z",
    fill: "#ede8e5"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h1v1h-1zm-3 17h-1v-1h1z",
    fill: "#d1d0cd"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60h1v1h-1zm28 32v1h-1v-1z",
    fill: "#d0cfcc"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61v-1h1v1zm0 26v1h-1v-1z",
    fill: "#2a2927"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h1v1h-1zm0 3v-1h1v1z",
    fill: "#847f7d"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62v-1h1v1zm-2 20v-1h1v1z",
    fill: "#5d5c5b"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h1v1h-1zm-33 51v-1h1v1z",
    fill: "#d0d1cc"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62h1v1h-1zm20 22h1v1h-1z",
    fill: "#bdbcb7"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M58 62h1v1h-1zm-21 50v1h-1v-1z",
    fill: "#c8c7c4"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62h1v1h-1zM59 72h1v1h-1z",
    fill: "#a8a7a4"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M75 63v-1h1v1zm11 36h1v1h-1z",
    fill: "#a9a6a2"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63h-1v-1h1zm-1 2h1v1h-1z",
    fill: "#d5d6d1"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63h1v1h-1zm-9 47v1h-1v-1z",
    fill: "#c1c1bd"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M86 65v-1h1v1zm-5 34v1h-1v-1z",
    fill: "#d4d4cf"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h-1v-1h1zm-23 43h1v1h-1z",
    fill: "#c2c0bc"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66h-1v-1h1zM63 98v-1h1v1z",
    fill: "#bfbbb8"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M40 67h-1v-1h1zm45 25h-1v-1h1z",
    fill: "#f5f3ef"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67h1v1h-1zm24 7h-1v-1h1z",
    fill: "#8c8b87"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M96 69h-1v-1h1zm-5 7h-1v-1h1z",
    fill: "#9d9794"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M97 69h-1v-1h1zm-1 3v-1h1v1z",
    fill: "#b6b0ac"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69h1v1h-1zm2 23h1v1h-1z",
    fill: "#f0ebe9"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#eae5e3"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70h-1v-1h1zm0 42v-1h1v1z",
    fill: "#ebe7e4"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v1h-1v-1zm-26 4h-1v-1h1z",
    fill: "#cbcac7"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v-1h1v1zm-5 36v-1h1v1z",
    fill: "#bbb9b5"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h1v1h-1zm7 23h1v1h-1z",
    fill: "#bdbab7"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M90 69v1h-1v-1zm-1 3v-1h1v1z",
    fill: "#bbb5b3"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70h1v1h-1zm-2 40v-1h1v1z",
    fill: "#dfddd9"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M42 70h1v1h-1zm3 11h1v1h-1z",
    fill: "#f6f3f2"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v1h-1v-1zM57 87v1h-1v-1z",
    fill: "#5f5e5a"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71v1h-1v-1zm13 19v1h-1v-1z",
    fill: "#282723"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M68 72h-1v-1h1zm25 38h1v1h-1z",
    fill: "#11100f"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72h-1v-1h1zm1 2v1h-1v-1z",
    fill: "#181716"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h1v1h-1zm18 4h-1v-1h1z",
    fill: "#d8d7d4"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73h1v1h-1zm9 23h1v1h-1z",
    fill: "#cac9c6"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M70 74v1h-1v-1zm0 3h1v1h-1z",
    fill: "#1a1918"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M64 75v1h-1v-1zm1 9h-1v-1h1z",
    fill: "#706f6e"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76v-1h1v1zm-3 2v1h-1v-1z",
    fill: "#6e6d6c"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76v1h-1v-1zm-4 40v1h-1v-1z",
    fill: "#d3d2cf"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76h1v1h-1zm-6 6v-1h1v1z",
    fill: "#b0aeaa"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77v1h-1v-1zm31 5h-1v-1h1z",
    fill: "#bfbdb9"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M37 79h-1v-1h1zm0 3h-1v-1h1z",
    fill: "#ddddd8"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80v-1h1v1zm1 2v1h-1v-1z",
    fill: "#dadad5"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M39 79h1v1h-1zm5 8v-1h1v1z",
    fill: "#fdfcf8"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M49 80v-1h1v1zm7 31h1v1h-1z",
    fill: "#d1cbc8"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M81 79v1h-1v-1zm-22 32v-1h1v1z",
    fill: "#cac7c4"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80v-1h1v1zm-36 21v-1h1v1z",
    fill: "#f1ebe8"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M91 80v1h-1v-1zm-5 21v1h-1v-1z",
    fill: "#b1aca9"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M32 81h1v2h-1v-1z",
    fill: "#d3ceca"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h-1v-1h1zm33 10h1v1h-1z",
    fill: "#e7e5e2"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M85 81v1h-1v-1zm-14 29v1h-1v-1z",
    fill: "#c0beba"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82v-1h1v1zm-2 13v-1h1v1z",
    fill: "#aeaaa7"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M70 83v-1h1v1zm-1 2v1h-1v-1z",
    fill: "#cfcecc"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84v-1h1v1zm1 4h-1v-1h1z",
    fill: "#d6d2ce"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84v1h-1v-2h1z",
    fill: "#d6d1cf"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M30 84h1v1h-1zm3 27v1h-1v-1z",
    fill: "#ddd",
    fillOpacity: 0.18
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84h1v1h-1zm1 6h-1v-1h1z",
    fill: "#d5d0cc"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h1v1h-1zm6 31h-1v-1h1z",
    fill: "#d8d8d3"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M94 84h1v1h-1zm-11 24h1v1h-1z",
    fill: "#a9a2a0"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v-1h1v1zm4 3v1h-1v-1z",
    fill: "#fdfcf9"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86h-1v-1h1zm-18 24h-1v-1h1z",
    fill: "#dbdad5"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M87 85h1v1h-1zm-37 33h1v1h-1z",
    fill: "#b5b5b0"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87h-1v-1h1zm-6 18v1h-1v-1z",
    fill: "#797471"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M36 88v-1h1v1zm0 21h1v1h-1z",
    fill: "#dbdbd7"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87h1v1h-1zm-5 3h1v1h-1z",
    fill: "#a19a98"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v-1h1v1zm6 3h1v1h-1z",
    fill: "#cdccc9"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M45 91h1v1h-1zm4 15h-1v-1h1z",
    fill: "#dddbd8"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M44 94h1v1h-1zm3 9h-1v-1h1z",
    fill: "#eee9e6"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M69 94h1v1h-1zm9 24v-1h1v1z",
    fill: "#6e6d6a"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M84 95v-1h1v1zm-25 20v1h-1v-1z",
    fill: "#d2d0cc"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M31 96h-1v-1h1zm0 5v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.051
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96v1h-1v-2h1z",
    fill: "#f9f7f3"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v-1h1v1zm1 8h-1v-1h1z",
    fill: "#dfdcd9"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M46 96h1v2h-1v-1z",
    fill: "#f2ece9"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97v-1h1v1zm-3 7v1h-1v-1z",
    fill: "#cbc9c5"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M61 98h-1v-1h1zm7 7h-1v-1h1z",
    fill: "#c4bebb"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M31 101h-1v-2h1v1z",
    fill: "#fff",
    fillOpacity: 0.043
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M48 99v1h-1v-1zm-1 2h1v1h-1z",
    fill: "#e6e0de"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M71 99h1v1h-1zm0 5h1v1h-1z",
    fill: "#bbb9b6"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M83 100v1h-1v-1zm-49 6v1h-1v-1z",
    fill: "#d3d0cd"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M68 102h-1v-1h1zm-2 1h1v1h-1z",
    fill: "#c1bdb9"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103h-1v-1h1zm17 2v-1h1v1z",
    fill: "#c5bfbc"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M85 103v-1h1v1zm-9 7h1v1h-1z",
    fill: "#aca9a6"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102h1v1h-1zm-18 16h1v1h-1z",
    fill: "#2e2d2c"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v1h-1v-1zm11 14v-1h1v1z",
    fill: "#d3d2cd"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103h2v1h-2z",
    fill: "#f6f3ef"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M44 103h1v1h-1zm1 4h-1v-1h1z",
    fill: "#f3f0ed"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M78 105v-2h1v2z",
    fill: "#c2c2be"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M80 104v-1h1v1zm-24 4h-1v-1h1z",
    fill: "#cecbc8"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M31 105h1v1h-1zm35 6v-1h1v1z",
    fill: "#c4c4c0"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#d4cecc"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M54 105v1h-1v-1zm-1 4v-1h1v1z",
    fill: "#d5cdcb"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108v2h-1v-2z",
    fill: "#d5cfcc"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M62 112v1h-1v-1zm-17 6v-1h1v1z",
    fill: "#c9c9c4"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M71 117h1v1h-1zm-5 2h1v1h-1z",
    fill: "#4b4a45"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8v1h-1V8z",
    fill: "#7f7f7f",
    fillOpacity: 0.016
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8h1v1h-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.047
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M55 9h-1V8h1z",
    fill: "#636363",
    fillOpacity: 0.071
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M56 9h-1V8h1z",
    fill: "#424242",
    fillOpacity: 0.09
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M56 8h1v1h-1z",
    fill: "#48483f",
    fillOpacity: 0.11
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9V8h1v1z",
    fill: "#524b4b",
    fillOpacity: 0.145
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M58 9V8h1v1z",
    fill: "#4d4d4d",
    fillOpacity: 0.169
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M60 9h-1V8h1z",
    fill: "#484848",
    fillOpacity: 0.192
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M60 8h1v1h-1z",
    fill: "#494949",
    fillOpacity: 0.204
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M62 8v1h-1V8z",
    fill: "#4b4646",
    fillOpacity: 0.212
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M62 9V8h1v1z",
    fill: "#4d4d48",
    fillOpacity: 0.22
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M64 8v1h-1V8z",
    fill: "#50504c",
    fillOpacity: 0.224
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M64 9V8h1v1z",
    fill: "#53534f",
    fillOpacity: 0.227
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M65 8h1v1h-1z",
    fill: "#565252",
    fillOpacity: 0.231
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M67 9h-1V8h1z",
    fill: "#5a5656",
    fillOpacity: 0.231
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M68 9h-1V8h1z",
    fill: "#5f5f5f",
    fillOpacity: 0.231
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8h1v1h-1z",
    fill: "#676363",
    fillOpacity: 0.231
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M70 9h-1V8h1z",
    fill: "#7a7a7a",
    fillOpacity: 0.212
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M71 9h-1V8h1z",
    fill: "#85857f",
    fillOpacity: 0.18
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M71 8h1v1h-1z",
    fill: "#8c928c",
    fillOpacity: 0.157
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M73 9h-1V8h1z",
    fill: "#aaaaa3",
    fillOpacity: 0.153
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M74 8v1h-1V8z",
    fill: "#bbb",
    fillOpacity: 0.133
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M75 9h-1V8h1z",
    fill: "#d9d9d9",
    fillOpacity: 0.106
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M75 9V8h1v1z",
    fill: "#e8e8e8",
    fillOpacity: 0.09
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M76 8h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.067
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M44 10V9h1v1z",
    fill: "#717171",
    fillOpacity: 0.035
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M45 9h1v1h-1z",
    fill: "#97978d",
    fillOpacity: 0.106
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M47 9v1h-1V9z",
    fill: "#9b9b97",
    fillOpacity: 0.212
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10V9h1v1z",
    fill: "#a09d9a",
    fillOpacity: 0.318
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M48 10V9h1v1z",
    fill: "#9f9b99",
    fillOpacity: 0.431
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M50 10h-1V9h1z",
    fill: "#9b9995",
    fillOpacity: 0.522
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M51 9v1h-1V9z",
    fill: "#979492",
    fillOpacity: 0.62
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M52 9v1h-1V9z",
    fill: "#868382",
    fillOpacity: 0.706
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M52 10V9h1v1z",
    fill: "#777572",
    fillOpacity: 0.769
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M54 10h-1V9h1z",
    fill: "#696563",
    fillOpacity: 0.816
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M55 10h-1V9h1z",
    fill: "#56524f",
    fillOpacity: 0.859
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M56 10h-1V9h1z",
    fill: "#454340",
    fillOpacity: 0.89
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9v1h-1V9z",
    fill: "#3b3b37",
    fillOpacity: 0.906
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9h1v1h-1z",
    fill: "#343430",
    fillOpacity: 0.925
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10h-1V9h1z",
    fill: "#2e2d29",
    fillOpacity: 0.945
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10V9h1v1z",
    fill: "#292826",
    fillOpacity: 0.957
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M61 9v1h-1V9z",
    fill: "#262425",
    fillOpacity: 0.965
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M61 10V9h1v1z",
    fill: "#262524",
    fillOpacity: 0.969
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M62 10V9h1v1z",
    fill: "#272623",
    fillOpacity: 0.973
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M63 9h1v1h-1z",
    fill: "#252422",
    fillOpacity: 0.976
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M64 9h1v1h-1z",
    fill: "#262523",
    fillOpacity: 0.976
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M66 9v1h-1V9z",
    fill: "#272622",
    fillOpacity: 0.98
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M66 10V9h1v1z",
    fill: "#2a2926",
    fillOpacity: 0.98
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M67 9h1v1h-1z",
    fill: "#2f2e2a",
    fillOpacity: 0.98
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M69 10h-1V9h1z",
    fill: "#32312e",
    fillOpacity: 0.976
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M69 10V9h1v1z",
    fill: "#393834",
    fillOpacity: 0.969
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M71 9v1h-1V9z",
    fill: "#3e3d39",
    fillOpacity: 0.957
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M72 10h-1V9h1z",
    fill: "#454440",
    fillOpacity: 0.941
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M73 10h-1V9h1z",
    fill: "#52514d",
    fillOpacity: 0.937
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M74 9v1h-1V9z",
    fill: "#5f5e5a",
    fillOpacity: 0.925
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M74 10V9h1v1z",
    fill: "#71706c",
    fillOpacity: 0.906
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M76 10h-1V9h1z",
    fill: "#84827e",
    fillOpacity: 0.89
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M77 10h-1V9h1z",
    fill: "#999794",
    fillOpacity: 0.863
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M77 10V9h1v1z",
    fill: "#b0afab",
    fillOpacity: 0.8
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M79 10h-1V9h1z",
    fill: "#c5c3bf",
    fillOpacity: 0.745
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M80 10h-1V9h1z",
    fill: "#d8d7d3",
    fillOpacity: 0.682
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M80 10V9h1v1z",
    fill: "#e1dfda",
    fillOpacity: 0.58
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M82 9v1h-1V9z",
    fill: "#eae8e4",
    fillOpacity: 0.49
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M83 9v1h-1V9z",
    fill: "#f1eeec",
    fillOpacity: 0.369
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M84 10h-1V9h1z",
    fill: "#f3f3ef",
    fillOpacity: 0.259
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M85 10h-1V9h1z",
    fill: "#f8f2f2",
    fillOpacity: 0.157
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M39 10h1v1h-1z",
    fill: "#555",
    fillOpacity: 0.035
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10v1h-1v-1z",
    fill: "#8f8f8f",
    fillOpacity: 0.153
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10h1v1h-1z",
    fill: "#a7a4a7",
    fillOpacity: 0.322
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10v1h-1v-1z",
    fill: "#bbbbb9",
    fillOpacity: 0.49
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10h1v1h-1z",
    fill: "#cbc9c6",
    fillOpacity: 0.655
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M45 11h-1v-1h1z",
    fill: "#cececa",
    fillOpacity: 0.796
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M46 10v1h-1v-1z",
    fill: "#d4d5d1",
    fillOpacity: 0.898
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M46 11v-1h1v1z",
    fill: "#dee0da",
    fillOpacity: 0.969
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11v-1h1v1z",
    fill: "#a29e9b"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M54 11v-1h1v1z",
    fill: "#6a6661"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M55 11v-1h1v1z",
    fill: "#5c5a55"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M57 11h-1v-1h1z",
    fill: "#51514b"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M57 10h1v1h-1z",
    fill: "#494943"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10v1h-1v-1z",
    fill: "#41403b"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10h1v1h-1z",
    fill: "#403e3e"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M62 11h-1v-1h1z",
    fill: "#413f3d"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M66 10h1v1h-1z",
    fill: "#45443f"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M67 11v-1h1v1z",
    fill: "#474641"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11v-1h1v1z",
    fill: "#4c4b46"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M71 10v1h-1v-1z",
    fill: "#514e49"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M72 11h-1v-1h1z",
    fill: "#55534e"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M73 10v1h-1v-1z",
    fill: "#5b5954"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M74 10v1h-1v-1z",
    fill: "#63605b"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M75 10v1h-1v-1z",
    fill: "#726d69"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M77 10v1h-1v-1z",
    fill: "#8b8782"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M77 11v-1h1v1z",
    fill: "#a09b97"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M79 11h-1v-1h1z",
    fill: "#b1aca8"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M80 10v1h-1v-1z",
    fill: "#c4bfbb"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M81 11h-1v-1h1z",
    fill: "#d7d3ce"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M81 10h1v1h-1z",
    fill: "#e6e1dd"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M82 11v-1h1v1z",
    fill: "#efe9e7"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M83 10h1v1h-1z",
    fill: "#f1edeb",
    fillOpacity: 0.996
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M84 11v-1h1v1z",
    fill: "#f5f2f1",
    fillOpacity: 0.945
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M86 11h-1v-1h1z",
    fill: "#f4f3f2",
    fillOpacity: 0.847
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M87 11h-1v-1h1z",
    fill: "#f4f3f3",
    fillOpacity: 0.694
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M87 11v-1h1v1z",
    fill: "#f6f4f4",
    fillOpacity: 0.498
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M89 11h-1v-1h1z",
    fill: "#f2f2ef",
    fillOpacity: 0.314
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M89 11v-1h1v1z",
    fill: "#f1f1f1",
    fillOpacity: 0.149
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M36 12v-1h1v1z",
    fill: "#66665e",
    fillOpacity: 0.137
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M38 11v1h-1v-1z",
    fill: "#6c6c69",
    fillOpacity: 0.369
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M39 12h-1v-1h1z",
    fill: "#868482",
    fillOpacity: 0.604
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12h-1v-1h1z",
    fill: "#aaa8a7",
    fillOpacity: 0.788
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12v-1h1v1z",
    fill: "#cac9c7",
    fillOpacity: 0.929
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M41 11h1v1h-1z",
    fill: "#dedddc"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M49 12h-1v-1h1z",
    fill: "#aeaba8"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M50 12h-1v-1h1z",
    fill: "#93908d"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M50 12v-1h1v1z",
    fill: "#7f7c79"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11h1v1h-1z",
    fill: "#6d6a67"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M52 12v-1h1v1z",
    fill: "#5d5a57"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M56 12v-1h1v1z",
    fill: "#3f3f3a"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M66 11h1v1h-1z",
    fill: "#504f4a"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12h-1v-1h1z",
    fill: "#55544f"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11v1h-1v-1z",
    fill: "#575752"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11h1v1h-1z",
    fill: "#5e5c57"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M71 12h-1v-1h1z",
    fill: "#65605d"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M71 11h1v1h-1z",
    fill: "#6e6a66"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M73 12h-1v-1h1z",
    fill: "#797571"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M78 12v-1h1v1z",
    fill: "#c9c5c1"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M84 11v1h-1v-1z",
    fill: "#f0eeeb"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M86 11v1h-1v-1z",
    fill: "#fbf7f5"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M86 12v-1h1v1z",
    fill: "snow"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M87 11h1v1h-1z",
    fill: "#fffbfa"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M89 11v1h-1v-1z",
    fill: "#f8f5f3"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M90 12h-1v-1h1z",
    fill: "#f6f4f3",
    fillOpacity: 0.922
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M91 11v1h-1v-1z",
    fill: "#f4f2f2",
    fillOpacity: 0.745
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M91 11h1v1h-1z",
    fill: "#f3f1f3",
    fillOpacity: 0.514
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M93 11v1h-1v-1z",
    fill: "#f6f6f6",
    fillOpacity: 0.235
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M93 11h1v1h-1z",
    fill: "#e7e7e7",
    fillOpacity: 0.043
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13h-1v-1h1z",
    fill: "#626258",
    fillOpacity: 0.102
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12v1h-1v-1z",
    fill: "#3b3836",
    fillOpacity: 0.388
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13h-1v-1h1z",
    fill: "#3a3837",
    fillOpacity: 0.706
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M37 12v1h-1v-1z",
    fill: "#4a4a48",
    fillOpacity: 0.925
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12v1h-1v-1z",
    fill: "#706e6c"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13v-1h1v1z",
    fill: "#5a5857"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12v1h-1v-1z",
    fill: "#42423f"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M55 13v-1h1v1z",
    fill: "#4c4c47"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M60 13v-1h1v1z",
    fill: "#5a5954"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13h-1v-1h1z",
    fill: "#5f5e5b"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12v1h-1v-1z",
    fill: "#706e6a"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M75 12v1h-1v-1z",
    fill: "#837f7c"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M84 13h-1v-1h1z",
    fill: "#e4e5e0"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M87 13h-1v-1h1z",
    fill: "#f7f1f1"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M87 13v-1h1v1z",
    fill: "#f9f4f4"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M88 12h1v1h-1z",
    fill: "#faf7f6"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M90 12v1h-1v-1z",
    fill: "#f7f5f3"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M92 13h-1v-1h1z",
    fill: "#f2f0ef"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M92 13v-1h1v1z",
    fill: "#e5e4e3",
    fillOpacity: 0.98
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M94 12v1h-1v-1z",
    fill: "#e2e1e0",
    fillOpacity: 0.808
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M95 12v1h-1v-1z",
    fill: "#e3e2e0",
    fillOpacity: 0.518
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M96 13h-1v-1h1z",
    fill: "#e8e8e3",
    fillOpacity: 0.18
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13h1v1h-1z",
    fill: "#575757",
    fillOpacity: 0.114
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14h-1v-1h1z",
    fill: "#292929",
    fillOpacity: 0.502
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14v-1h1v1z",
    fill: "#21201f",
    fillOpacity: 0.871
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13v1h-1v-1z",
    fill: "#686762"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M69 14v-1h1v1z",
    fill: "#6f6c69"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M71 14h-1v-1h1z",
    fill: "#76726f"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M74 13v1h-1v-1z",
    fill: "#837d7a"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M81 14v-1h1v1z",
    fill: "#a8a3a1"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M82 13h1v1h-1z",
    fill: "#b1afab"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M85 14h-1v-1h1z",
    fill: "#c9c7c4"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M86 14v-1h1v1z",
    fill: "#ded9d8"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M87 13h1v1h-1z",
    fill: "#e1dddc"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M89 14h-1v-1h1z",
    fill: "#e8e5e4"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M89 14v-1h1v1z",
    fill: "#eeeceb"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M90 14v-1h1v1z",
    fill: "#f1f0ef"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M94 13h1v1h-1z",
    fill: "#d2d0cb"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M96 13v1h-1v-1z",
    fill: "#c7c6c2",
    fillOpacity: 0.925
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M96 13h1v1h-1z",
    fill: "#c5c5c4",
    fillOpacity: 0.596
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M98 13v1h-1v-1z",
    fill: "#d5dcdc",
    fillOpacity: 0.145
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15v-1h1v1z",
    fill: "#3e3c3e",
    fillOpacity: 0.4
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14v1h-1v-1z",
    fill: "#1e1d1d",
    fillOpacity: 0.882
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15v-1h1v1z",
    fill: "#191818"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M49 15h-1v-1h1z",
    fill: "#7f7e7b"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M68 15h-1v-1h1z",
    fill: "#7e7c79"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M84 15v-1h1v1z",
    fill: "#b6b1af"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M86 14h1v1h-1z",
    fill: "#b9b6b3"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M88 14v1h-1v-1z",
    fill: "#c2bebc"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M88 14h1v1h-1z",
    fill: "#ccc7c5"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M90 14v1h-1v-1z",
    fill: "#d4d0ce"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M91 15h-1v-1h1z",
    fill: "#d3d0d0"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M94 14v1h-1v-1z",
    fill: "#dfded7"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M95 14v1h-1v-1z",
    fill: "#d4d1cc"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M95 15v-1h1v1z",
    fill: "#c2c0bb"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M97 15v-1h1v1z",
    fill: "#b0afaf",
    fillOpacity: 0.878
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M99 15h-1v-1h1z",
    fill: "#c7c7c4",
    fillOpacity: 0.341
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16v-1h1v1z",
    fill: "#666363",
    fillOpacity: 0.392
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15h1v1h-1z",
    fill: "#22211f",
    fillOpacity: 0.992
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15v1h-1v-1z",
    fill: "#060503"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M51 15h1v1h-1z",
    fill: "#9e9d98"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v-1h1v1z",
    fill: "#999692"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h-1v-1h1z",
    fill: "#989290"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15h1v1h-1z",
    fill: "#8e8a87"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v1h-1v-1z",
    fill: "#908e8a"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h1v1h-1z",
    fill: "#9a9894"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16v-1h1v1z",
    fill: "#b4b1ad"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M90 15h1v1h-1z",
    fill: "#b8b3b1"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M92 16v-1h1v1z",
    fill: "#b6b1ad"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M94 16h-1v-1h1z",
    fill: "#aba6a2"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M99 16h-1v-1h1z",
    fill: "#a3a39e",
    fillOpacity: 0.965
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M99 15h1v1h-1z",
    fill: "#c0c0bc",
    fillOpacity: 0.302
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16h1v1h-1z",
    fill: "#444242",
    fillOpacity: 0.776
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17h-1v-1h1z",
    fill: "#191817"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16h1v1h-1z",
    fill: "#030200"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17v-1h1v1z",
    fill: "#81807d"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v1h-1v-1z",
    fill: "#bfbdba"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M68 16h1v1h-1z",
    fill: "#c3bcba"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M71 17h-1v-1h1z",
    fill: "#bab8b5"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16v1h-1v-1z",
    fill: "#b3b1ad"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M83 16v1h-1v-1z",
    fill: "#a59e9b"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v-1h1v1z",
    fill: "#aaaaa5"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16h1v1h-1z",
    fill: "#a7a5a1"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M90 17h-1v-1h1z",
    fill: "#bbb4b2"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M90 17v-1h1v1z",
    fill: "#a39c99"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M93 16h1v1h-1z",
    fill: "#aca5a3"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M94 16h1v1h-1z",
    fill: "#8c8684"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M96 16v1h-1v-1z",
    fill: "#898482"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M97 17h-1v-1h1z",
    fill: "#b7b4b1"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M100 16v1h-1v-1z",
    fill: "#a0a09d",
    fillOpacity: 0.69
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M100 16h1v1h-1z",
    fillOpacity: 0.004
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.059
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M29 18v-1h1v1z",
    fill: "#4d4d4d",
    fillOpacity: 0.843
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18v-1h1v1z",
    fill: "#171613"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17h1v1h-1z",
    fill: "#0c0a09"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17h1v1h-1z",
    fill: "#090806"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17h1v1h-1z",
    fill: "#7a7977"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M38 18h-1v-1h1z",
    fill: "#484746"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M43 18h-1v-1h1z",
    fill: "#7c7b7a"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18h-1v-1h1z",
    fill: "#c8c6c3"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M83 17v1h-1v-1z",
    fill: "#d2cbc9"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M92 18h-1v-1h1z",
    fill: "#bab6b2"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M95 18h-1v-1h1z",
    fill: "#b7b1ae"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M96 17h1v1h-1z",
    fill: "#716e6b"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M99 18v-1h1v1z",
    fill: "#5b5958",
    fillOpacity: 0.757
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M29 18h1v1h-1z",
    fill: "#9e9e9e",
    fillOpacity: 0.757
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M33 19v-1h1v1z",
    fill: "#1d1c19"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19h-1v-1h1z",
    fill: "#a3a29f"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h1v1h-1z",
    fill: "#d2cfcb"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M78 19h-1v-1h1z",
    fill: "#d1ceca"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M80 18h1v1h-1z",
    fill: "#ccc9c6"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18h1v1h-1z",
    fill: "#817f7b"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M98 19v-1h1v1z",
    fill: "#757471"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M100 19h-1v-1h1z",
    fill: "#3a3836",
    fillOpacity: 0.565
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19v1h-1v-1z",
    fill: "#d4d4d1",
    fillOpacity: 0.588
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M96 19h1v1h-1z",
    fill: "#8e8e89"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M99 20h-1v-1h1z",
    fill: "#4a4947",
    fillOpacity: 0.949
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M100 19v1h-1v-1z",
    fill: "#9b9696",
    fillOpacity: 0.2
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21h-1v-1h1z",
    fill: "#d9d9d7",
    fillOpacity: 0.502
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M32 20h1v1h-1z",
    fill: "#b3b2af"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M90 20h1v1h-1z",
    fill: "#d4d3ce"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M95 21h-1v-1h1z",
    fill: "#969592"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M99 20v1h-1v-1z",
    fill: "#9b9997",
    fillOpacity: 0.831
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22h-1v-1h1z",
    fill: "#dcd9d7",
    fillOpacity: 0.486
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21h1v1h-1z",
    fill: "#c6c2c0"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M36 21h1v1h-1z",
    fill: "#cecdc8"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h1v1h-1z",
    fill: "#d2d0cd"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M94 22h-1v-1h1z",
    fill: "#525150"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M97 21v1h-1v-1z",
    fill: "#797877"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M99 22h-1v-1h1z",
    fill: "#72716f",
    fillOpacity: 0.792
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23v-1h1v1z",
    fill: "#e0dcdc",
    fillOpacity: 0.486
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22h1v1h-1z",
    fill: "#e8e7e4"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22h1v1h-1z",
    fill: "#d5d5d0"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M50 22h1v1h-1z",
    fill: "#dad6d3"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22v1h-1v-1z",
    fill: "#c3c0bc"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M99 22v1h-1v-1z",
    fill: "#777673",
    fillOpacity: 0.776
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23h1v1h-1z",
    fill: "#e1dcda",
    fillOpacity: 0.467
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24v-1h1v1z",
    fill: "#6c6764"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24h-1v-1h1z",
    fill: "#918d8b"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24v-1h1v1z",
    fill: "#c3c4bf"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M46 23h1v1h-1z",
    fill: "#c7c8c3"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24v-1h1v1z",
    fill: "#c7c1bf"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24v-1h1v1z",
    fill: "#d8d2cf"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M53 24v-1h1v1z",
    fill: "#dbd6d3"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23h1v1h-1z",
    fill: "#aeaba7"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M99 24h-1v-1h1z",
    fill: "#8d8c8b",
    fillOpacity: 0.761
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M99 23h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25h-1v-1h1z",
    fill: "#dad8d8",
    fillOpacity: 0.439
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24v1h-1v-1z",
    fill: "#9d9a97"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M41 24h1v1h-1z",
    fill: "#d0cfca"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h-1v-1h1z",
    fill: "#d6d5d0"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24v1h-1v-1z",
    fill: "#d2d2ce"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h-1v-1h1z",
    fill: "#d4cfcd"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25h-1v-1h1z",
    fill: "#d3cdca"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M51 25h-1v-1h1z",
    fill: "#d0cac7"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M51 24h1v1h-1z",
    fill: "#cac4c1"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h1v1h-1z",
    fill: "#c0bab7"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M58 25h-1v-1h1z",
    fill: "#bdb6b3"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h-1v-1h1z",
    fill: "#c2bdb9"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M61 24v1h-1v-1z",
    fill: "#bebeba"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M82 24v1h-1v-1z",
    fill: "#999995"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M92 24h1v1h-1z",
    fill: "#42413e"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M98 24h1v1h-1z",
    fill: "#908f8c",
    fillOpacity: 0.741
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25h1v1h-1z",
    fill: "#dad8d8",
    fillOpacity: 0.416
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25h1v1h-1z",
    fill: "#9c9997"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h1v1h-1z",
    fill: "#cbc9c6"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M48 26h-1v-1h1z",
    fill: "#b1afaa"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M48 25h1v1h-1z",
    fill: "#afaba9"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v-1h1v1z",
    fill: "#95908c"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M59 26h-1v-1h1z",
    fill: "#9b9692"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M60 26v-1h1v1z",
    fill: "#92928f"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M62 25v1h-1v-1z",
    fill: "#939390"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26v-1h1v1z",
    fill: "#93928d"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M75 25v1h-1v-1z",
    fill: "#716f6b"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M75 26v-1h1v1z",
    fill: "#898784"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v1h-1v-1z",
    fill: "#9f9d99"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26v-1h1v1z",
    fill: "#a6a4a0"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26v-1h1v1z",
    fill: "#aaa8a4"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M88 26h-1v-1h1z",
    fill: "#dbd9d6"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M90 25h1v1h-1z",
    fill: "#9d9b97"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M99 26h-1v-1h1z",
    fill: "#92908e",
    fillOpacity: 0.718
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M30 27h-1v-1h1z",
    fill: "#d9d6d4",
    fillOpacity: 0.396
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26v1h-1v-1z",
    fill: "#fffefe"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27h-1v-1h1z",
    fill: "#fcfcfc"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26v1h-1v-1z",
    fill: "#f7f7f7"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27v-1h1v1z",
    fill: "#f0f0ee"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27h-1v-1h1z",
    fill: "#d8d4d0"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27h-1v-1h1z",
    fill: "#8b8986"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27v-1h1v1z",
    fill: "#7d7c79"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h1v1h-1z",
    fill: "#8e8d8a"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27v-1h1v1z",
    fill: "#989693"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M78 26v1h-1v-1z",
    fill: "#aba7a3"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26h1v1h-1z",
    fill: "#6a6663"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M92 26h1v1h-1z",
    fill: "#53504e"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M98 26h1v1h-1z",
    fill: "#959392",
    fillOpacity: 0.69
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M29 28v-1h1v1z",
    fill: "#d7d7d4",
    fillOpacity: 0.38
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h-1v-1h1z",
    fill: "#b4b1ae"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M31 27h1v1h-1z",
    fill: "#605c59"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v1h-1v-1z",
    fill: "#90908d"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v-1h1v1z",
    fill: "#ecece8"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27v1h-1v-1z",
    fill: "#f4eeeb"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M48 28v-1h1v1z",
    fill: "#e5e3de"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M51 27v1h-1v-1z",
    fill: "#b9b7b3"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27h1v1h-1z",
    fill: "#797673"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28v-1h1v1z",
    fill: "#7a7a77"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28v-1h1v1z",
    fill: "#807f7e"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h-1v-1h1z",
    fill: "#838181"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v-1h1v1z",
    fill: "#737371"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v-1h1v1z",
    fill: "#cdc8c5"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M91 27v1h-1v-1z",
    fill: "#928b89"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v-1h1v1z",
    fill: "#686360"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M92 28v-1h1v1z",
    fill: "#534f4d"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M99 27v1h-1v-1z",
    fill: "#939390",
    fillOpacity: 0.651
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28v1h-1v-1z",
    fill: "#d8d8d8",
    fillOpacity: 0.361
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h1v1h-1z",
    fill: "#615f5b"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M38 28v1h-1v-1z",
    fill: "#fdfdfd"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28v1h-1v-1z",
    fill: "#fefcf9"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M47 29v-1h1v1z",
    fill: "#eee9e5"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M49 29h-1v-1h1z",
    fill: "#e3e1dc"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M51 29v-1h1v1z",
    fill: "#b1aeaa"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29v-1h1v1z",
    fill: "#40403c"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28h1v1h-1z",
    fill: "#32322f"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M61 29h-1v-1h1z",
    fill: "#1f1d1d"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M61 28h1v1h-1z",
    fill: "#1c1b1a"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M73 29h-1v-1h1z",
    fill: "#2a2a28"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M74 28v1h-1v-1z",
    fill: "#403e3c"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29h-1v-1h1z",
    fill: "#a7a3a0"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28v1h-1v-1z",
    fill: "#eeede8"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28h1v1h-1z",
    fill: "#f4f2ef"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28v1h-1v-1z",
    fill: "#fbf7f4"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h1v1h-1z",
    fill: "#faf6f3"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v1h-1v-1z",
    fill: "#928a88"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M92 29v-1h1v1z",
    fill: "#524e4d"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M99 28v1h-1v-1z",
    fill: "#979796",
    fillOpacity: 0.62
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M30 29v1h-1v-1z",
    fill: "#d9d9d9",
    fillOpacity: 0.345
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h-1v-1h1z",
    fill: "#e8e5e0"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v1h-1v-1z",
    fill: "#d0d0cc"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v1h-1v-1z",
    fill: "#b4b2ae"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30v-1h1v1z",
    fill: "#302f2e"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30v-1h1v1z",
    fill: "#454340"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29v1h-1v-1z",
    fill: "#5e5956"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29v1h-1v-1z",
    fill: "#a5a19e"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M79 30h-1v-1h1z",
    fill: "#cecec9"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v-1h1v1z",
    fill: "#efece9"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30v-1h1v1z",
    fill: "#555250"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M99 30h-1v-1h1z",
    fill: "#a1a09e",
    fillOpacity: 0.6
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30h1v1h-1z",
    fill: "#dadad7",
    fillOpacity: 0.329
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30v1h-1v-1z",
    fill: "#fafafa"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30v1h-1v-1z",
    fill: "#e3e0db"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v-1h1v1z",
    fill: "#9a9390"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h1v1h-1z",
    fill: "#4c4a48"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31h-1v-1h1z",
    fill: "#5f5a57"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M82 30v1h-1v-1z",
    fill: "#f3efec"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31h-1v-1h1z",
    fill: "#8a8381"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M93 30v1h-1v-1z",
    fill: "#595654"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h1v1h-1z",
    fill: "#a3a3a2",
    fillOpacity: 0.592
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31v1h-1v-1z",
    fill: "#d5d5d5",
    fillOpacity: 0.31
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31v1h-1v-1z",
    fill: "#f8f8f8"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M47 31v1h-1v-1z",
    fill: "#f5f2ee"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32h-1v-1h1z",
    fill: "#e2dfda"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M49 31v1h-1v-1z",
    fill: "#dcd9d5"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v1h-1v-1z",
    fill: "#a39d9b"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31h1v1h-1z",
    fill: "#97908d"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M73 31v1h-1v-1z",
    fill: "#41413f"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v-1h1v1z",
    fill: "#54524f"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M74 31h1v1h-1z",
    fill: "#66605d"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M77 32h-1v-1h1z",
    fill: "#898381"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v-1h1v1z",
    fill: "#edeae7"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M91 32h-1v-1h1z",
    fill: "#928c89"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31h1v1h-1z",
    fill: "#5b5756"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M99 31v1h-1v-1z",
    fill: "#a7a7a4",
    fillOpacity: 0.573
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M30 33h-1v-1h1z",
    fill: "#d5d5d5",
    fillOpacity: 0.29
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32v1h-1v-1z",
    fill: "#b6b5b1",
    fillOpacity: 0.996
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h-1v-1h1z",
    fill: "#e1e0dd"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33v-1h1v1z",
    fill: "#f7f7f6"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v1h-1v-1z",
    fill: "#fefefd"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32v1h-1v-1z",
    fill: "#e1dfda"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M53 32v1h-1v-1z",
    fill: "#a6a09e"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33v-1h1v1z",
    fill: "#9a9391"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32v1h-1v-1z",
    fill: "#6c6a66"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M58 33v-1h1v1z",
    fill: "#64625e"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32v1h-1v-1z",
    fill: "#514f4c"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v1h-1v-1z",
    fill: "#33322f"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v1h-1v-1z",
    fill: "#484846"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M74 32v1h-1v-1z",
    fill: "#5b5956"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M92 32v1h-1v-1z",
    fill: "#746f6c"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h-1v-1h1z",
    fill: "#646160"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M98 32h1v1h-1z",
    fill: "#a9a7a5",
    fillOpacity: 0.549
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M29 33h1v1h-1z",
    fill: "#dbd7d3",
    fillOpacity: 0.278
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M31 33v1h-1v-1z",
    fill: "#bcb8b5",
    fillOpacity: 0.992
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h-1v-1h1z",
    fill: "#7b7774"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33v1h-1v-1z",
    fill: "#989593"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h1v1h-1z",
    fill: "#f5f5f3"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M59 33h1v1h-1z",
    fill: "#5c5855"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33v1h-1v-1z",
    fill: "#383734"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33v1h-1v-1z",
    fill: "#5e5c59"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h1v1h-1z",
    fill: "#f1efec"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33v1h-1v-1z",
    fill: "#f9f6f2"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h1v1h-1z",
    fill: "#f2f0ec"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v1h-1v-1z",
    fill: "#dbd6d4"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33v1h-1v-1z",
    fill: "#87807e"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h1v1h-1z",
    fill: "#575755"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M98 34v-1h1v1z",
    fill: "#a9a7a5",
    fillOpacity: 0.514
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M29 35v-1h1v1z",
    fill: "#dad6d2",
    fillOpacity: 0.271
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M31 35h-1v-1h1z",
    fill: "#bdb8b6",
    fillOpacity: 0.992
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h1v1h-1z",
    fill: "#969391"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M41 35h-1v-1h1z",
    fill: "#fffeff"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v1h-1v-1z",
    fill: "#b7b5b1"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34v1h-1v-1z",
    fill: "#aca6a4"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34v1h-1v-1z",
    fill: "#615d5a"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35v-1h1v1z",
    fill: "#494944"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M73 35v-1h1v1z",
    fill: "#5b5957"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v-1h1v1z",
    fill: "#706b68"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M78 34v1h-1v-1z",
    fill: "#9f9b98"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M81 34h1v1h-1z",
    fill: "#efeeeb"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M84 35h-1v-1h1z",
    fill: "#f6f4f0"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M85 34v1h-1v-1z",
    fill: "#f7f5f2"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35h-1v-1h1z",
    fill: "#f5f5f0"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h1v1h-1z",
    fill: "#908987"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35v-1h1v1z",
    fill: "#6b6766"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M99 34v1h-1v-1z",
    fill: "#acaaa7",
    fillOpacity: 0.482
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36v-1h1v1z",
    fill: "#d8d5d5",
    fillOpacity: 0.263
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M30 35h1v1h-1z",
    fill: "#c0b9b7",
    fillOpacity: 0.988
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v-1h1v1z",
    fill: "#867f7d"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35h1v1h-1z",
    fill: "#9d9996"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35h1v1h-1z",
    fill: "#fdfbfb"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36h-1v-1h1z",
    fill: "#fefcfd"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v1h-1v-1z",
    fill: "#fbfbf9"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1z",
    fill: "#aba5a2"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M59 35h1v1h-1z",
    fill: "#64615e"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35h1v1h-1z",
    fill: "#484844"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v1h-1v-1z",
    fill: "#5e5c5a"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v-1h1v1z",
    fill: "#f3f3ef"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M91 35v1h-1v-1z",
    fill: "#958f8c"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M92 36v-1h1v1z",
    fill: "#6f6c6a"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35h1v1h-1z",
    fill: "#acacaa",
    fillOpacity: 0.463
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M30 37h-1v-1h1z",
    fill: "#dedada",
    fillOpacity: 0.247
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v1h-1v-1z",
    fill: "#c4bdbb",
    fillOpacity: 0.984
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36h1v1h-1z",
    fill: "#908a87"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36h1v1h-1z",
    fill: "#a39f9d"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37v-1h1v1z",
    fill: "#fdfbfc"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M41 37v-1h1v1z",
    fill: "#fdfcfc"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M59 37h-1v-1h1z",
    fill: "#6f6a67"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M59 36h1v1h-1z",
    fill: "#6b6764"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M61 37h-1v-1h1z",
    fill: "#5f5f5b"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36v1h-1v-1z",
    fill: "#4e4d4a"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v-1h1v1z",
    fill: "#605e5b"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36h1v1h-1z",
    fill: "#f3f3ee"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M93 36v1h-1v-1z",
    fill: "#73706f"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M97 36v1h-1v-1z",
    fill: "#31302d"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M98 36h1v1h-1z",
    fill: "#adabab",
    fillOpacity: 0.431
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38v-1h1v1z",
    fill: "#d7d7d7",
    fillOpacity: 0.227
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M31 37v1h-1v-1z",
    fill: "#c1c0bd",
    fillOpacity: 0.976
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37v1h-1v-1z",
    fill: "#64605d"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h-1v-1h1z",
    fill: "#5c5c57"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M70 38v-1h1v1z",
    fill: "#52514d"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37h1v1h-1z",
    fill: "#63615d"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37v1h-1v-1z",
    fill: "#c0bfba"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h-1v-1h1z",
    fill: "#9b9491"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M93 38h-1v-1h1z",
    fill: "#797675"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38v-1h1v1z",
    fill: "#5f5e5d"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M97 37h1v1h-1z",
    fill: "#666662"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M98 38v-1h1v1z",
    fill: "#b4b4b2",
    fillOpacity: 0.404
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38h1v1h-1z",
    fill: "#dadad6",
    fillOpacity: 0.22
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M30 38h1v1h-1z",
    fill: "#c2c1be",
    fillOpacity: 0.973
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M33 38v1h-1v-1z",
    fill: "#9b9a97"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v1h-1v-1z",
    fill: "#e1e0db"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38h1v1h-1z",
    fill: "#686461"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M64 38v1h-1v-1z",
    fill: "#474643"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M72 39v-1h1v1z",
    fill: "#54544f"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M89 39v-1h1v1z",
    fill: "#b7b0ae"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M91 39h-1v-1h1z",
    fill: "#a19a97"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M92 38h1v1h-1z",
    fill: "#807d7b"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h1v1h-1z",
    fill: "#4e4d4c"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M96 38h1v1h-1z",
    fill: "#2e2d29"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M98 39v-1h1v1z",
    fill: "#b5b2b2",
    fillOpacity: 0.392
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M30 39v1h-1v-1z",
    fill: "#d8d8d3",
    fillOpacity: 0.208
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40h-1v-1h1z",
    fill: "#cac9c5",
    fillOpacity: 0.969
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M61 40v-1h1v1z",
    fill: "#62625e"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M63 39h1v1h-1z",
    fill: "#4d4c49"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39h1v1h-1z",
    fill: "#3a3938"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40h-1v-1h1z",
    fill: "#6b6965"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M76 39h1v1h-1z",
    fill: "#98928f"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v1h-1v-1z",
    fill: "#f6f6f2"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M87 39v1h-1v-1z",
    fill: "#f5f3f0"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M90 40h-1v-1h1z",
    fill: "#bab4b2"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M90 39h1v1h-1z",
    fill: "#a39c9a"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v-1h1v1z",
    fill: "#6c6967"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M95 39v1h-1v-1z",
    fill: "#403f3e"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M99 39v1h-1v-1z",
    fill: "#afacac",
    fillOpacity: 0.365
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h1v1h-1z",
    fill: "#d0d0d0",
    fillOpacity: 0.192
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v1h-1v-1z",
    fill: "#cbcbc7",
    fillOpacity: 0.953
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v-1h1v1z",
    fill: "#f3f1f1"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v1h-1v-1z",
    fill: "#7c7976"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40v1h-1v-1z",
    fill: "#70706c"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M63 41v-1h1v1z",
    fill: "#5a5956"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M73 40v1h-1v-1z",
    fill: "#5e5e5a"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40v1h-1v-1z",
    fill: "#6b6966"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M87 41v-1h1v1z",
    fill: "#e6e6e2"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M88 40h1v1h-1z",
    fill: "#ceccc9"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M91 40v1h-1v-1z",
    fill: "#8d8684"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41v-1h1v1z",
    fill: "#787776"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M98 40h1v1h-1z",
    fill: "#b8b8b8",
    fillOpacity: 0.341
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M30 41v1h-1v-1z",
    fill: "#ddddd7",
    fillOpacity: 0.176
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M31 42h-1v-1h1z",
    fill: "#bfbebb",
    fillOpacity: 0.945
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M36 41h1v1h-1z",
    fill: "#c5c4c1"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v1h-1v-1z",
    fill: "#fbfaf9"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42h-1v-1h1z",
    fill: "#f4f2f2"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v1h-1v-1z",
    fill: "#cbc8c5"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42v-1h1v1z",
    fill: "#ada7a4"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h1v1h-1z",
    fill: "#908e8b"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42v-1h1v1z",
    fill: "#807f7c"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M64 42h-1v-1h1z",
    fill: "#63625f"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M72 42h-1v-1h1z",
    fill: "#5c5b59"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M73 41v1h-1v-1z",
    fill: "#6a6a67"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v1h-1v-1z",
    fill: "#757371"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M84 41h1v1h-1z",
    fill: "#eae8e5"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M86 42h-1v-1h1z",
    fill: "#e4e2de"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42h-1v-1h1z",
    fill: "#9a9694"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M93 41h1v1h-1z",
    fill: "#969291"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41h1v1h-1z",
    fill: "#7f7c7c"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M97 41v1h-1v-1z",
    fill: "#181713"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42v-1h1v1z",
    fill: "#6f6e6b"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M99 42h-1v-1h1z",
    fill: "#c4c4c1",
    fillOpacity: 0.325
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M29 43v-1h1v1z",
    fill: "#d9d9d3",
    fillOpacity: 0.161
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42h1v1h-1z",
    fill: "#c6c5c1",
    fillOpacity: 0.933
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42v1h-1v-1z",
    fill: "#e8e6e6"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M48 42v1h-1v-1z",
    fill: "#deddda"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M51 43v-1h1v1z",
    fill: "#c6c3c0"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M56 43v-1h1v1z",
    fill: "#979490"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M74 43h-1v-1h1z",
    fill: "#666462"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43h-1v-1h1z",
    fill: "#7d7774"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M77 42v1h-1v-1z",
    fill: "#8f8886"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M79 43v-1h1v1z",
    fill: "#b7b7b3"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h-1v-1h1z",
    fill: "#e4e4df"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42v1h-1v-1z",
    fill: "#8e8a89"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M93 43v-1h1v1z",
    fill: "#62605e"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43h-1v-1h1z",
    fill: "#2c2a2a"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h-1v-1h1z",
    fill: "#141310"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42h1v1h-1z",
    fill: "#a1a09c",
    fillOpacity: 0.996
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43h-1v-1h1z",
    fill: "#b3b3af",
    fillOpacity: 0.29
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h-1v-1h1z",
    fill: "#dadad3",
    fillOpacity: 0.137
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44v-1h1v1z",
    fill: "#cdcdc9",
    fillOpacity: 0.918
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M45 44v-1h1v1z",
    fill: "#e9e7e6"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44v-1h1v1z",
    fill: "#343230"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M74 44v-1h1v1z",
    fill: "#504b48"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M76 43v1h-1v-1z",
    fill: "#645e5b"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44h-1v-1h1z",
    fill: "#b3b0ad"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43h1v1h-1z",
    fill: "#dcd9d6"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v1h-1v-1z",
    fill: "#fcfaf6"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h1v1h-1z",
    fill: "#fdfaf7"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M92 43h1v1h-1z",
    fill: "#43413f"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43v1h-1v-1z",
    fill: "#494847"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M98 43v1h-1v-1z",
    fill: "#71706d",
    fillOpacity: 0.98
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v1h-1v-1z",
    fill: "#ababa7",
    fillOpacity: 0.239
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45h-1v-1h1z",
    fill: "#d4d4d4",
    fillOpacity: 0.118
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h1v1h-1z",
    fill: "#c6c5c2",
    fillOpacity: 0.902
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M46 44v1h-1v-1z",
    fill: "#f9f8f7"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44v1h-1v-1z",
    fill: "#9f9c99"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45v-1h1v1z",
    fill: "#51504d"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M61 44h1v1h-1z",
    fill: "#4f4e4d"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v-1h1v1z",
    fill: "#565554"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44h1v1h-1z",
    fill: "#676663"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45h-1v-1h1z",
    fill: "#817e7a"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M76 45h-1v-1h1z",
    fill: "#94918d"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M76 44h1v1h-1z",
    fill: "#a5a29f"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v1h-1v-1z",
    fill: "#8c8986"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45h-1v-1h1z",
    fill: "#63605d"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M94 45h-1v-1h1z",
    fill: "#9c9c9a"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44v1h-1v-1z",
    fill: "#aba9a9"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45v-1h1v1z",
    fill: "#22211c"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M98 45h-1v-1h1z",
    fill: "#6f6e6a",
    fillOpacity: 0.969
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M98 44h1v1h-1z",
    fill: "#d5d5d0",
    fillOpacity: 0.216
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h1v1h-1z",
    fill: "#e0e0e0",
    fillOpacity: 0.098
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M31 45v1h-1v-1z",
    fill: "#c4c3bf",
    fillOpacity: 0.886
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h-1v-1h1z",
    fill: "#f2f1f0"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v-1h1v1z",
    fill: "#d7d8d3"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M54 46h-1v-1h1z",
    fill: "#d5d3cf"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46h-1v-1h1z",
    fill: "#bfbebd"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h1v1h-1z",
    fill: "#bebcbb"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45h1v1h-1z",
    fill: "#abaaa7"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45v1h-1v-1z",
    fill: "#d2ceca"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M90 46h-1v-1h1z",
    fill: "#b4b2af"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M95 46h-1v-1h1z",
    fill: "#393737"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M97 45h1v1h-1z",
    fill: "#aeada8",
    fillOpacity: 0.965
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M99 45v1h-1v-1z",
    fill: "#b3b3ae",
    fillOpacity: 0.212
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M29 46h1v1h-1z",
    fill: "#dadada",
    fillOpacity: 0.082
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M31 47h-1v-1h1z",
    fill: "#d2d1cd",
    fillOpacity: 0.871
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-1v-1h1z",
    fill: "#dbdad9"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1z",
    fill: "#a19e9b"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v-1h1v1z",
    fill: "#9b9995"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46v1h-1v-1z",
    fill: "#8f8d8c"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v1h-1v-1z",
    fill: "#8e8c8c"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M78 46v1h-1v-1z",
    fill: "#94928e"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M79 47h-1v-1h1z",
    fill: "#a09a97"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47h-1v-1h1z",
    fill: "#c0b9b7"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M83 46v1h-1v-1z",
    fill: "#dcd7d5"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h1v1h-1z",
    fill: "#efebe8"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47v-1h1v1z",
    fill: "#797873",
    fillOpacity: 0.941
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M99 47h-1v-1h1z",
    fill: "#afafaf",
    fillOpacity: 0.176
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h1v1h-1z",
    fill: "#e2e2e2",
    fillOpacity: 0.071
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h-1v-1h1z",
    fill: "#ccccc7",
    fillOpacity: 0.851
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48v-1h1v1z",
    fill: "#c1c0bd"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47h1v1h-1z",
    fill: "#f4f3f2"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v1h-1v-1z",
    fill: "#a3a19d"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M61 47v1h-1v-1z",
    fill: "#2a2928"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47h1v1h-1z",
    fill: "#4b4a47"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M82 47v1h-1v-1z",
    fill: "#f6f0ed"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M94 47v1h-1v-1z",
    fill: "#9a9998"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v-1h1v1z",
    fill: "#aeacac"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h1v1h-1z",
    fill: "#767573"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M96 48v-1h1v1z",
    fill: "#292723"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h1v1h-1z",
    fill: "#72716e",
    fillOpacity: 0.918
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h-1v-1h1z",
    fill: "#e1e1e1",
    fillOpacity: 0.067
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M31 49h-1v-1h1z",
    fill: "#c6c6c2",
    fillOpacity: 0.847
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v-1h1v1z",
    fill: "#b8b7b4"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M45 49v-1h1v1z",
    fill: "#f6f4f4"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M60 48h1v1h-1z",
    fill: "#a8a7a5"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-1z",
    fill: "#a5a4a3"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49v-1h1v1z",
    fill: "#c8c5c1"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49v-1h1v1z",
    fill: "#dfdcd8"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M91 49h-1v-1h1z",
    fill: "#b0b0ac"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v1h-1v-1z",
    fill: "#8d8c8b"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M95 49h-1v-1h1z",
    fill: "#3c3a3a"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M97 49v-1h1v1z",
    fill: "#adada8",
    fillOpacity: 0.918
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48h1v1h-1z",
    fill: "#bfbfbf",
    fillOpacity: 0.141
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49v1h-1v-1z",
    fill: "#dfdfdf",
    fillOpacity: 0.063
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h1v1h-1z",
    fill: "#d1d0cd",
    fillOpacity: 0.835
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v-1h1v1z",
    fill: "#565552"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M44 49h1v1h-1z",
    fill: "#e1dfde"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v-1h1v1z",
    fill: "#c5c1bd"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50v-1h1v1z",
    fill: "#b5b5b1"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M56 49v1h-1v-1z",
    fill: "#adaca9"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50v-1h1v1z",
    fill: "#979792"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h1v1h-1z",
    fill: "#9d9d98"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M80 50h-1v-1h1z",
    fill: "#ababa6"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h-1v-1h1z",
    fill: "#f6efed"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50v-1h1v1z",
    fill: "#40403f"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M95 50v-1h1v1z",
    fill: "#8d8a88"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50v-1h1v1z",
    fill: "#878481",
    fillOpacity: 0.878
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M99 49v1h-1v-1z",
    fill: "#bfbfb4",
    fillOpacity: 0.094
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51h-1v-1h1z",
    fill: "#d7d7d7",
    fillOpacity: 0.051
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51v-1h1v1z",
    fill: "#cfcdcc",
    fillOpacity: 0.816
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M44 50h1v1h-1z",
    fill: "#f7f5f4"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v1h-1v-1z",
    fill: "#cccac8"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h-1v-1h1z",
    fill: "#7c7c77"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50h1v1h-1z",
    fill: "#1b1a19"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M79 50v1h-1v-1z",
    fill: "#aba9a6"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50v1h-1v-1z",
    fill: "#fbf5f3"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51h-1v-1h1z",
    fill: "#878782"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51h-1v-1h1z",
    fill: "#aeaead"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v1h-1v-1z",
    fill: "#817d7b"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50h1v1h-1z",
    fill: "#393330"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50h1v1h-1z",
    fill: "#807b79",
    fillOpacity: 0.839
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.063
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M30 52v-1h1v1z",
    fill: "#c6c6c3",
    fillOpacity: 0.796
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h-1v-1h1z",
    fill: "#acabaa"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51v1h-1v-1z",
    fill: "#cdcbc9"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52h-1v-1h1z",
    fill: "#d6d3d0"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52h-1v-1h1z",
    fill: "#f8f8f6"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M47 51v1h-1v-1z",
    fill: "#e9e9e6"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h-1v-1h1z",
    fill: "#e7e5e3"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51h1v1h-1z",
    fill: "#e3dfdc"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51v1h-1v-1z",
    fill: "#414140"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M96 52h-1v-1h1z",
    fill: "#1f1c1a"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52h-1v-1h1z",
    fill: "#aea9a6",
    fillOpacity: 0.816
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M31 52v1h-1v-1z",
    fill: "#cfcdcc",
    fillOpacity: 0.773
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h1v1h-1z",
    fill: "#71706d"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52h1v1h-1z",
    fill: "#e6e6e3"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M46 53v-1h1v1z",
    fill: "#dcdcda"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52v1h-1v-1z",
    fill: "#d8d6d3"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M77 52h1v1h-1z",
    fill: "#a7a5a2"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M87 52v1h-1v-1z",
    fill: "#f6f2ee"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M90 53h-1v-1h1z",
    fill: "#c7c7c3"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h-1v-1h1z",
    fill: "#484847"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M95 52h1v1h-1z",
    fill: "#928f8d"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52v1h-1v-1z",
    fill: "#86827f",
    fillOpacity: 0.761
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M30 54v-1h1v1z",
    fill: "#cecccb",
    fillOpacity: 0.737
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v-1h1v1z",
    fill: "#8d8b89"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54v-1h1v1z",
    fill: "#84807d"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M45 53v1h-1v-1z",
    fill: "#edeceb"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54h-1v-1h1z",
    fill: "#dfdfde"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53v1h-1v-1z",
    fill: "#d1d1cf"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M50 53v1h-1v-1z",
    fill: "#b5aeab"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M80 54h-1v-1h1z",
    fill: "#bdb6b4"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54v-1h1v1z",
    fill: "#fbfbf7"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h1v1h-1z",
    fill: "#b7b4b0"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M89 53h1v1h-1z",
    fill: "#8b8b87"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M94 53h1v1h-1z",
    fill: "#aaaaa7"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53h1v1h-1z",
    fill: "#3e3935"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v-1h1v1z",
    fill: "#8d8986",
    fillOpacity: 0.741
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M31 54v1h-1v-1z",
    fill: "#c8c8c5",
    fillOpacity: 0.718
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55h-1v-1h1z",
    fill: "#b0aba9"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55h-1v-1h1z",
    fill: "#ada9a6"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54v1h-1v-1z",
    fill: "#f5f5f4"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54h1v1h-1z",
    fill: "#e2dfdd"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M73 55v-1h1v1z",
    fill: "#82817e"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54h1v1h-1z",
    fill: "#acaba6"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54h1v1h-1z",
    fill: "#c5c0bd"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h-1v-1h1z",
    fill: "#cbc5c3"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M81 55v-1h1v1z",
    fill: "#edebe8"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54h1v1h-1z",
    fill: "#e6e4e0"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54h1v1h-1z",
    fill: "#a09d99"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M90 55h-1v-1h1z",
    fill: "#94928f"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54v1h-1v-1z",
    fill: "#898883"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M94 55v-1h1v1z",
    fill: "#3b3b38"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M95 54h1v1h-1z",
    fill: "#1f1c18"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v1h-1v-1z",
    fill: "#7a7470"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M97 55v-1h1v1z",
    fill: "#b4afad",
    fillOpacity: 0.733
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M31 55v1h-1v-1z",
    fill: "#cdccca",
    fillOpacity: 0.706
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56h-1v-1h1z",
    fill: "#c7c4c0"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M43 55h1v1h-1z",
    fill: "#efedeb"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M50 56h-1v-1h1z",
    fill: "#dbd7d3"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55v1h-1v-1z",
    fill: "#eae6e3"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M93 55h1v1h-1z",
    fill: "#2a2925"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56h-1v-1h1z",
    fill: "#444340"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v-1h1v1z",
    fill: "#9c9895",
    fillOpacity: 0.702
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M30 57v-1h1v1z",
    fill: "#cececc",
    fillOpacity: 0.686
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56h1v1h-1z",
    fill: "#d8d7d6"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h1v1h-1z",
    fill: "#c7c7c4"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M49 56v1h-1v-1z",
    fill: "#b7b6b1"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v1h-1v-1z",
    fill: "#a6a4a1"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M56 56v1h-1v-1z",
    fill: "#8a8986"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M63 57h-1v-1h1z",
    fill: "#908f8d"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M80 56v1h-1v-1z",
    fill: "#b2b3ae"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57v-1h1v1z",
    fill: "#fefaf7"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M90 57v-1h1v1z",
    fill: "#6b6462"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57h-1v-1h1z",
    fill: "#4f4b48"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v-1h1v1z",
    fill: "#625f5c"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57h-1v-1h1z",
    fill: "#898581"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v1h-1v-1z",
    fill: "#716c68"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57v-1h1v1z",
    fill: "#948f8c",
    fillOpacity: 0.675
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v-1h1v1z",
    fill: "#cdccca",
    fillOpacity: 0.667
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M50 57h1v1h-1z",
    fill: "#bbbab5"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57h1v1h-1z",
    fill: "#bcbcb7"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M79 58v-1h1v1z",
    fill: "#c6c6c1"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58v-1h1v1z",
    fill: "#aba8a4"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M95 58h-1v-1h1z",
    fill: "#656662"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57v1h-1v-1z",
    fill: "#43413d"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M96 58v-1h1v1z",
    fill: "#746f6b"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57h1v1h-1z",
    fill: "#a29e9b",
    fillOpacity: 0.663
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59v-1h1v1z",
    fill: "#cccbcb",
    fillOpacity: 0.655
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M33 58v1h-1v-1z",
    fill: "#abaaa8"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v1h-1v-1z",
    fill: "#f6f6f4"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M51 58v1h-1v-1z",
    fill: "#dfded9"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58h1v1h-1z",
    fill: "#7c7875"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M93 59v-1h1v1z",
    fill: "#555350"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M95 59v-1h1v1z",
    fill: "#6b6763"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M97 58v1h-1v-1z",
    fill: "#8e8985"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M97 59v-1h1v1z",
    fill: "#a5a19e",
    fillOpacity: 0.651
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59h1v1h-1z",
    fill: "#cdcbca",
    fillOpacity: 0.643
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M55 59h1v1h-1z",
    fill: "#bab9b6"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59h1v1h-1z",
    fill: "#faf7f4"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M85 60v-1h1v1z",
    fill: "#fefbf7"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60h-1v-1h1z",
    fill: "#f8f5f2"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h1v1h-1z",
    fill: "#8d8985"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M95 60h-1v-1h1z",
    fill: "#7e7a78"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h-1v-1h1z",
    fill: "#807c78"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M98 59v1h-1v-1z",
    fill: "#a5a09d",
    fillOpacity: 0.635
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61v-1h1v1z",
    fill: "#cccbc9",
    fillOpacity: 0.635
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M55 61v-1h1v1z",
    fill: "#464542"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M74 60v1h-1v-1z",
    fill: "#282724"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M86 60h1v1h-1z",
    fill: "#ddddd9"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M88 60h1v1h-1z",
    fill: "#b7b3b0"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v-1h1v1z",
    fill: "#827b78"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h1v1h-1z",
    fill: "#908986"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M98 61h-1v-1h1z",
    fill: "#a8a3a0",
    fillOpacity: 0.624
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h1v1h-1z",
    fill: "#cdccca",
    fillOpacity: 0.612
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62h-1v-1h1z",
    fill: "#fafaf8"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M47 62h-1v-1h1z",
    fill: "#e5e4df"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M47 61h1v1h-1z",
    fill: "#e3e2dd"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h-1v-1h1z",
    fill: "#a4a3a0"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M76 62h-1v-1h1z",
    fill: "#afafab"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M89 61h1v1h-1z",
    fill: "#b1aba9"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62v-1h1v1z",
    fill: "#a7a19f"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v1h-1v-1z",
    fill: "#827d7c"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61h1v1h-1z",
    fill: "#837c79"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M97 61v1h-1v-1z",
    fill: "#918b87"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M97 62v-1h1v1z",
    fill: "#aca8a5",
    fillOpacity: 0.604
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h1v1h-1z",
    fill: "#cfcfcc",
    fillOpacity: 0.588
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M43 63v-1h1v1z",
    fill: "#ecebe8"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v1h-1v-1z",
    fill: "#bbbab9"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M75 62v1h-1v-1z",
    fill: "#a9a6a3"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63v-1h1v1z",
    fill: "#aba9a5"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62h1v1h-1z",
    fill: "#a9a3a0"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M95 62h1v1h-1z",
    fill: "#847e7b"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M96 63v-1h1v1z",
    fill: "#938d89"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M98 62v1h-1v-1z",
    fill: "#aea8a7",
    fillOpacity: 0.58
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M31 64h-1v-1h1z",
    fill: "#cfcfcc",
    fillOpacity: 0.569
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64v-1h1v1z",
    fill: "#b2b1ae"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63h1v1h-1z",
    fill: "#f3f2ef"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M59 63v1h-1v-1z",
    fill: "#7e7d7a"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64v-1h1v1z",
    fill: "#848381"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M61 64h-1v-1h1z",
    fill: "#848281"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M62 63v1h-1v-1z",
    fill: "#7d7b7b"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M62 64v-1h1v1z",
    fill: "#797976"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M73 64v-1h1v1z",
    fill: "#444240"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M74 63h1v1h-1z",
    fill: "#57524f"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63v1h-1v-1z",
    fill: "#d6d6d2"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M95 63v1h-1v-1z",
    fill: "#878280"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64v-1h1v1z",
    fill: "#86807d"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64v-1h1v1z",
    fill: "#afaaa8",
    fillOpacity: 0.541
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M30 64h1v1h-1z",
    fill: "#d1cfcd",
    fillOpacity: 0.545
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64h1v1h-1z",
    fill: "#f2f1ec"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64h1v1h-1z",
    fill: "#2f2e2d"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M61 65v-1h1v1z",
    fill: "#222120"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65h-1v-1h1z",
    fill: "#4d4b49"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65v-1h1v1z",
    fill: "#cbccc7"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65v-1h1v1z",
    fill: "#b8b2af"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M95 65h-1v-1h1z",
    fill: "#8a8483"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64v1h-1v-1z",
    fill: "#9d9793"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64h1v1h-1z",
    fill: "#b3adab",
    fillOpacity: 0.518
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66v-1h1v1z",
    fill: "#d0d0cf",
    fillOpacity: 0.522
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66h-1v-1h1z",
    fill: "#edece7"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65h1v1h-1z",
    fill: "#ecece7"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M45 66v-1h1v1z",
    fill: "#e6e6e1"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65v1h-1v-1z",
    fill: "#aeadaa"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M60 66v-1h1v1z",
    fill: "#999796"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M62 65v1h-1v-1z",
    fill: "#8b8a89"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M94 65h1v1h-1z",
    fill: "#8c8785"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M96 65h1v1h-1z",
    fill: "#a7a19d"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M97 65h1v1h-1z",
    fill: "#b9b5b1",
    fillOpacity: 0.502
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66h1v1h-1z",
    fill: "#cfcfcd",
    fillOpacity: 0.51
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M32 67v-1h1v1z",
    fill: "#bcbbb8"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v1h-1v-1z",
    fill: "#f2efec"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66v1h-1v-1z",
    fill: "#f3eeeb"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h-1v-1h1z",
    fill: "#e4e4e0"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67v-1h1v1z",
    fill: "#b8b7b2"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M74 67h-1v-1h1z",
    fill: "#868482"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66v1h-1v-1z",
    fill: "#9b9793"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66v1h-1v-1z",
    fill: "#d9dad5"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M95 66v1h-1v-1z",
    fill: "#8f8a88"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M96 67h-1v-1h1z",
    fill: "#9a9491"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M97 66v1h-1v-1z",
    fill: "#aea8a4"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M98 67h-1v-1h1z",
    fill: "#bab4b2",
    fillOpacity: 0.494
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67h1v1h-1z",
    fill: "#d3d3d1",
    fillOpacity: 0.486
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68v-1h1v1z",
    fill: "#fdf7f4"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M41 67h1v1h-1z",
    fill: "#fdf5f3"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67h1v1h-1z",
    fill: "#6d6c67"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67v1h-1v-1z",
    fill: "#2b2a26"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M75 68v-1h1v1z",
    fill: "#4c4a46"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M77 67v1h-1v-1z",
    fill: "#767470"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M88 68h-1v-1h1z",
    fill: "#d2d3ce"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68h-1v-1h1z",
    fill: "#b2acaa"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M93 68v-1h1v1z",
    fill: "#9a9492"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68h-1v-1h1z",
    fill: "#9f9998"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M98 67v1h-1v-1z",
    fill: "#c4bebc",
    fillOpacity: 0.478
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69v-1h1v1z",
    fill: "#d6d4d4",
    fillOpacity: 0.471
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69h-1v-1h1z",
    fill: "#f8f1ef"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M44 69v-1h1v1z",
    fill: "#f1edea"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h-1v-1h1z",
    fill: "#a5a49f"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M73 68v1h-1v-1z",
    fill: "#686766"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M76 69h-1v-1h1z",
    fill: "#a9a7a3"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M88 68v1h-1v-1z",
    fill: "#cfd0cb"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68v1h-1v-1z",
    fill: "#a39e9c"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M98 69h-1v-1h1z",
    fill: "#c5c1bf",
    fillOpacity: 0.455
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69h1v1h-1z",
    fill: "#d4d2cf",
    fillOpacity: 0.467
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70v-1h1v1z",
    fill: "#e4e0de"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M39 70h-1v-1h1z",
    fill: "#f1edeb"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v1h-1v-1z",
    fill: "#e9e4e2"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69h1v1h-1z",
    fill: "#bdbbb9"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M94 70v-1h1v1z",
    fill: "#948f8d"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M98 69v1h-1v-1z",
    fill: "#c3bebc",
    fillOpacity: 0.435
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71v-1h1v1z",
    fill: "#d8d6d4",
    fillOpacity: 0.443
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70h1v1h-1z",
    fill: "#e2dfde"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M38 71v-1h1v1z",
    fill: "#f7f3f2"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M40 70v1h-1v-1z",
    fill: "#fffcfb"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M41 71h-1v-1h1z",
    fill: "#fffdfc"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71h-1v-1h1z",
    fill: "#fdfaf9"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M43 70h1v1h-1z",
    fill: "#f0ede9"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70h1v1h-1z",
    fill: "#a5a4a1"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M94 70h1v1h-1z",
    fill: "#938d8c"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M97 71h-1v-1h1z",
    fill: "#bbb5b1"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M98 70v1h-1v-1z",
    fill: "#c2c0bb",
    fillOpacity: 0.431
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h1v1h-1z",
    fill: "#d9d9d7",
    fillOpacity: 0.427
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72v-1h1v1z",
    fill: "#dddbd9"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72v-1h1v1z",
    fill: "#fdfef9"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M57 72h-1v-1h1z",
    fill: "#363531"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M98 72h-1v-1h1z",
    fill: "#c9c4c1",
    fillOpacity: 0.376
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h1v1h-1z",
    fill: "#d6d6d3",
    fillOpacity: 0.416
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73h-1v-1h1z",
    fill: "#eaeae7"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72h1v1h-1z",
    fill: "#f7f7f2"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73v-1h1v1z",
    fill: "#f1f1ec"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72h1v1h-1z",
    fill: "#9c9b99"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M74 73v-1h1v1z",
    fill: "#cac9c4"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72h1v1h-1z",
    fill: "#aea8a7"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M96 73v-1h1v1z",
    fill: "#b8b2ae"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M98 72v1h-1v-1z",
    fill: "#d1cecc",
    fillOpacity: 0.353
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74v-1h1v1z",
    fill: "#d4d4d2",
    fillOpacity: 0.4
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v1h-1v-1z",
    fill: "#e2e2df"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M39 73v1h-1v-1z",
    fill: "#f7f7f5"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M94 73h1v1h-1z",
    fill: "#948e8d"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M98 74h-1v-1h1z",
    fill: "#c5bfbc",
    fillOpacity: 0.329
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74h1v1h-1z",
    fill: "#d6d6d4",
    fillOpacity: 0.373
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M36 75v-1h1v1z",
    fill: "#dcdbd8"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74h1v1h-1z",
    fill: "#efeeed"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M46 74h1v1h-1z",
    fill: "#dddddb"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75h-1v-1h1z",
    fill: "#353433"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M69 75h-1v-1h1z",
    fill: "#201f1e"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75v-1h1v1z",
    fill: "#a19b9a"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M98 74v1h-1v-1z",
    fill: "#c5c1be",
    fillOpacity: 0.294
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M31 76h-1v-1h1z",
    fill: "#d2d2cf",
    fillOpacity: 0.361
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75h1v1h-1z",
    fill: "#abaaa9"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v1h-1v-1z",
    fill: "#b9b8b5"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M91 75h1v1h-1z",
    fill: "#908c88"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75h1v1h-1z",
    fill: "#aea9a8"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M97 76h-1v-1h1z",
    fill: "#b4aeaa",
    fillOpacity: 0.996
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M97 76v-1h1v1z",
    fill: "#cecbc7",
    fillOpacity: 0.271
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M30 76h1v1h-1z",
    fill: "#d6d3d3",
    fillOpacity: 0.322
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h1v1h-1z",
    fill: "#d9d8d7"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M90 76v1h-1v-1z",
    fill: "#a49e9c"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M93 77h-1v-1h1z",
    fill: "#b3aeaa"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M94 77v-1h1v1z",
    fill: "#938e8d"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M97 77h-1v-1h1z",
    fill: "#bbb5b1",
    fillOpacity: 0.988
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M98 77h-1v-1h1z",
    fill: "#cbc6c2",
    fillOpacity: 0.231
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78v-1h1v1z",
    fill: "#d5d5d1",
    fillOpacity: 0.286
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M52 77v1h-1v-1z",
    fill: "#a09e9a"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M52 78v-1h1v1z",
    fill: "#7d7b77"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M69 78v-1h1v1z",
    fill: "#1f1e1d"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78h-1v-1h1z",
    fill: "#e9e7e3"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M87 78v-1h1v1z",
    fill: "#b2b0ad"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M89 77v1h-1v-1z",
    fill: "#b7b5b2"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M90 78h-1v-1h1z",
    fill: "#beb7b5"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M95 77v1h-1v-1z",
    fill: "#a09b99"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M96 78v-1h1v1z",
    fill: "#b0aca8",
    fillOpacity: 0.965
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M97 77h1v1h-1z",
    fill: "#c9c9c4",
    fillOpacity: 0.188
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79h-1v-1h1z",
    fill: "#d6d6d6",
    fillOpacity: 0.275
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v1h-1v-1z",
    fill: "#d2d0ce"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78h1v1h-1z",
    fill: "#f5f2f1"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78h1v1h-1z",
    fill: "#e5e3e0"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79h-1v-1h1z",
    fill: "#d8d4d1"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M62 79v-1h1v1z",
    fill: "#656463"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M95 78v1h-1v-1z",
    fill: "#b0a9a7"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79h-1v-1h1z",
    fill: "#b1aeac",
    fillOpacity: 0.949
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79v-1h1v1z",
    fill: "#d8d8d8",
    fillOpacity: 0.157
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79v1h-1v-1z",
    fill: "#d8d8d8",
    fillOpacity: 0.259
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M31 80v-1h1v1z",
    fill: "#d3d1d0",
    fillOpacity: 0.992
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M32 79h1v1h-1z",
    fill: "#d1cdc9"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M43 79v1h-1v-1z",
    fill: "#ececea"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79v1h-1v-1z",
    fill: "#dedcdb"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79v1h-1v-1z",
    fill: "#afaeab"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79v1h-1v-1z",
    fill: "#b8b8b3"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80h-1v-1h1z",
    fill: "#dfdad8"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79v1h-1v-1z",
    fill: "#fbf4f2"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79h1v1h-1z",
    fill: "#fdf6f4"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79v1h-1v-1z",
    fill: "#f9f3f0"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M95 80h-1v-1h1z",
    fill: "#938d8a"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M96 80v-1h1v1z",
    fill: "#b7b6b4",
    fillOpacity: 0.937
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79h1v1h-1z",
    fill: "#c6c6c6",
    fillOpacity: 0.141
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80h1v1h-1z",
    fill: "#d6d6d6",
    fillOpacity: 0.247
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80v1h-1v-1z",
    fill: "#d2d1cf",
    fillOpacity: 0.988
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81v-1h1v1z",
    fill: "#efedec"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81v-1h1v1z",
    fill: "#aaa6a3"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81h-1v-1h1z",
    fill: "#95928f"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81h-1v-1h1z",
    fill: "#4f4e4b"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80v1h-1v-1z",
    fill: "#4a4948"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80h1v1h-1z",
    fill: "#555453"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v1h-1v-1z",
    fill: "#252421"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v1h-1v-1z",
    fill: "#c4c4bf"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M81 80v1h-1v-1z",
    fill: "#e2dfdc"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M94 80h1v1h-1z",
    fill: "#9d9694"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M97 80v1h-1v-1z",
    fill: "#adaba9",
    fillOpacity: 0.91
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M98 80v1h-1v-1z",
    fill: "#c8c8c8",
    fillOpacity: 0.11
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h-1v-1h1z",
    fill: "#d8d8d8",
    fillOpacity: 0.235
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M32 82h-1v-1h1z",
    fill: "#d0cecc",
    fillOpacity: 0.984
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82v-1h1v1z",
    fill: "#ebebe8"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82v-1h1v1z",
    fill: "#aaa9a4"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81v1h-1v-1z",
    fill: "#959491"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82v-1h1v1z",
    fill: "#6c6b6a"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M72 81v1h-1v-1z",
    fill: "#777675"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M74 82h-1v-1h1z",
    fill: "#9d9c99"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h-1v-1h1z",
    fill: "#c9c9c5"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M97 82h-1v-1h1z",
    fill: "#b3b1af",
    fillOpacity: 0.882
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M97 81h1v1h-1z",
    fill: "#ddd",
    fillOpacity: 0.09
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82v1h-1v-1z",
    fill: "#d6d6d6",
    fillOpacity: 0.22
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h1v1h-1z",
    fill: "#d3d2ce",
    fillOpacity: 0.976
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M41 83h-1v-1h1z",
    fill: "#faf9f6"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v1h-1v-1z",
    fill: "#f5f3f2"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M88 83h-1v-1h1z",
    fill: "#bdbeb9"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M94 82h1v1h-1z",
    fill: "#8d8784"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M97 83h-1v-1h1z",
    fill: "#bbb9b9",
    fillOpacity: 0.863
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M97 82h1v1h-1z",
    fill: "#d6d6d6",
    fillOpacity: 0.075
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83h1v1h-1z",
    fill: "#dcdcd7",
    fillOpacity: 0.2
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M32 83v1h-1v-1z",
    fill: "#d1d0cc",
    fillOpacity: 0.969
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h-1v-1h1z",
    fill: "#f2f1ee"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83v1h-1v-1z",
    fill: "#fbf9f9"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M44 84h-1v-1h1z",
    fill: "#fefdfa"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84v-1h1v1z",
    fill: "#75746f"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83v1h-1v-1z",
    fill: "#6d6c6a"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M87 83v1h-1v-1z",
    fill: "#a1a19d"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M87 84v-1h1v1z",
    fill: "#9b9c97"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M97 83v1h-1v-1z",
    fill: "#b0aeaf",
    fillOpacity: 0.82
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M98 84h-1v-1h1z",
    fill: "#e9e9e9",
    fillOpacity: 0.047
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85h-1v-1h1z",
    fill: "#d5d4cf",
    fillOpacity: 0.957
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h1v1h-1z",
    fill: "#e2e0e0"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84h1v1h-1z",
    fill: "#edece9"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M88 85h-1v-1h1z",
    fill: "#d3d4cf"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M90 85h-1v-1h1z",
    fill: "#b8b2b0"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M96 84h1v1h-1z",
    fill: "#b6b3b3",
    fillOpacity: 0.784
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M30 86v-1h1v1z",
    fill: "#dedede",
    fillOpacity: 0.153
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85v1h-1v-1z",
    fill: "#d6d4d1",
    fillOpacity: 0.941
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M37 86h-1v-1h1z",
    fill: "#dadad6"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M41 85h1v1h-1z",
    fill: "#f8f7f6"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M61 86h-1v-1h1z",
    fill: "#d8d7d5"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M94 85h1v1h-1z",
    fill: "#8c8582"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M97 86h-1v-1h1z",
    fill: "#bdbbbb",
    fillOpacity: 0.765
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M98 86h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.02
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M31 87v-1h1v1z",
    fill: "#d6d5d0",
    fillOpacity: 0.929
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M38 87h-1v-1h1z",
    fill: "#dfdddc"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M39 87h-1v-1h1z",
    fill: "#dfdddb"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v1h-1v-1z",
    fill: "#e3e0df"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M41 86v1h-1v-1z",
    fill: "#eceae9"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v-1h1v1z",
    fill: "#f6f4f3"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M60 87v-1h1v1z",
    fill: "#91908f"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M63 87v-1h1v1z",
    fill: "#8f8e8d"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87h-1v-1h1z",
    fill: "#93938e"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M88 86h1v1h-1z",
    fill: "#a09d9a"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87v-1h1v1z",
    fill: "#948e8a"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87v-1h1v1z",
    fill: "#b0aead",
    fillOpacity: 0.737
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M31 88h-1v-1h1z",
    fill: "#e5e5e5",
    fillOpacity: 0.118
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M32 88h-1v-1h1z",
    fill: "#d5d4cf",
    fillOpacity: 0.914
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M38 88v-1h1v1z",
    fill: "#f3f3f0"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M40 88h-1v-1h1z",
    fill: "#f1f1ee"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v1h-1v-1z",
    fill: "#e2e1e0"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88h-1v-1h1z",
    fill: "#44433f"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87v1h-1v-1z",
    fill: "#73726f"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87v1h-1v-1z",
    fill: "#c7c2bf"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87v1h-1v-1z",
    fill: "#9c9795"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87h1v1h-1z",
    fill: "#a8a7a5",
    fillOpacity: 0.694
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M30 89v-1h1v1z",
    fill: "#e3e3e3",
    fillOpacity: 0.11
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v-1h1v1z",
    fill: "#d5d4d0",
    fillOpacity: 0.902
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M32 89v-1h1v1z",
    fill: "#d6d2cd"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v-1h1v1z",
    fill: "#dbdcd7"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v-1h1v1z",
    fill: "#dedcd9"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89v-1h1v1z",
    fill: "#87807d"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M95 88h1v1h-1z",
    fill: "#908c89"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M97 88v1h-1v-1z",
    fill: "#a7a5a5",
    fillOpacity: 0.663
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v1h-1v-1z",
    fill: "#eaeaea",
    fillOpacity: 0.098
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89h1v1h-1z",
    fill: "#d5d4d1",
    fillOpacity: 0.894
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M40 89v1h-1v-1z",
    fill: "#e3dfdb"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h1v1h-1z",
    fill: "#f0eeed"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h-1v-1h1z",
    fill: "#fefdf9"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M91 89v1h-1v-1z",
    fill: "#a49e9b"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M93 89v1h-1v-1z",
    fill: "#87827f"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89h1v1h-1z",
    fill: "#77706d"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M96 90v-1h1v1z",
    fill: "#a7a5a4",
    fillOpacity: 0.627
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M30 91v-1h1v1z",
    fill: "#e7f3f3",
    fillOpacity: 0.086
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M31 90h1v1h-1z",
    fill: "#d6d5d1",
    fillOpacity: 0.882
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M37 90v1h-1v-1z",
    fill: "#dddcd7"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90h1v1h-1z",
    fill: "#f0ecea"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90v1h-1v-1z",
    fill: "#a8a6a2"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91h-1v-1h1z",
    fill: "#bdbbb7"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M90 91v-1h1v1z",
    fill: "#857f7c"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M92 91h-1v-1h1z",
    fill: "#77706e"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M92 90h1v1h-1z",
    fill: "#6e6865"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M93 90h1v1h-1z",
    fill: "#6c6563"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M95 90v1h-1v-1z",
    fill: "#6e6765"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M96 90h1v1h-1z",
    fill: "#a5a1a1",
    fillOpacity: 0.6
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M30 91h1v1h-1z",
    fill: "#e5e5e5",
    fillOpacity: 0.078
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M31 92v-1h1v1z",
    fill: "#d6d5d3",
    fillOpacity: 0.871
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M40 91h1v1h-1z",
    fill: "#fcf9f6"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92v-1h1v1z",
    fill: "#fefcfa"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v1h-1v-1z",
    fill: "#fcfaf9"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h-1v-1h1z",
    fill: "#a3a2a1"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M82 91v1h-1v-1z",
    fill: "#e1dfdc"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M82 92v-1h1v1z",
    fill: "#edebe7"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M83 91h1v1h-1z",
    fill: "#f4f4f0"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M92 92v-1h1v1z",
    fill: "#645f5c"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M94 91v1h-1v-1z",
    fill: "#635e5b"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M94 92v-1h1v1z",
    fill: "#66605e"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M95 91h1v1h-1z",
    fill: "#7c7775"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M96 92v-1h1v1z",
    fill: "#a09d9d",
    fillOpacity: 0.573
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h-1v-1h1z",
    fill: "#d8d5d3",
    fillOpacity: 0.847
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M37 92h1v1h-1z",
    fill: "#e5e2de"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M40 92v1h-1v-1z",
    fill: "#e6e3df"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M40 93v-1h1v1z",
    fill: "#e8e4e1"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h-1v-1h1z",
    fill: "#f7f2f0"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92v1h-1v-1z",
    fill: "#e5e5e1"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M89 92h1v1h-1z",
    fill: "#84817e"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M91 93v-1h1v1z",
    fill: "#65625e"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M93 93h-1v-1h1z",
    fill: "#5b5855"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M93 92h1v1h-1z",
    fill: "#595652"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M96 92v1h-1v-1z",
    fill: "#75726f"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93h-1v-1h1z",
    fill: "#9b9999",
    fillOpacity: 0.553
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M31 94h-1v-1h1z",
    fill: "#ececec",
    fillOpacity: 0.055
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93v1h-1v-1z",
    fill: "#d8d6d4",
    fillOpacity: 0.831
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M38 94h-1v-1h1z",
    fill: "#e8e8e4"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h1v1h-1z",
    fill: "#e8e3df"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h-1v-1h1z",
    fill: "#eae3e1"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M65 94v-1h1v1z",
    fill: "#6a6966"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94h-1v-1h1z",
    fill: "#646362"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94v-1h1v1z",
    fill: "#b6b4b0"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M93 94h-1v-1h1z",
    fill: "#52524d"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93v1h-1v-1z",
    fill: "#969696",
    fillOpacity: 0.533
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M31 94v1h-1v-1z",
    fill: "#ebebeb",
    fillOpacity: 0.051
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95v-1h1v1z",
    fill: "#d9d7d4",
    fillOpacity: 0.827
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M40 95v-1h1v1z",
    fill: "#faf8f4"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94h1v1h-1z",
    fill: "#faf4f1"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v-1h1v1z",
    fill: "#e6e0dd"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h1v1h-1z",
    fill: "#e3dcda"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M63 94v1h-1v-1z",
    fill: "#5a5a56"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M66 94v1h-1v-1z",
    fill: "#555451"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M96 95v-1h1v1z",
    fill: "#90908e",
    fillOpacity: 0.518
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95h1v1h-1z",
    fill: "#d9d7d3",
    fillOpacity: 0.831
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M47 95v1h-1v-1z",
    fill: "#ede7e4"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M85 95v1h-1v-1z",
    fill: "#cfcdc9"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M86 95h1v1h-1z",
    fill: "#bcb8b5"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M89 95h1v1h-1z",
    fill: "#6d6b67"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95h1v1h-1z",
    fill: "#464540"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M96 95h1v1h-1z",
    fill: "#898787",
    fillOpacity: 0.502
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M31 96v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.035
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97v-1h1v1z",
    fill: "#d8d7d4",
    fillOpacity: 0.816
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M88 96h1v1h-1z",
    fill: "#7e7a77"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M89 97v-1h1v1z",
    fill: "#696764"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M96 97v-1h1v1z",
    fill: "#7f7f7d",
    fillOpacity: 0.478
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97h1v1h-1z",
    fill: "#d9d7d3",
    fillOpacity: 0.808
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M62 97v1h-1v-1z",
    fill: "#c1bab8"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M97 97v1h-1v-1z",
    fill: "#7b7b78",
    fillOpacity: 0.447
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M31 98h1v1h-1z",
    fill: "#dad8d5",
    fillOpacity: 0.816
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M46 99v-1h1v1z",
    fill: "#f1ebe9"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v-1h1v1z",
    fill: "#c2bbb9"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99v-1h1v1z",
    fill: "#c0b9b6"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M86 98h1v1h-1z",
    fill: "#afaba7"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M88 99v-1h1v1z",
    fill: "#76716f"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98v1h-1v-1z",
    fill: "#615f5d"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M93 98h1v1h-1z",
    fill: "#3a3935"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M97 99h-1v-1h1z",
    fill: "#6f6f6d",
    fillOpacity: 0.412
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M32 100h-1v-1h1z",
    fill: "#dbd8d6",
    fillOpacity: 0.816
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99h1v1h-1z",
    fill: "#d4d2cf"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h1v1h-1z",
    fill: "#d8d8d5"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M47 100h-1v-1h1z",
    fill: "#f0eae8"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99h1v1h-1z",
    fill: "#bcb9b6"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M84 99v1h-1v-1z",
    fill: "#cdcdc9"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M84 99h1v1h-1z",
    fill: "#c1bebb"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M85 99h1v1h-1z",
    fill: "#b9b5b1"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M93 100v-1h1v1z",
    fill: "#373632"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M97 100h-1v-1h1z",
    fill: "#696967",
    fillOpacity: 0.388
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M31 100h1v1h-1z",
    fill: "#dcdad6",
    fillOpacity: 0.82
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M86 100h1v1h-1z",
    fill: "#a3a09c"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M88 100h1v1h-1z",
    fill: "#6d6967"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M97 100v1h-1v-1z",
    fill: "#61615e",
    fillOpacity: 0.369
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M31 102v-1h1v1z",
    fill: "#dcdad7",
    fillOpacity: 0.831
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102v-1h1v1z",
    fill: "#f0eae7"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101v1h-1v-1z",
    fill: "#bcbab7"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h-1v-1h1z",
    fill: "#babab5"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M87 102h-1v-1h1z",
    fill: "#9d9a95"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M89 101v1h-1v-1z",
    fill: "#686462"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M92 101v1h-1v-1z",
    fill: "#3f3d3c"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M92 102v-1h1v1z",
    fill: "#373534"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M97 102h-1v-1h1z",
    fill: "#625f5f",
    fillOpacity: 0.357
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M32 102v1h-1v-1z",
    fill: "#dddbd7",
    fillOpacity: 0.855
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v-1h1v1z",
    fill: "#d0cdca"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103h-1v-1h1z",
    fill: "#c2c2bd"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M87 103h-1v-1h1z",
    fill: "#989490"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M88 103v-1h1v1z",
    fill: "#65605f"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M90 102h1v1h-1z",
    fill: "#464544"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102v1h-1v-1z",
    fill: "#353332"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M97 103h-1v-1h1z",
    fill: "#5f5f5c",
    fillOpacity: 0.345
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M30 103h1v1h-1z",
    fill: "#ddddd6",
    fillOpacity: 0.149
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M32 103v1h-1v-1z",
    fill: "#dddcd8",
    fillOpacity: 0.933
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M89 103v1h-1v-1z",
    fill: "#605b5a"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M91 104h-1v-1h1z",
    fill: "#434340"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M97 103v1h-1v-1z",
    fill: "#60605d",
    fillOpacity: 0.333
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M31 104v1h-1v-1z",
    fill: "#aaa",
    fillOpacity: 0.365
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M32 105v-1h1v1z",
    fill: "#d5d4cf"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M65 105h-1v-1h1z",
    fill: "#c7c3c0"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104v1h-1v-1z",
    fill: "#b5aeac"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M89 104v1h-1v-1z",
    fill: "#5d5857"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M97 105h-1v-1h1z",
    fill: "#525250",
    fillOpacity: 0.4
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M31 106h-1v-1h1z",
    fill: "#939390",
    fillOpacity: 0.435
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M52 105v1h-1v-1z",
    fill: "#d8d3d0"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105h1v1h-1z",
    fill: "#c6c0bd"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M78 105h1v1h-1z",
    fill: "#c1c2bd"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M81 106h-1v-1h1z",
    fill: "#cac7c3"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M82 106h-1v-1h1z",
    fill: "#c9c4c2"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M88 106v-1h1v1z",
    fill: "#5c5756"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M97 105v1h-1v-1z",
    fill: "#2d2b2b",
    fillOpacity: 0.533
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M30 106h1v1h-1z",
    fill: "#a9a6a6",
    fillOpacity: 0.349
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M48 106v1h-1v-1z",
    fill: "#e1dedb"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M51 107v-1h1v1z",
    fill: "#d7d3d0"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h1v1h-1z",
    fill: "#d4ccca"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v1h-1v-1z",
    fill: "#c5c5c1"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M87 107v-1h1v1z",
    fill: "#736e6c"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M89 106v1h-1v-1z",
    fill: "#585453"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M90 106v1h-1v-1z",
    fill: "#4a4746"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M97 106v1h-1v-1z",
    fill: "#171515",
    fillOpacity: 0.565
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M31 107v1h-1v-1z",
    fill: "#dcdcdc",
    fillOpacity: 0.2
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M31 107h1v1h-1z",
    fill: "#9a9896",
    fillOpacity: 0.969
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M33 108h-1v-1h1z",
    fill: "#cfcbc7"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v1h-1v-1z",
    fill: "#d4cdca"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M69 108v-1h1v1z",
    fill: "#c0bdb9"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107h1v1h-1z",
    fill: "#bcbcb8"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108v-1h1v1z",
    fill: "#979491"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M86 107h1v1h-1z",
    fill: "#85817e"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M89 108h-1v-1h1z",
    fill: "#54504f"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M90 108h-1v-1h1z",
    fill: "#474342"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M90 108v-1h1v1z",
    fill: "#3a3837"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M96 107h1v1h-1z",
    fill: "#181816",
    fillOpacity: 0.49
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M31 109v-1h1v1z",
    fill: "#aeacab",
    fillOpacity: 0.812
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M32 108h1v1h-1z",
    fill: "#9c9894"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M33 108h1v1h-1z",
    fill: "#dcd8d6"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109v-1h1v1z",
    fill: "#b8b5b2"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M81 108h1v1h-1z",
    fill: "#beb8b6"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108h1v1h-1z",
    fill: "#918f8b"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M95 109v-1h1v1z",
    fill: "#0c0b0a",
    fillOpacity: 0.988
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M96 108h1v1h-1z",
    fill: "#242424",
    fillOpacity: 0.275
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M32 109v1h-1v-1z",
    fill: "#dad8d5",
    fillOpacity: 0.463
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M33 110v-1h1v1z",
    fill: "#a4a09c"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110h-1v-1h1z",
    fill: "#d5cecc"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h1v1h-1z",
    fill: "#cfccc8"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M85 110h-1v-1h1z",
    fill: "#958f8d"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M95 110v-1h1v1z",
    fill: "#10100d",
    fillOpacity: 0.749
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M97 110h-1v-1h1z",
    fill: "#4c3333",
    fillOpacity: 0.039
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M32 111h-1v-1h1z",
    fill: "#f2f2f2",
    fillOpacity: 0.078
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M33 110v1h-1v-1z",
    fill: "#d3d0ce",
    fillOpacity: 0.776
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M34 111h-1v-1h1z",
    fill: "#a3a09e"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M34 110h1v1h-1z",
    fill: "#a9a7a4"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M45 110v1h-1v-1z",
    fill: "#efedea"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M47 111h-1v-1h1z",
    fill: "#e6e3e0"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M56 111h-1v-1h1z",
    fill: "#d0cdc9"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111h-1v-1h1z",
    fill: "#ccc9c5"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M69 111h-1v-1h1z",
    fill: "#c3c3bf"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111h-1v-1h1z",
    fill: "#b2afac"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111v-1h1v1z",
    fill: "#afada9"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M76 111h-1v-1h1z",
    fill: "#adaaa7"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M83 110h1v1h-1z",
    fill: "#9e9795"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M85 110v1h-1v-1z",
    fill: "#8f8987"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M86 111h-1v-1h1z",
    fill: "#898683"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M86 110h1v1h-1z",
    fill: "#777774"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M88 110v1h-1v-1z",
    fill: "#5e5d5a"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M90 110v1h-1v-1z",
    fill: "#3b3b39"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M93 111h-1v-1h1z",
    fill: "#121110"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M94 110h1v1h-1z",
    fill: "#171615",
    fillOpacity: 0.945
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M96 111h-1v-1h1z",
    fill: "#181814",
    fillOpacity: 0.243
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M34 111v1h-1v-1z",
    fill: "#d0cecc",
    fillOpacity: 0.875
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M44 111v1h-1v-1z",
    fill: "#f1eeeb"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M48 111h1v1h-1z",
    fill: "#dcdad7"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M71 112h-1v-1h1z",
    fill: "#c1beba"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111h1v1h-1z",
    fill: "#b1aba8"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M83 112h-1v-1h1z",
    fill: "#a29d99"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M84 111v1h-1v-1z",
    fill: "#96908d"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112v-1h1v1z",
    fill: "#8d8786"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M85 111h1v1h-1z",
    fill: "#848180"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M93 111v1h-1v-1z",
    fill: "#0d0d0c"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M94 111v1h-1v-1z",
    fill: "#161616",
    fillOpacity: 0.976
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M95 112h-1v-1h1z",
    fill: "#0f1111",
    fillOpacity: 0.392
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M34 113h-1v-1h1z",
    fill: "#ddddd8",
    fillOpacity: 0.235
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M35 112v1h-1v-1z",
    fill: "#d2d1cf",
    fillOpacity: 0.859
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M54 112v1h-1v-1z",
    fill: "#d1d1cd"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113v-1h1v1z",
    fill: "#d0cecb"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M83 112v1h-1v-1z",
    fill: "#9a9692"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M83 113v-1h1v1z",
    fill: "#918b88"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112h1v1h-1z",
    fill: "#8e8887"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M85 113v-1h1v1z",
    fill: "#817e7d"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M93 113h-1v-1h1z",
    fill: "#1a1a18",
    fillOpacity: 0.965
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M93 112h1v1h-1z",
    fill: "#0e0e0e",
    fillOpacity: 0.416
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M34 114v-1h1v1z",
    fill: "#d4cece",
    fillOpacity: 0.165
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M35 113h1v1h-1z",
    fill: "#cccbc9",
    fillOpacity: 0.733
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h1v1h-1z",
    fill: "#d1d1cc"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114v-1h1v1z",
    fill: "#e3dedb"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113v1h-1v-1z",
    fill: "#d2d2cd"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113h1v1h-1z",
    fill: "#d1cfcc"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M60 114v-1h1v1z",
    fill: "#cacac6"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M73 114h-1v-1h1z",
    fill: "#b4aeac"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M78 114v-1h1v1z",
    fill: "#9c9693"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M83 114h-1v-1h1z",
    fill: "#928e8a"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M85 114h-1v-1h1z",
    fill: "#7d7776"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M85 113h1v1h-1z",
    fill: "#5f5c5b"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M87 113v1h-1v-1z",
    fill: "#3e3e3c"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M92 113v1h-1v-1z",
    fill: "#1d1d1b",
    fillOpacity: 0.875
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M92 114v-1h1v1z",
    fill: "#12120f",
    fillOpacity: 0.322
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M37 114v1h-1v-1z",
    fill: "#cfcfcd",
    fillOpacity: 0.463
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115h-1v-1h1z",
    fill: "#ccccc7",
    fillOpacity: 0.89
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M41 114h1v1h-1z",
    fill: "#d4d4d0"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114v1h-1v-1z",
    fill: "#dedbd7"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M45 115v-1h1v1z",
    fill: "#e4e1de"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M47 115v-1h1v1z",
    fill: "#e4e1dd"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M53 114h1v1h-1z",
    fill: "#d3d3cf"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M73 114v1h-1v-1z",
    fill: "#afaaa8"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114v1h-1v-1z",
    fill: "#a7a39f"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114h1v1h-1z",
    fill: "#9b9795"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M79 114h1v1h-1z",
    fill: "#928e8c"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M80 114h1v1h-1z",
    fill: "#8c8885"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M81 115v-1h1v1z",
    fill: "#807c79"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M83 115h-1v-1h1z",
    fill: "#6c6866"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M84 114v1h-1v-1z",
    fill: "#544f4d"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M85 115h-1v-1h1z",
    fill: "#433f3d"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M86 114v1h-1v-1z",
    fill: "#4a4847"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M89 115h-1v-1h1z",
    fill: "#595857"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M90 115h-1v-1h1z",
    fill: "#2f2e2c",
    fillOpacity: 0.965
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M91 114v1h-1v-1z",
    fill: "#1a1a18",
    fillOpacity: 0.612
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M92 114v1h-1v-1z",
    fill: "#161616",
    fillOpacity: 0.133
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115v1h-1v-1z",
    fill: "#d5d5ce",
    fillOpacity: 0.145
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M38 116v-1h1v1z",
    fill: "#cdcdc9",
    fillOpacity: 0.545
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M39 115h1v1h-1z",
    fill: "#c9c8c3",
    fillOpacity: 0.91
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M41 116v-1h1v1z",
    fill: "#d8d6d5"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M44 116h-1v-1h1z",
    fill: "#dadad7"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M57 115h1v1h-1z",
    fill: "#d3d3ce"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M88 115v1h-1v-1z",
    fill: "#333231",
    fillOpacity: 0.973
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M88 115h1v1h-1z",
    fill: "#212121",
    fillOpacity: 0.686
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M90 115v1h-1v-1z",
    fill: "#1f1f1f",
    fillOpacity: 0.251
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M39 116h1v1h-1z",
    fill: "#cecec7",
    fillOpacity: 0.145
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M41 116v1h-1v-1z",
    fill: "#cdcdcc",
    fillOpacity: 0.51
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M42 117h-1v-1h1z",
    fill: "#cdcccb",
    fillOpacity: 0.831
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M85 116h1v1h-1z",
    fill: "#282725",
    fillOpacity: 0.882
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M86 117v-1h1v1z",
    fill: "#1e1e1c",
    fillOpacity: 0.592
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M87 117v-1h1v1z",
    fill: "#1d1d1d",
    fillOpacity: 0.235
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M41 117h1v1h-1z",
    fill: "#d4d4c6",
    fillOpacity: 0.071
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M43 118h-1v-1h1z",
    fill: "#cdcdcd",
    fillOpacity: 0.322
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M43 117h1v1h-1z",
    fill: "#cfcfcc",
    fillOpacity: 0.631
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M45 117v1h-1v-1z",
    fill: "#c9c9c5",
    fillOpacity: 0.886
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M55 117h1v1h-1z",
    fill: "#aaaaa6"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M57 117h1v1h-1z",
    fill: "#a8a8a4"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M59 118h-1v-1h1z",
    fill: "#a4a29f"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M61 118v-1h1v1z",
    fill: "#96928f"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M63 117h1v1h-1z",
    fill: "#868380"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M82 117h1v1h-1z",
    fill: "#1d1c1a",
    fillOpacity: 0.878
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M84 118h-1v-1h1z",
    fill: "#1a1a17",
    fillOpacity: 0.643
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M85 117v1h-1v-1z",
    fill: "#201e1e",
    fillOpacity: 0.365
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M85 118v-1h1v1z",
    fill: "#242424",
    fillOpacity: 0.11
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M45 119h-1v-1h1z",
    fill: "#cfcfcf",
    fillOpacity: 0.106
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M45 118h1v1h-1z",
    fill: "#cdcdca",
    fillOpacity: 0.322
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M47 118v1h-1v-1z",
    fill: "#d2d0cc",
    fillOpacity: 0.557
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M47 118h1v1h-1z",
    fill: "#d2d0cd",
    fillOpacity: 0.761
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M49 119h-1v-1h1z",
    fill: "#cdccc7",
    fillOpacity: 0.906
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M50 119h-1v-1h1z",
    fill: "#c3c3be",
    fillOpacity: 0.988
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M52 119h-1v-1h1z",
    fill: "#9b9a95"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M53 119h-1v-1h1z",
    fill: "#5b5a55"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M54 118v1h-1v-1z",
    fill: "#595853"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M54 119v-1h1v1z",
    fill: "#72716c"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M56 119v-1h1v1z",
    fill: "#65645f"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M58 118v1h-1v-1z",
    fill: "#62625d"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M60 118v1h-1v-1z",
    fill: "#66635f"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M60 118h1v1h-1z",
    fill: "#65615d"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M62 119h-1v-1h1z",
    fill: "#625e5b"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M63 118v1h-1v-1z",
    fill: "#5e5b58"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M63 119v-1h1v1z",
    fill: "#5f5d59"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M72 118v1h-1v-1z",
    fill: "#4d4d49"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M72 119v-1h1v1z",
    fill: "#42423e"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M74 119h-1v-1h1z",
    fill: "#33332f"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M75 118v1h-1v-1z",
    fill: "#2b2b29"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M77 119v-1h1v1z",
    fill: "#161514",
    fillOpacity: 0.98
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M78 119v-1h1v1z",
    fill: "#141310",
    fillOpacity: 0.886
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M80 118v1h-1v-1z",
    fill: "#11100e",
    fillOpacity: 0.737
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M81 119h-1v-1h1z",
    fill: "#141211",
    fillOpacity: 0.529
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M82 119h-1v-1h1z",
    fill: "#181814",
    fillOpacity: 0.29
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M82 119v-1h1v1z",
    fill: "#1f1f1f",
    fillOpacity: 0.094
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M47 120v-1h1v1z",
    fill: "#ccc",
    fillOpacity: 0.02
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M49 119v1h-1v-1z",
    fill: "#cdcdc5",
    fillOpacity: 0.122
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M50 119v1h-1v-1z",
    fill: "#c5c9c1",
    fillOpacity: 0.278
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M50 120v-1h1v1z",
    fill: "#c6c6c2",
    fillOpacity: 0.443
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M52 120h-1v-1h1z",
    fill: "#c2c0bd",
    fillOpacity: 0.596
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M52 119h1v1h-1z",
    fill: "#aba8a4",
    fillOpacity: 0.729
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M53 119h1v1h-1z",
    fill: "#a09c99",
    fillOpacity: 0.843
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M54 119h1v1h-1z",
    fill: "#a4a19e",
    fillOpacity: 0.918
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M55 119h1v1h-1z",
    fill: "#a19e9b",
    fillOpacity: 0.969
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M56 119h1v1h-1z",
    fill: "#959490",
    fillOpacity: 0.996
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M67 120v-1h1v1z",
    fill: "#43423d"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M68 119h1v1h-1z",
    fill: "#393833"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M70 119v1h-1v-1z",
    fill: "#2d2d29",
    fillOpacity: 0.988
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M70 120v-1h1v1z",
    fill: "#252523",
    fillOpacity: 0.969
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M71 120v-1h1v1z",
    fill: "#2f2f2d",
    fillOpacity: 0.933
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M73 119v1h-1v-1z",
    fill: "#242422",
    fillOpacity: 0.882
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M74 119v1h-1v-1z",
    fill: "#1e1e1d",
    fillOpacity: 0.792
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M74 119h1v1h-1z",
    fill: "#212121",
    fillOpacity: 0.694
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M76 120h-1v-1h1z",
    fill: "#242424",
    fillOpacity: 0.553
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M77 120h-1v-1h1z",
    fill: "#212121",
    fillOpacity: 0.384
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M78 119v1h-1v-1z",
    fill: "#222",
    fillOpacity: 0.235
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M79 119v1h-1v-1z",
    fill: "#282828",
    fillOpacity: 0.098
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M79 119h1v1h-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.008
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M54 121h-1v-1h1z",
    fill: "#c6c6b8",
    fillOpacity: 0.071
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M54 121v-1h1v1z",
    fill: "#bdb6b6",
    fillOpacity: 0.137
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M56 121h-1v-1h1z",
    fill: "#b9b4b4",
    fillOpacity: 0.216
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M56 121v-1h1v1z",
    fill: "#bcbcb9",
    fillOpacity: 0.286
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M57 120h1v1h-1z",
    fill: "#c5c5c2",
    fillOpacity: 0.329
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M59 120v1h-1v-1z",
    fill: "#c3c1c1",
    fillOpacity: 0.388
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M59 121v-1h1v1z",
    fill: "#bfbdbd",
    fillOpacity: 0.455
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M61 120v1h-1v-1z",
    fill: "#bab8b6",
    fillOpacity: 0.482
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M62 121h-1v-1h1z",
    fill: "#b2b0b0",
    fillOpacity: 0.486
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M62 121v-1h1v1z",
    fill: "#aba9a9",
    fillOpacity: 0.502
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M64 121h-1v-1h1z",
    fill: "#9c9a9a",
    fillOpacity: 0.506
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M65 121h-1v-1h1z",
    fill: "#8e8c8c",
    fillOpacity: 0.498
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M65 121v-1h1v1z",
    fill: "#7e7c7a",
    fillOpacity: 0.475
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M66 121v-1h1v1z",
    fill: "#767673",
    fillOpacity: 0.431
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M68 121h-1v-1h1z",
    fill: "#767371",
    fillOpacity: 0.38
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M68 121v-1h1v1z",
    fill: "#747470",
    fillOpacity: 0.31
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M70 121h-1v-1h1z",
    fill: "#63635f",
    fillOpacity: 0.251
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M71 120v1h-1v-1z",
    fill: "#535353",
    fillOpacity: 0.204
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M72 121h-1v-1h1z",
    fill: "#4b4b4b",
    fillOpacity: 0.145
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M72 120h1v1h-1z",
    fill: "#4a4a3f",
    fillOpacity: 0.094
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M74 121h-1v-1h1z",
    fill: "#666",
    fillOpacity: 0.039
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinCan);
export default __webpack_public_path__ + "static/media/tin-can.adfb4022be959289d27c2ea87fab9246.svg";
export { ForwardRef as ReactComponent };